export const fi = {
  translation: {
    nav: {
      dashboard: 'Työpöytä',
      announcements: 'Ilmoitukset',
      companies: 'Yritykseni',
      properties: 'Kohteet',
      documentBank: 'Dokumenttipankki',
      keys: 'Avaimet',
      maintenance: 'Kunnossapito',
      serviceRequests: 'Palvelupyynnöt',
      messages: 'Viestit',
      rentalBrokerage: 'Vuokraus',
      rentalAndFinance: 'Vuokraus',
      controlPanel: 'Hallinta',
      reports: 'Analytiikka',
      billing: 'Laskutus',
    },
    access: {
      noPermission: 'Ei käyttöoikeutta',
      maintenance: 'Sinulla ei ole oikeutta tarkastella kunnossapitoa.',
      serviceRequests: 'Sinulla ei ole oikeutta tarkastella palvelupyyntöjä.',
      messages: 'Sinulla ei ole oikeutta tarkastella viestejä.',
      residents: 'Sinulla ei ole oikeutta tarkastella asukkaita.',
      reports: 'Sinulla ei ole oikeutta tarkastella analytiikkaa.',
      billing: 'Sinulla ei ole oikeutta tarkastella laskutusta.',
      properties: 'Sinulla ei ole oikeutta tarkastella kohteita.',
      announcements: 'Sinulla ei ole oikeutta tarkastella ilmoituksia.',
      apartments: 'Sinulla ei ole oikeutta tarkastella tätä asuntoa.',
      condominium: 'Sinulla ei ole oikeutta tarkastella tätä kiinteistöä.',
      landlords: 'Sinulla ei ole oikeutta tarkastella tätä vuokranantajaa.',
      users: 'Sinulla ei ole oikeutta tarkastella tätä käyttäjää.',
      billingAccounts: 'Sinulla ei ole oikeutta tarkastella tätä laskutustiliä.',
      serviceProviders: 'Sinulla ei ole oikeutta tarkastella tätä palveluntarjoajaa.',
      companies: 'Sinulla ei ole oikeutta tarkastella tätä yritystä.',
      keys: 'Sinulla ei ole oikeutta tarkastella tätä avainta.',
      trackedAssets: 'Sinulla ei ole oikeutta tarkastella Laitteita.',
      rentalBrokerage: 'Sinulla ei ole oikeutta tarkastella vuokrausta.',
    },
    documentBank: {
      title: 'Dokumenttipankki',
      searchPlaceholder: 'Hae tiedostoa, taloyhtiötä, asuntoa tai asiakkuutta…',
      noAccess: 'Sinulla ei ole oikeutta nähdä dokumentteja tässä näkymässä.',
      empty: 'Ei tuloksia.',
      sections: {
        general: 'Yleiset tiedostot',
        condominiums: 'Taloyhtiöt',
        billingAccounts: 'Asiakkuudet',
      },
      generalRoot: 'Juuri',
      createFolderPlaceholder: 'esim. Sopimukset',
      createFolder: 'Luo kansio',
      createSubfolder: 'Luo alikansio',
      createSubfolderModalTitle: 'Luo uusi alikansio',
      createSubfolderParentPath: 'Kohdekansio: {{path}}',
      createSubfolderNameLabel: 'Kansion nimi',
      moveFile: 'Siirrä tiedosto',
      moveFileTitle: 'Siirrä tiedosto: {{name}}',
      moveFileDescription: 'Valitse kansio, johon tiedosto siirretään.',
      moveFileCurrentFolder: 'Nykyinen kansio: {{path}}',
      moveFileTargetFolderLabel: 'Kohdekansio',
      moveFileTargetFolderPlaceholder: 'Valitse kohdekansio',
      moveFileConfirm: 'Siirrä tiedosto',
      deleteFolder: 'Poista kansio',
      deleteFolderTitle: 'Poistetaanko kansio?',
      deleteFolderMessage:
        'Kansio "{{name}}" poistetaan, mukaan lukien kaikki sen alikansiot ja kunkin tason tiedostot.',
      showAllEntities: 'Näytä myös tyhjät',
      browseTruncated: 'Tuloksia on paljon. Tarkenna hakua, jotta näet loput.',
      renameFile: 'Nimeä tiedosto uudelleen',
      renameFolder: 'Nimeä kansio uudelleen',
      renameFileTitle: 'Nimeä tiedosto uudelleen: {{name}}',
      renameFolderTitle: 'Nimeä kansio uudelleen: {{name}}',
      renameNameLabel: 'Uusi nimi',
      renameConfirm: 'Tallenna nimi',
      renameSuccess: 'Nimi päivitetty',
      previewTitle: '{{name}}',
      previewLoading: 'Avataan esikatselua…',
      previewUnavailable: 'Tälle tiedostotyypille ei ole esikatselua. Voit ladata tiedoston.',
    },
    errors: {
      generic: 'Jokin meni vikaan. Yritä uudelleen.',
      boundaryTitle: 'Oops! Jotain meni pieleen',
      boundaryDescription:
        'Sovelluksessa tapahtui odottamaton virhe. Voit yrittää päivittää sivun tai palata etusivulle.',
      retry: 'Yritä uudelleen',
      goHome: 'Etusivulle',
      copyDetails: 'Kopioi virhetiedot tukea varten',
      copied: 'Kopioitu!',
      devDetailsTitle: 'Virhetiedot (kehitysympäristö)',
      stackTrace: 'Stack Trace',
      contactSupport: 'Jos ongelma jatkuu, ota yhteyttä tukeen.',
      networkError: 'Verkkovirhe',
      networkErrorMessage: 'Tarkista internetyhteys ja yritä uudelleen.',
      timeoutError: 'Pyyntö aikakatkaistiin',
      timeoutErrorMessage: 'Palvelin ei vastannut ajoissa. Yritä uudelleen.',
      serverError: 'Palvelinvirhe',
      serverErrorMessage: 'Palvelimessa tapahtui virhe. Yritä hetken kuluttua uudelleen.',
      unauthorized: 'Kirjautuminen vaaditaan',
      unauthorizedMessage: 'Istunto on vanhentunut. Kirjaudu sisään uudelleen.',
      forbidden: 'Ei käyttöoikeutta',
      forbiddenMessage: 'Sinulla ei ole oikeuksia suorittaa tätä toimintoa.',
      notFound: 'Tietoja ei löytynyt',
      notFoundMessage: 'Pyytämäsi tiedot eivät ole saatavilla tai ne on poistettu.',
      pageNotFound: 'Sivua ei löytynyt',
      pageNotFoundMessage: 'Tätä sivua ei ole olemassa tai osoite on virheellinen.',
      validationError: 'Tarkista tiedot',
      validationErrorMessage: 'Lomakkeessa on virheitä. Korjaa ne ja yritä uudelleen.',
      conflictError: 'Ristiriita tiedoissa',
      conflictErrorMessage: 'Tiedot on päivitetty toisen käyttäjän toimesta. Päivitä sivu.',
      duplicateError: 'Tieto on jo olemassa',
      duplicateErrorMessage: 'Vastaava tieto on jo järjestelmässä.',
      constraintError: 'Toiminto ei ole mahdollinen',
      constraintErrorMessage: 'Toimintoa ei voida suorittaa nykyisellä tietojen tilalla.',
      fileTooLarge: 'Tiedosto liian suuri',
      fileTooLargeMessage: 'Valittu tiedosto on liian suuri. Maksimikoko on 10 MB.',
      fileTypeError: 'Väärä tiedostotyyppi',
      fileTypeErrorMessage: 'Valittu tiedostotyyppi ei ole tuettu.',
      uploadError: 'Tiedoston lataus epäonnistui',
      uploadErrorMessage: 'Tiedoston lataus palvelimelle epäonnistui.',
      unknownError: 'Odottamaton virhe',
      unknownErrorMessage: 'Tapahtui odottamaton virhe. Yritä uudelleen tai ota yhteyttä tukeen.',
      unexpectedError: 'Odottamaton virhe',
      unexpectedErrorMessage: 'Tapahtui tuntematon virhe.',
      featureUnavailable: 'Toiminto ei käytettävissä',
      featureUnavailableMessage: 'Tämä toiminto ei ole tällä hetkellä käytettävissä.',
      tryAgain: 'Yritä uudelleen',
      login: 'Kirjaudu sisään',
      goBack: 'Takaisin',
      fix: 'Korjaa',
      refreshPage: 'Päivitä sivu',
      selectOtherFile: 'Valitse toinen tiedosto',
      technicalDetails: 'Tekniset tiedot (kehitysympäristö)',
      time: 'Aika',
      eventName: 'Tapahtuma',
      holder: 'Haltija',
      dueDate: 'Eräpäivä',
      performer: 'Tekijä',
      view: 'Tarkastele',
      borrowedSince: 'Lainassa alkaen',
      returnDate: 'Palautuspäivä',
      markAsLost: 'Merkitse avain kadonneeksi',
      markAsLostConfirm: 'Merkitse kadonneeksi',
      deleteKey: 'Poista avain',
      deleteAnnouncement: 'Poista ilmoitus',
      deleteAnnouncementConfirm: 'Haluatko varmasti poistaa ilmoituksen "{{title}}"?',
    },
    navigation: {
      home: 'Etusivu',
      back: 'Taakse',
    },
    actions: {
      confirmDeleteEntity: 'Haluatko varmasti poistaa kohteen {{entity}}?',
      unlink: 'Poista linkitys',
      copy: 'Kopioi',
      add: 'Lisää',
      details: 'Lisätiedot',
      edit: 'Muokkaa',
      editing: 'Muokataan...',
      delete: 'Poista',
      deleting: 'Poistetaan...',
      downloadQrPng: 'Lataa QR-koodi',
      save: 'Tallenna',
      cancel: 'Peruuta',
      close: 'Sulje',
      open: 'Avaa',
      characterCount: 'merkkiä',
      completeGive: 'Viimeistele luovutus',
      completeReturn: 'Viimeistele palautus',
      filter: 'Suodata',
      back: 'Takaisin',
      next: 'Seuraava',
      previous: 'Edellinen',
      loading: 'Ladataan...',
      serverStarting: 'Yhdistetään palvelimeen, odota hetki…',
      print: 'Tulosta',
      export: 'Vie',
      view: 'Näytä',
      create: 'Luo',
      createApartment: 'Luo asunto',
      createKey: 'Luo avain',
      select: 'Valitse',
      longPressHint: 'Vinkki: voit myös painaa korttia pitkään valitaksesi sen',
      clearSelection: 'Tyhjennä valinta',
      selected: 'Valittu {{count}} kpl',
      addSelectedToCart: 'Ostoskoriin',
      giveKeys: 'Luovuta',
      returnKeys: 'Palauta',
      regiveKeys: 'Uudelleenluovuta',
      changeFile: 'Vaihda tiedosto',
      selectFile: 'Valitse tiedosto',
      moreActions: 'Lisää toimintoja',
      createKeyType: 'Luo avaintyyppi',
      createUpkeepType: 'Luo kunnossapitotyyppi',
      createServiceRequestType: 'Luo palvelupyyntötyyppi',
      createCompany: 'Luo yritys',
      confirmDelete: 'Vahvista poisto',
      confirmDeleteGeneric: 'Haluatko varmasti poistaa tämän kohteen? Tätä toimintoa ei voi peruuttaa.',
      retry: 'Yritä uudelleen',
      actions: 'Toiminnot',
      deleteSelected: 'Poista valitut',
      bulk: {
        editSelected: 'Muokkaa',
        deleteConfirmTitle: 'Vahvista massapoisto',
        deleteResidentsMessage: 'Haluatko varmasti poistaa {{count}} valittua asukasta?',
        deleteApartmentsMessage: 'Haluatko varmasti poistaa {{count}} valittua asuntoa?',
        deleteCondominiumsMessage: 'Haluatko varmasti poistaa {{count}} valittua taloyhtiötä?',
        deleteKeysMessage: 'Haluatko varmasti poistaa {{count}} valittua avainta?',
        deleteLandlordsMessage: 'Haluatko varmasti poistaa {{count}} valittua vuokranantajaa?',
        deleteUpkeepsMessage: 'Haluatko varmasti poistaa {{count}} valittua tarkastusta?',
        deleteServiceRequestsMessage: 'Haluatko varmasti poistaa {{count}} valittua palvelupyyntöä?',
        deleteMeasurementsMessage: 'Haluatko varmasti poistaa {{count}} valittua mittausta?',
        deleteBillingAccountsMessage:
          'Haluatko varmasti poistaa {{count}} valittua asiakkuutta? Kohdeliitokset irtoavat, eivätkä ne palaudu, jos asiakkuudet palautetaan.',
        deleteTrackedAssetsMessage: 'Haluatko varmasti poistaa {{count}} valittua laitetta?',
        deleteRentalListingsMessage: 'Haluatko varmasti poistaa {{count}} valittua vuokrailmoitusta?',
        deleteBrokerageAgreementsMessage: 'Haluatko varmasti poistaa {{count}} valittua välityssopimusta?',
        deleteRentalApplicantsMessage: 'Haluatko varmasti poistaa {{count}} valittua hakijaa?',
        deleteRentalTemplatesMessage: 'Haluatko varmasti poistaa {{count}} valittua sopimuspohjaa?',
        deleteFinalCleaningTemplatesMessage: 'Haluatko varmasti poistaa {{count}} valittua loppusiivouspohjaa?',
        deleteRentalLeasesMessage: 'Haluatko varmasti poistaa {{count}} valittua vuokrasopimusta?',
        deleteBrokerageInvoicesMessage: 'Haluatko varmasti poistaa {{count}} valittua laskua?',
        deleteFinalInspectionsMessage: 'Haluatko varmasti poistaa {{count}} valittua lopputarkastusta?',
        deleteMoveInInspectionsMessage: 'Haluatko varmasti poistaa {{count}} valittua muuttotarkastusta?',
        deleteNeedsAssessmentsMessage: 'Haluatko varmasti poistaa {{count}} valittua tarveselvitystä?',
        deleteRepairHistoryReportsMessage: 'Haluatko varmasti poistaa {{count}} valittua korjaushistoriaa?',
        deleteUpkeepBatchesMessage: 'Haluatko varmasti poistaa {{count}} valittua kunnossapitokokonaisuutta?',
        deleteEspAccessMessage: 'Haluatko varmasti poistaa {{count}} valittua käyttöoikeutta?',
        editServiceRequestsTitle: 'Muokkaa palvelupyyntöjä',
        editUpkeepsTitle: 'Muokkaa tarkastuksia',
        editResidentsTitle: 'Muokkaa asukkaita',
        editApartmentsTitle: 'Muokkaa asuntoja',
        editCondominiumsTitle: 'Muokkaa taloyhtiöitä',
        editLandlordsTitle: 'Muokkaa vuokranantajia',
        editSelectionCount: '{{count}} kohdetta valittu',
        applyToSelected: 'Käytä valittuihin',
        clearAssignment: 'Tyhjennä kohdistus',
        selectResidentApartment: 'Valitse asunto',
        deleteFailed: 'Kaikkia valittuja kohteita ei voitu poistaa. Yritä uudelleen.',
        editFailed: 'Kaikkia valittuja kohteita ei voitu päivittää. Yritä uudelleen.',
        editSuccess: '{{count}} kohdetta päivitetty',
      },
    },
    wizard: {
      title: 'Taloyhtiön pikaluonti',
      subtitle: 'Luo taloyhtiö, asunnot, asukkaat ja avaimet yhdellä kertaa',
      quickSetup: 'Pikaluonti',
      steps: {
        condominium: 'Taloyhtiö',
        apartments: 'Asunnot',
        residents: 'Asukkaat',
        keys: 'Avaimet',
        review: 'Yhteenveto',
      },
      stepDescriptions: {
        condominium: 'Luo uusi taloyhtiö täyttämällä perustiedot',
        apartments: 'Lisää asuntoja taloyhtiöön yksitellen tai massana',
        residents: 'Lisää asukkaita ja liitä heidät asuntoihin',
        keys: 'Syötä asuntokohtaiset avainmäärät taulukosta tai lisää avaimia yksitellen; voit luovuttaa osan heti asukkaille',
        review: 'Tarkista tiedot ennen tallennusta',
      },
      actions: {
        skip: 'Ohita',
        next: 'Seuraava',
        previous: 'Edellinen',
        submit: 'Luo kaikki',
        addApartment: 'Lisää asunto',
        addResident: 'Lisää asukas',
        addKey: 'Lisää avain',
      },
      progress: {
        creatingCondominium: 'Luodaan taloyhtiötä...',
        creatingApartments: 'Luodaan asuntoja...',
        creatingResidents: 'Luodaan asukkaita...',
        creatingKeys: 'Luodaan avaimia...',
        rolling_back: 'Peruutetaan muutoksia...',
        complete: 'Valmis!',
      },
      info: {
        required: 'Huomio',
        condominiumRequired: 'Tähdellä (*) merkityt kentät ovat pakollisia',
        noApartments: 'Ei asuntoja lisätty. Voit ohittaa tämän vaiheen.',
        noApartmentsForResidents: 'Lisää ensin asuntoja, jotta voit lisätä asukkaita.',
        signatureAtReview: 'Allekirjoitus kerätään yhteenveto-vaiheessa',
      },
      apartmentsList: 'Asunnot',
      residentsList: 'Asukkaat',
      keysList: 'Avaimet',
      total: 'yhteensä',
      unknownApartment: 'Tuntematon asunto',
      willBeGivenTo: 'Luovutetaan',
      giveKeyImmediately: 'Luovuta avain heti',
      giveKeyImmediatelyDescription: 'Valitse asukas, jolle avain luovutetaan',
      selectResident: 'Valitse asukas',
      selectResidentOption: 'Valitse asukas...',
      apartment: 'Asunto',
      selectApartmentOptional: 'Valitse asunto',
      signatureRequired: 'Allekirjoitus vaaditaan',
      signatureRequiredDescription: 'Osa avaimista luovutetaan heti. Allekirjoita alla.',
      reviewConfirmation:
        'Tarkista tiedot huolellisesti. Kun painat "Luo kaikki", kaikki yllä olevat tiedot luodaan järjestelmään.',
      errors: {
        condominiumRequired: 'Taloyhtiön tiedot vaaditaan',
        apartmentNotFound: 'Asuntoa ei löytynyt',
        residentNotFound: 'Asukasta ei löytynyt',
        residentRequired: 'Valitse asukas',
        submissionFailed: 'Tallentaminen epäonnistui',
        rateLimited: 'Liian monta pyyntöä kerralla. Odota hetki ja yritä uudelleen.',
      },
      success: {
        allCreated: 'Kaikki tiedot luotu onnistuneesti!',
      },
      openSignatureInNewWindow: 'Avaa allekirjoitus uudessa ikkunassa',
      condominiumSections: {
        basic: 'Perustiedot',
        identifiers: 'Tunnisteet',
        settings: 'Hallinta ja oletukset',
      },
      keysQuantityTable: {
        title: 'Asuntokohtaiset avainmäärät',
        description:
          'Anna kullekin asunnolle avainten lukumäärä. Painike korvaa aiemmin taulukosta luodut avaimet; käsin lisätyt rivit säilyvät.',
        quantityColumn: 'Määrä',
        sequentialStampsLabel: 'Jatka leiman numerointia kaikkien asuntojen yli',
        sequentialStampsHint:
          'Kun leimapohja tukee numerosarjaa (esim. K-1-), numerot jatkuvat seuraavaan asuntoon ilman päällekkäisyyttä.',
        apply: 'Lisää / päivitä asuntoavaimet taulukosta',
        errorKeyType: 'Valitse asuntoavaimen tyyppi.',
        errorNoQuantities: 'Anna vähintään yhdelle asunnolle avainmäärä suurempi kuin nolla.',
      },
      keysAccordion: {
        addOneByOneTitle: 'Lisää avain yksitellen',
        addOneByOneDescription:
          'Yleisavaimet, poikkeavat asuntokohtaiset määrät tai luovutus heti asukkaalle — käytä tätä lomaketta.',
      },
    },
    apartment: {
      apartments: 'Asunnot',
      deleteTitle: 'Poista asunto',
      deleteMessage: 'Haluatko varmasti poistaa tämän asunnon? Tätä toimintoa ei voi peruuttaa.',
      apartment: 'Asunto',
      noNumber: 'Ei numeroa',
    },
    apartments: {
      title: 'Asunnot',
      searchPlaceholder: 'Hae asuntoja...',
      editApartment: 'Muokkaa asuntoa',
      apartment: 'Asunto',
      defaultTitle: 'Asunto',
      notFoundDescription: 'Pyytämääsi asuntoa ei löytynyt tai sinulla ei ole oikeuksia nähdä sitä.',
      overview: 'Yleiskatsaus',
      keys: 'Avaimet',
      residents: 'Asukkaat',
      name: 'Nimi',
      identifier: 'Tilatunnus',
      identifierPlaceholder: 'Esim. 123-456-7890-0012',
      identifierFormat: 'Tilatunnus voi olla enintään 32 merkkiä pitkä',
      deleteResidentTitle: 'Poista asukas',
      deleteResidentMessage: 'Haluatko varmasti poistaa asukkaan',
      deleteKeyTitle: 'Poista avain',
      deleteKeyMessage: 'Haluatko varmasti poistaa avaimen',
      addressRequired: 'Osoite on pakollinen',
      postalCodeRequired: 'Postinumero on pakollinen',
      postalCodeFormat: 'Postinumeron täytyy olla 5 numeroa',
      cityRequired: 'Kaupunki on pakollinen',
      condominiumRequired: 'Taloyhtiö on pakollinen',
      createNew: 'Luo uusi asunto',
      createMultiple: 'Luo useita asuntoja',
      multipleLabel: 'Luo useita asuntoja',
      multipleDescription: 'Kytke päälle luodaksesi useita asuntoja kerralla numeroalueella',
      firstNumber: 'Ensimmäinen numero',
      lastNumber: 'Viimeinen numero',
      condominium: 'Taloyhtiö',
      selectCondominium: 'Valitse taloyhtiö',
      selectApartment: 'Valitse asunto',
      address: 'Osoite',
      addressStreet: 'Katuosoite',
      postalCode: 'Postinumero',
      addressPostalCode: 'Postinumero',
      city: 'Kaupunki',
      addressCity: 'Kaupunki',
      sameForAll: '(Sama kaikille)',
      namePlaceholder: 'Esim. Punttisali',
      addressPlaceholder: 'Esim. Esimerkkikatu 1',
      postalCodePlaceholder: '00100',
      cityPlaceholder: 'Helsinki',
      firstNumberCannotBeGreater: 'Ensimmäinen numero ei voi olla suurempi kuin viimeinen numero',
      firstNumberRequired: 'Ensimmäinen numero on pakollinen',
      lastNumberRequired: 'Viimeinen numero on pakollinen',
      minOne: 'Arvon tulee olla vähintään 1',
      bulkRange: 'Numerot {{first}}-{{last}} ({{count}} kpl)',
      singleApartment: 'Yksittäinen asunto',
      createMultipleDescription: 'Luo useita asuntoja kerralla numero alueella',
      concatenateTo: 'Lisää numerot',
      concatenateToAddress: 'Osoitteeseen',
      concatenateToName: 'Nimeen',
      concatenateToBoth: 'Nimeen ja osoitteeseen',
      numbersConcatenatedToAddress: 'Numerot lisätään osoitteeseen',
      numbersConcatenatedToName: 'Numerot lisätään nimeen',
      numbersConcatenatedToBoth: 'Numerot lisätään nimeen ja osoitteeseen',
      keysFree: 'Avaimia vapaana',
      residentsCount: 'Asukkaita',
      showEmptyOnly: 'Vain asunnot ilman asukkaita',
      searchKeys: 'Hae avaimia...',
      searchResidents: 'Hae asukkaita...',
      addResident: 'Lisää asukas',
      additionalAddresses: 'Lisäosoitteet',
      additionalAddressesHelp: 'Pääosoite on yllä. Lisää tähän muut osoitteet.',
      addAdditionalAddress: 'Lisää lisäosoite',
      noAdditionalAddresses: 'Ei lisäosoitteita.',
      additionalAddressLabel: 'Lisäosoite {{index}}',
      additionalAddressIncomplete: 'Täytä lisäosoitteen katuosoite, postinumero ja kaupunki.',
      additionalAddressPostalCodeInvalid: 'Lisäosoitteen postinumeron täytyy olla 5 numeroa.',
      roomComposition: 'Huonejako',
      sizeM2: 'Koko (m²)',
      sizeNegative: 'Koko ei voi olla negatiivinen',
    },
    billingAccount: {
      name: 'Nimi',
      businessId: 'Y-tunnus',
      contactPerson: 'Yhteyshenkilö',
      email: 'Sähköposti',
      phone: 'Puhelin',
      billingAddress: 'Laskutusosoite',
      billingAddressStreet: 'Katuosoite',
      billingAddressPostalCode: 'Postinumero',
      billingAddressCity: 'Kaupunki',
      createTitle: 'Luo asiakkuus',
      editTitle: 'Muokkaa asiakkuutta: {{name}}',
      namePlaceholder: 'Esim. huollon asiakkuus',
      businessIdPlaceholder: '1234567-8',
      contactPersonPlaceholder: 'Yhteyshenkilön nimi',
      emailPlaceholder: 'laskutus@example.com',
      phonePlaceholder: '+358 40 123 4567',
      billingAddressStreetPlaceholder: 'Esim. Esimerkkikatu 1',
      billingAddressPostalCodePlaceholder: '00100',
      billingAddressCityPlaceholder: 'Helsinki',
      noBillingAccountsYet: 'Ei asiakkuuksia vielä',
      overview: 'Yleiskatsaus',
      deleteTitle: 'Poista asiakkuus',
      deleteConfirm:
        'Haluatko varmasti poistaa tämän asiakkuuden? Kohdeliitokset irtoavat, eivätkä ne palaudu, jos asiakkuus palautetaan.',
      notFound: 'Asiakkuutta ei löytynyt',
      searchPlaceholder: 'Hae asiakkuuksia...',
      createNew: 'Luo asiakkuus',
      addCondominiums: 'Lisää kiinteistöjä',
      addApartments: 'Lisää asuntoja',
      addSelected: 'Lisää valitut',
      noUnassignedCondominiums: 'Ei linkittämättömiä kiinteistöjä.',
      noUnassignedApartments: 'Ei linkittämättömiä asuntoja.',
      priceList: 'Hinnasto',
      priceListPlaceholder: 'Ei hinnastoa',
      priceListHelp:
        'Valinnainen. Sama hinnasto voi olla usealla asiakkuudella. Hinnat täyttyvät automaattisesti laskun esikatselussa.',
      noLinkedCondominiums: 'Tähän asiakkuuteen ei ole vielä linkitetty kiinteistöjä.',
      noLinkedApartments: 'Tähän asiakkuuteen ei ole vielä linkitetty asuntoja.',
      removeLink: 'Poista linkitys',
      removeLinkTitle: 'Poista linkitys asiakkuudesta',
      removeLinkConfirm: 'Poistetaanko "{{name}}" tästä asiakkuudesta? Kohde säilyy järjestelmässä.',
      assignmentAddSuccess: '{{count}} kohdetta linkitetty',
      assignmentAddFailed: 'Linkitysten lisääminen epäonnistui',
      assignmentRemoveFailed: 'Linkityksen poisto epäonnistui',
      linkPropertiesForRelatedLists:
        'Linkitä ensin taloyhtiöitä tai asuntoja tähän asiakkuuteen, jotta voit selata niihin liittyviä tietoja.',
      assignableSelectAllShown: 'Valitse kaikki näkyvät',
      assignableShownOfTotal: '{{visible}} / {{total}}',
    },
    validation: {
      endDateBeforeStart: 'Päättymispäivä ei voi olla ennen alkamispäivää',
      fillAllRequired: 'Täytä kaikki vaaditut kentät',
      firstNameRequired: 'Etunimi on pakollinen',
      lastNameRequired: 'Sukunimi on pakollinen',
      emailRequired: 'Sähköposti on pakollinen',
      emailInvalid: 'Virheellinen sähköpostiosoite',
      roleRequired: 'Rooli on pakollinen',
      companyRequired: 'Yritys on pakollinen',
      confirmNameRequired: 'Vahvistusnimi on pakollinen',
      phoneRequired: 'Puhelinnumero on pakollinen',
      phoneInvalid: 'Virheellinen puhelinnumero',
      postalCodeRequired: 'Postinumero on pakollinen',
      postalCodeLength: 'Postinumeron täytyy olla 5 numeroa',
      postalCodeInvalid: 'Virheellinen postinumero',
      businessIdInvalid: 'Virheellinen Y-tunnus. Käytä muotoa 1234567-8 ja oikeaa tarkistusmerkkiä.',
      nameRequired: 'Nimi on pakollinen',
      unsafeText: 'Teksti sisältää sallimattomia merkkejä',
      addressRequired: 'Osoite on pakollinen',
      cityRequired: 'Postitoimipaikka on pakollinen',
      passwordRequired: 'Salasana on pakollinen',
      passwordConfirmationRequired: 'Salasanan vahvistus on pakollinen',
      passwordInvalid: 'Salasana ei täytä vaatimuksia',
      passwordMinLength: 'Salasanan tulee olla vähintään 8 merkkiä',
      passwordComplexity: 'Salasanan tulee sisältää pieni kirjain, iso kirjain, numero ja erikoismerkki',
      keyTypeRequired: 'Avaimen tyyppi on pakollinen',
      amountMin: 'Määrä täytyy olla vähintään 1',
      amountMax: 'Määrä ei voi olla yli 100',
      condominiumOrApartmentRequired: 'Taloyhtiö tai asunto on pakollinen riippuen avaimen tyypistä',
      condominiumRequired: 'Taloyhtiö on pakollinen',
      apartmentRequired: 'Asunto on pakollinen',
      selectTarget: 'Valitse kohde',
      date: 'Anna kelvollinen päivä (YYYY-MM-DD).',
      translationTypeInvalid: 'Virheellinen käännöstyyppi. Valitse yksi seuraavista vaihtoehdoista.',
      passwordsMustMatch: 'Salasanojen täytyy täsmätä',
      maxLength: 'Teksti voi olla enintään {{max}} merkkiä',
      minValue: 'Arvo ei voi olla pienempi kuin {{min}}',
      maxValue: 'Arvo ei voi olla suurempi kuin {{max}}',
      invalidValue: 'Virheellinen arvo',
      fields: {
        name: 'Nimi',
        listName: 'Listanimi',
        number: 'Numero',
        identifier: 'Tunnus',
        addressStreet: 'Katuosoite',
        addressPostalCode: 'Postinumero',
        addressCity: 'Postitoimipaikka',
        businessId: 'Y-tunnus',
        stamp: 'Leima',
        sizeM2: 'Pinta-ala',
      },
      required: 'Pakollinen',
    },
    residents: {
      emailNotSet: 'Sähköpostia ei ole asetettu',
      title: 'Asukkaat',
      searchPlaceholder: 'Hae asukkaita...',
      emptyStateDescription: 'Luo ensimmäinen asukas aloittaaksesi',
      editResident: 'Muokkaa asukasta',
      createResident: 'Luo uusi asukas',
      firstName: 'Etunimi',
      lastName: 'Sukunimi',
      email: 'Sähköposti',
      phone: 'Puhelinnumero',
      apartment: 'Asunto',
      active: 'Aktiivinen',
      firstNamePlaceholder: 'Esim. Matti',
      lastNamePlaceholder: 'Esim. Meikäläinen',
      emailPlaceholder: 'matti@example.com',
      phonePlaceholder: '+358 40 123 4567',
      selectApartment: 'Valitse asunto',
      apartmentRequired: 'Asunto on pakollinen',
      cancel: 'Peruuta',
      createNewTab: 'Luo uusi',
      selectExistingTab: 'Valitse olemassa oleva',
      noResidentsWithoutApartment: 'Kaikilla asukkailla on jo asunto',
      noResidentsFound: 'Ei asukkaita',
      selectResidentPlaceholder: 'Valitse asukas...',
    },
    landlords: {
      listTitle: 'Vuokranantajat',
      linkExisting: 'Linkitä vuokranantaja',
      searchPlaceholder: 'Hae vuokranantajia...',
      deleteTitle: 'Poista vuokranantaja',
      deleteMessage: 'Haluatko varmasti poistaa vuokranantajan "{{name}}"? Tätä toimintoa ei voi peruuttaa.',
      createLandlord: 'Luo vuokranantaja',
      openLandlordPortal: 'Avaa vuokranantajaportaali',
      editLandlord: 'Muokkaa vuokranantajaa',
      landlordDetails: 'Vuokranantajan tiedot',
      landlord: 'Vuokranantaja',
      addressStreet: 'Katuosoite',
      addressPostalCode: 'Postinumero',
      addressCity: 'Kaupunki',
      contactNotes: 'Yhteystiedot',
      leaseContactNote: 'Yhteystiedot vuokrasopimusasioissa',
      billingContactNote: 'Yhteystiedot laskuasioissa',
      paymentInfo: 'Maksutiedot',
      invoiceIban: 'Tilinumero (IBAN)',
      invoiceBic: 'BIC',
      notFound: 'Vuokranantajaa ei löydy',
      publicPortalLink: 'Vuokranantajaportaali',
      publicPortalLinkDescription:
        'Jaa tämä linkki vuokranantajille. He syöttävät sähköpostinsa ja saavat kertakirjautumislinkin portaaliin.',
      linkSuccess: 'Vuokranantaja linkitetty',
      unlinkSuccess: 'Linkitys poistettu',
      unlinkTitle: 'Poistetaanko linkitys?',
      unlinkConfirm: 'Poista linkitys',
      unlink: 'Poista linkitys',
      noResults: 'Ei tuloksia haulla.',
      unnamed: 'Nimetön vuokranantaja',
      noCondominiums: 'Ei kiinteistöjä',
      noApartments: 'Ei tiloja',
      additionalContacts: 'Muut vuokranantajat',
      tenantBillingMode: 'Vuokralaisten laskutus',
      tenantBillingModeHint:
        'Valitse kuka laskuttaa vuokralaiset. Tämä kopioituu uusille vuokrasopimuksille, ja sopimuksella voi tarvittaessa poiketa.',
      tenantBillingModes: {
        self: 'Vuokranantaja laskuttaa itse',
        via_xkey: 'Laskutus Xkeyn kautta',
        via_api: 'Laskutus Xkeyn kautta (rajapinta)',
      },
      additionalContactsHelp:
        'Liitä tähän vuokranantajaan toinen henkilö (esim. puoliso). Häntä käsitellään vuokranantajana: sähköpostilla voi kirjautua vuokranantajaportaaliin, ja allekirjoituspyynnöt lähtevät myös hänelle.',
      additionalContactsEmpty: 'Ei muita vuokranantajia',
      addContact: 'Lisää vuokranantaja',
      additionalContactLabel: 'Vuokranantaja {{index}}',
      additionalContactNameRequired: 'Vuokranantajan nimi on pakollinen',
      additionalContactEmailDuplicate: 'Sama sähköposti on jo lisätty',
      additionalContactEmailMatchesPrimary: 'Lisäsähköposti ei voi olla sama kuin päätilin sähköposti',
    },
    keys: {
      notFound: 'Avainta ei löytynyt',
      attentionFilter: 'Näytä kaikki tai huomiota vaativat',
      title: 'Avaimet',
      searchPlaceholder: 'Hae avaimia...',
      showMineOnly: 'Näytä omat',
      key: 'Avain',
      tasks: 'Tehtävät',
      tasksTooltip: '{{count}} avaintehtävää (avoinna)',
      emptyMyKeysOnly: 'Sinulla ei ole hallussasi olevia avaimia.',
      attentionFilterLate: 'Vain myöhässä',
      attentionFilterMissing: 'Vain kadonneet',
      emptyLateAttention: 'Ei myöhässä olevia avaimia.',
      emptyMissingAttention: 'Ei kadonneita avaimia.',
      emptyAvailableTab: 'Ei vapaita avaimia (ei lainassa).',
      emptyBorrowedTabTitle: 'Ei lainassa olevia avaimia',
      emptyBorrowedTab: 'Tällä hetkellä ei ole lainassa olevia avaimia.',
      emptyStateDescription: 'Luo ensimmäinen avain aloittaaksesi',
      editKey: 'Muokkaa avainta',
      deleteKeyType: 'Poista avaintyyppi',
      noSearchResults: 'Ei hakutuloksia',
      keyType: 'Avaimen tyyppi',
      apartment: 'Asunto',
      target: 'Kohde',
      resident: 'Asukas',
      landlord: 'Vuokranantaja',
      borrower: 'Lainaaja',
      issuedDate: 'Luovutusaika',
      status: 'Tila',
      generalKey: 'Yleinen avain',
      stamp: 'Leima',
      name: 'Nimi',
      attentionNote: 'Huomio',
      attentionNotePlaceholder: 'Kirjoita avaimeen lisätieto (näkyy luovutuksessa ja palautuksessa)',
      namePlaceholder: 'Näyttönimi (esim. varasto)',
      noStamp: 'Ei leimaa',
      lockType: 'Lukkotyyppi',
      type: 'Avaintyyppi',
      condominium: 'Taloyhtiö',
      amount: 'Määrä',
      received: 'Vastaanotettu',
      returned: 'Palautettu',
      amountRequired: 'Määrä on pakollinen',
      typeRequired: 'Tyyppi on pakollinen',
      pcs: 'kpl',
      unknownType: 'Tuntematon tyyppi',
      signature: 'Allekirjoitus',
      create: 'Luo avain',
      canBeReGiven: 'Avain voidaan luovuttaa edelleen',
      canBeReGivenDescription: 'Avaimen saaja voi luovuttaa avaimen eteenpäin',
      mandate: 'Valtakirja',
      stampPlaceholder: 'Syötä avaimen leima',
      amountPlaceholder: 'Luotavien avainten määrä',
      bulkRowsTitle: 'Massaluonnin rivit',
      regenerateStamps: 'Luo leimat uudelleen',
      sequentialStampTooltip:
        'Kun luot useampaa avainta kerralla, leimat täyttyvät automaattisesti tästä kentästä.\n\nJuokseva numero: käytä tunnistettavaa mallia leiman lopussa, esim. KEY- (→ KEY1, KEY2), EA/1- (→ EA/1, EA/2), EA/10 (→ EA/10, EA/11) tai EA -/10 (→ EA 1/10, EA 2/10).\n\nPelkkä teksti ilman mallia toistuu samana kaikilla riveillä. Voit korjata yksittäisiä leimoja taulukossa.',
      selectKeyType: 'Valitse avaimen tyyppi',
      cannotChangeTypeWhileOnLoan: 'Avaimen tyyppiä ei voi vaihtaa, kun avain on lainassa tai varattuna.',
      selectLockType: 'Valitse lukkotyyppi',
      keyAgreement: 'Avainsopimus',
      handoverInstructions: 'Avainluovutuksen ohjeet',
      handoverInstructionsPlaceholder: 'Kirjoita ohjeet avainten luovutukseen ja palautukseen',
      stampAlreadyInUse: 'Leima "{{stamp}}" on jo käytössä',
      stampCheckFailed: 'Leiman käytettävyyttä ei voitu tarkistaa. Yritä uudelleen.',
      keyHandoutDocument: 'Avainluovutusasiakirja',
      handedOver: 'Luovutettu',
      handedOverKey: 'Luovutettu avain',
      returnedKey: 'Palautettu avain',
      identifier: 'Tunniste',
      location: 'Sijainti',
      dateAndTime: 'Päivämäärä ja aika',
      returnBy: 'Palautettava viimeistään',
      available: 'Vapaa',
      borrowed: 'Lainassa',
      returnToOwnerLabel: 'Omistajalle',
      returnToOriginalLabel: 'Alkuperäiselle haltijalle',
      noPermission: 'Ei käyttöoikeutta',
      noPermissionDescription: 'Sinulla ei ole käyttöoikeutta tarkastella avaimia.',
      dueDate: 'Palautettava viimeistään',
      selectedKeysNotGiveableWarning:
        'Kaikkia valituista avaimista ei voi luovuttaa. Vain vapaat avaimet voidaan luovuttaa.',
      selectionMixedCartTypes:
        'Valinnassa on sekä vapaita että lainassa olevia avaimia. Lisää koriin vain yhtä tyyppiä kerrallaan tai tyhjennä valinta.',
      externalCompany: 'Yritys',
      bulkEdit: {
        title: 'Massamuokkaa avaimia',
        save: 'Tallenna muutokset',
        mixedValue: 'Arvo vaihtelee valituissa avaimissa',
        selectionCount: '{{count}} avainta valittuna',
        clearValue: 'Tyhjennä arvo',
        stampSequentialTemplate: 'Käytä peräkkäistä leimapohjaa',
        stampTemplatePlaceholder: 'esim. EA -/10',
        stampTemplateHelper:
          'Numerointi alkaa arvosta 1 ja etenee taulukon riveittäin ylhäältä alas. Esim. pohjalla "EA -/10" rivit saavat leimat "EA 1/10", "EA 2/10", "EA 3/10"...',
        stampPreviewLabel: 'Esikatselu',
      },
    },
    cart: {
      title: 'Avainerä',
      addToCart: 'Lisää erään',
      removeFromCart: 'Poista erästä',
      clearAll: 'Tyhjennä erä',
      empty: 'Ei avaimia erässä',
      openCart: 'Avaa avainerä',
      totalKeys: 'Yhteensä {{count}} avainta',
      giveAll: 'Luovuta kaikki',
      addKeysToStart: 'Valitse avaimia listasta → Lisää erään, tai käytä Esivalmistellut-välilehteä.',
      processingCart: 'Erää käsitellään...',
      updatingCartData: 'Päivitetään erän tietoja...',
      loadingCartContents: 'Ladataan erän sisältöä...',
      invalidItem: 'Virheellinen erän kohde - puuttuu avaintiedot',
      modeGive: 'Luovutus',
      modeReturn: 'Palautus',
      returnCartInfo:
        'Erässä on lainassa olevia avaimia. Voit tallentaa ne esivalmisteltuun palautukseen. Tyhjennä erä, jos haluat lisätä vapaita avaimia.',
    },
    presavedCart: {
      title: 'Esivalmistellut avaimet',
      tabTitle: 'Esivalmistellut',
      saveCart: 'Tallenna kori',
      save: 'Tallenna',
      cartName: 'Korin nimi',
      cartNamePlaceholder: 'Esim. Asukkaan avaimet',
      makePrivate: 'Yksityinen (vain minä näen)',
      private: 'Yksityinen',
      companyWide: 'Yrityksen laajuinen',
      keysCount: '{{count}} avainta',
      keys: 'Avaimet',
      createdBy: 'Luonut',
      noSavedCarts: 'Ei tallennettuja koreja',
      noSavedCartsDescription:
        'Tallenna ostoskori valmistellaksesi luovutuksen tai palautuksen ja viimeistelläksesi sen myöhemmin allekirjoituksella.',
      selectCart: 'Valitse kori',
      completeGive: 'Viimeistele luovutus',
      completeGiveWizardReview: 'Tarkistus',
      completeGiveWizardSign: 'Allekirjoitus',
      completeReturn: 'Viimeistele palautus',
      combineCarts: 'Yhdistä korit',
      combineSelected: 'Yhdistä valitut',
      combine: 'Yhdistä',
      selectAtLeastTwo: 'Valitse vähintään kaksi koria yhdistääksesi',
      confirmDelete: 'Haluatko varmasti poistaa tämän korin?',
      notFound: 'Esivalmisteltua avainkorttia ei löytynyt.',
      savingKeys: 'Tallennetaan {{count}} avainta',
      howToSave: 'Miten haluat tallentaa?',
      createNewSavedCart: 'Luo uusi tallennettu kori',
      addToExistingSavedCart: 'Lisää avaimet olemassa olevaan tallennettuun koriin',
      selectExistingCartRequired: 'Valitse tallennettu kori',
      appendKeysNote:
        'Korin palautuspäivä, uudelleenluovutusasetus ja nimi pysyvät ennallaan. Vain valitut avaimet lisätään.',
      addKeys: 'Lisää avaimet',
      addingKeys: 'Lisätään…',
      visibility: 'Näkyvyys',
      editCart: 'Tallennettu kori',
      searchCarts: 'Hae tallennettuja koreja…',
      addKeysViaShoppingCartHint:
        'Voit lisätä avaimia myös ostoskorin kautta: Tallenna kori → Lisää olemassa olevaan tallennettuun koriin.',
      addKeysSectionTitle: 'Lisää vapaita avaimia',
      addKeysDirectDescription:
        'Valitse alla olevista vapaista (luovuttamattomista) avaimista. Hae leimalla, tyypillä tai kohteella.',
      addHeldKeysSectionTitle: 'Lisää lainassa olevia avaimia',
      addHeldKeysDirectDescription:
        'Valitse alla olevista saman henkilön lainassa olevista avaimista. Hae leimalla, tyypillä tai kohteella.',
      otherHeldKeys: 'Muut lainassa olevat avaimet',
      otherHeldKeysDescription: 'Saman henkilön lainassa olevat avaimet, jotka eivät ole tässä korissa.',
      addKeyToCart: 'Lisää koriin',
      addAllHeldKeys: 'Lisää kaikki',
      searchKeysToAddPlaceholder: 'Hae avaimia…',
      addSelectedKeysToCart: 'Lisää valitut avaimet',
      noKeysToAddMatch: 'Hakuehdoilla ei löytynyt vapaita avaimia. Kokeile toista hakua tai tyhjennä haku.',
      noHeldKeysToAddMatch: 'Hakuehdoilla ei löytynyt lainassa olevia avaimia. Kokeile toista hakua tai tyhjennä haku.',
      noKeysInCartYet: 'Korissa ei ole vielä avaimia. Lisää vapaita avaimia alta tai käytä ostoskoria.',
      noKeysInReturnCartYet: 'Korissa ei ole vielä avaimia. Lisää lainassa olevia avaimia alta.',
      keysAddListMayTruncate: 'Enintään 200 avainta ladataan kerralla. Käytä hakua, jos avainta ei näy listalla.',
      combineSelectionInvalid:
        'Voit yhdistää vain saman tyyppisiä koreja: yksityisiä keskenään tai yrityksen laajuisia keskenään.',
      cartDirection: 'Tarkoitus',
      cartDirectionAutoHint:
        'Valitaan automaattisesti ostoskorin avainten perusteella (vapaat → luovutus, lainassa → palautus).',
      prepareGive: 'Valmistele luovutus',
      prepareReturn: 'Valmistele palautus',
      directionGive: 'Luovutus',
      directionReturn: 'Palautus',
      direction: 'Tyyppi',
      returnToLabel: 'Palautuskohde',
      returnToRequired: 'Valitse palautuskohde',
      recipient: 'Vastaanottaja',
      recipientType: 'Vastaanottajan tyyppi',
      selectRecipient: 'Valitse vastaanottaja',
      returnHolderLabel: 'Nykyinen haltija',
      returnHolderInferredHint: 'Valitaan automaattisesti korin avainten perusteella.',
      returnHolderType: 'Kenen palautuskori',
      returnHolderHint: 'Korissa on usean henkilön avaimia. Valitse kenen palautuskoriin nämä liitetään.',
      selectReturnHolder: 'Valitse henkilö',
      noSavedCartsForRecipient: 'Tällä vastaanottajalla ei ole vielä tallennettuja koreja. Luo uusi kori.',
      noSavedCartsForReturnHolder: 'Tällä henkilöllä ei ole vielä tallennettuja palautuskoreja. Luo uusi kori.',
      noReturnCarts: 'Ei valmisteltuja palautuskoreja tälle vastaanottajalle.',
      keyMustBeHeldForReturn: 'Avaimen tulee olla lainassa (ei vapaa), jotta se voidaan lisätä palautuskoriin.',
      cannotCompleteReturnWithAvailableKeys: 'Palautusta ei voi viimeistellä, jos jokin korin avaimista on yhä vapaa.',
      downloadQrPdf: 'QR-koodi PDF',
      notifyReadyForPickup: 'Lähetä noutoilmoitus',
      notifyReadyTitle: 'Ilmoita avaimet valmiiksi',
      notifyReadyDescription:
        'Lähetä korin kohteelle ilmoitus, että avaimesi ovat valmiit noudettavaksi. Viestissä mainitaan yrityksen nimi.',
      notifyReadySend: 'Lähetä noutoilmoitus',
      pdfTitle: 'Esivalmistellut avaimet',
      pdfKeysHeading: 'Avaimet',
      pdfKeyName: 'Nimi / leima',
      pdfKeyType: 'Tyyppi',
      pdfKeyLocation: 'Sijainti',
      pdfScanInstructions: 'Skannaa QR-koodi avataksesi tämän avainkorin suoraan Xkey-järjestelmässä.',
      pdfGeneratedAt: 'Luotu:',
      keyAlreadyGiven: 'Tämä avain on lainassa / ei ole vapaa luovutettavaksi',
      cannotCompleteWithGivenKeys:
        'Luovutusta ei voi viimeistellä, koska jotkin avaimet eivät ole vapaana. Ota käyttöön vain vapaat avaimet tai poista varatut avaimet korista.',
      giveOnlyAvailableKeys: 'Luovuta vain vapaana olevat avaimet',
      giveOnlyAvailableKeysHint:
        'Luovutetaan vain avaimet, jotka ovat vapaana. Lainassa olevat jäävät samaan koriin ja voit viimeistellä luovutuksen myöhemmin.',
      handoverInstructionsMultipleLocations:
        'Avaimet ovat useasta sijainnista — ohjeet on jaettu otsikoilla. Laajenna kukin osio tarvittaessa.',
      partialGiveSuccess:
        'Vapaat avaimet luovutettu. Lainassa olevat avaimet jäivät korissa — viimeistele luovutus uudella allekirjoituksella, kun ne ovat palautuneet.',
      noAvailableKeysToGive: 'Korissa ei ole vapaita avaimia, joita voisi luovuttaa',
      preHandoverDetailsSection: 'Lisätiedot',
      handoverExtraDetailsSection: 'Luovutuksen lisätiedot',
      handoverExtraDetailsNotYetAllowedWarning: 'Luovutusta ei saa vielä tehdä!',
      handoverAllowedFromDate: 'Luovutus sallittu alkaen (päivä)',
      handoverAllowedFromTime: 'Luovutus sallittu alkaen (kellonaika)',
      handoverAllowedFromTimePlaceholder: '14:00',
      externalOrderReference: 'Ulkoinen tilausnumero',
      mandateHandoverAllowed: 'Luovutus valtakirjalla sallittu',
      mandateHandoverUnspecified: 'Ei merkitty',
      mandateHandoverYes: 'Kyllä',
      mandateHandoverNo: 'Ei',
      additionalNotes: 'Lisätiedot',
      taskTitlesEmpty: 'Ei valmisteltuja luovutustehtäviä',
      taskTitlesCount: '{{count}} tehtävää',
      invalidHandoverTime: 'Anna kellonaika muodossa HH:mm (esim. 09:30)',
      preHandoverDetailsEmpty: 'Ei täytettyjä lisätietoja',
    },
    key: {
      overview: 'Yleiskatsaus',
      history: 'Historia',
      actions: 'Toiminnot',
      borrowed: 'Lainassa',
      overdue: 'Myöhässä',
      returnDateInPast: 'Palautuspäivä on menneisyydessä. Avain näkyy heti myöhässä olevana.',
      available: 'Vapaa',
      presaved: 'Esivalmisteltu',
      openPresavedCart: 'Avaa',
      choosePresavedCart: 'Valitse tallennettu kori',
      lost: 'Kadonnut',
      return: 'Palauta',
      give: 'Luovuta',
      regive: 'Uudelleenluovuta',
      giving: 'Luovutetaan...',
      regiving: 'Uudelleenluovutetaan...',
      returning: 'Palautetaan...',
      markingLost: 'Merkitään kadonneeksi...',
      markingFound: 'Merkitään löytyneeksi...',
      sendReminder: 'Lähetä muistutus',
      sendingReminder: 'Lähetetään muistutusta...',
      changeDueDate: 'Muuta eräpäivää',
      changeDueDateBulkDescription: 'Sama eräpäivä asetetaan kaikille valituille lainassa oleville avaimille.',
      updateDueDate: 'Päivitä eräpäivä',
      removeDueDate: 'Poista eräpäivä',
      currentDueDate: 'Nykyinen eräpäivä',
      keys: 'Avaimet',
      notFound: 'Avainta ei löytynyt',
      id: 'Avain ID',
      keyDetails: 'Avaimen tiedot',
      locationAndHolder: 'Sijainti ja haltija',
      holder: 'Haltija',
      originalHolder: 'Alkuperäinen haltija',
      borrowedSince: 'Lainassa alkaen',
      returnDate: 'Palautuspäivä',
      historyEmpty: 'Tälle avaimelle ei löytynyt historiatietoja.',
      batchEmpty: 'Tässä erässä ei ole muita tapahtumia.',
      historySearchPlaceholder: 'Hae historiasta...',
      historyNoMatches: 'Ei hakutuloksia',
      historyNoMatchesDescription: 'Kokeile toista hakusanaa.',
      giveKey: 'Anna avain',
      returnKey: 'Palauta avain',
      returnDestination: 'Mihin avaimet palautetaan?',
      regiveKey: 'Uudelleenluovuta avain',
      giveTo: 'Kenelle avain luovutetaan?',
      regiveTo: 'Kenelle avain uudelleenluovutetaan?',
      handoverAddResident: 'Luo uusi asukas',
      handoverKeysListGive: 'Luovutettavat avaimet ({{count}})',
      handoverKeysListRegive: 'Uudelleenluovutettavat avaimet ({{count}})',
      handoverKeysListReturn: 'Palautettavat avaimet ({{count}})',
      handoverKeysListEmpty: 'Ei avaimia valittuna',
      handoverRemoveKey: 'Poista listasta',
      handoverAddKeys: 'Lisää avaimia',
      handoverAddFromCart: 'Korista',
      handoverAddFromList: 'Listasta',
      handoverNewKey: 'Uusi avain',
      handoverAddFromDirectory: 'Taloyhtiöstä tai asunnosta',
      handoverDirectoryHint:
        'Valitse taloyhtiö tai asunto, tai kirjoita vähintään kaksi merkkiä hakukenttään (tunniste, osoite, taloyhtiö).',
      handoverDirectoryKeySearch: 'Hae',
      handoverDirectorySearchPlaceholder: 'Esim. tunniste tai osoite…',
      handoverDirectoryNoQuery: 'Valitse taloyhtiö tai asunto, tai kirjoita hakua (vähintään 2 merkkiä).',
      handoverDirectoryLoading: 'Haetaan…',
      handoverDirectoryNoResults: 'Ei sopivia avaimia.',
      handoverDirectoryAdd: 'Lisää',
      handoverDirectoryResultCount: 'Näytetään {{shown}} / {{total}} tulosta',
      handoverDirectoryTruncated: 'Listalla on enintään {{max}} tulosta — tarkenna valintaa tai hakua.',
      handoverWizardKeys: 'Avaimet',
      handoverWizardRecipient: 'Kenelle',
      handoverWizardPeriodAndNotifications: 'Aika ja viestit',
      handoverWizardAgreementSign: 'Allekirjoitus',
      handoverWizardWhoReturned: 'Kuka palautti',
      handoverWhoReturned: 'Kuka palautti avaimen',
      returnedByPhysical: 'Palautti',
      handoverWizardReturnDestination: 'Kohde',
      handoverWizardReturnComplete: 'Allekirjoitus',
      returnKeysModalTitle: 'Palauta avaimet',
      returnRegisterExternalHint:
        'Kun avain palautetaan ulkoisesta järjestelmästä eikä sitä ole vielä rekisteröity, lisää avain tähän luomalla uusi tai valitsemalla luettelosta, ja viimeistele palautus allekirjoituksella.',
      returnSavedCartsNoticeTitle: 'Avain kuuluu tallennettuihin koreihin',
      returnSavedCartsNoticeLine: '{{key}} kuuluu koreihin: {{carts}}',
      openSavedCartNewTab: 'Avaa kori',
      returnToOwnerLabel: 'Omistajalle',
      returnToOwnerHint: 'Avaimet palautetaan vapaiksi omistajalle eikä niitä kirjata kenenkään lainaan',
      returnToOriginalLabel: 'Alkuperäiselle haltijalle',
      returnToOriginalHint: 'Avaimet palautetaan sille henkilölle, jolla ne olivat alun perin',
      returnToOriginalDisabledHint: 'Alkuperäinen haltija on sama kuin nykyinen haltija',
      returnOriginalHoldersHeading: 'Alkuperäiset haltijat',
      returnNoOriginalHolder: 'Ei alkuperäistä haltijaa',
      returnSaving: 'Palautetaan...',
      returnSubmit: 'Palauta avaimet',
      notifications: 'Ilmoitukset',
      additionalReceiptEmail: 'Lisäsähköposti kuittaukselle',
      additionalReceiptEmailHint:
        'Jos täytät kentän, tähän osoitteeseen lähetetään erillinen kuittaus luovutuksesta tai palautuksesta.',
      incompleteReturn: 'Puutteellinen palautus',
      incompleteReturnNote: 'Selite',
      incompleteReturnNotePlaceholder: 'Esim. postilaatikon avain puuttuu',
      incompleteReturnNoteRequired: 'Kirjoita, mikä palautuksessa on puutteellista',
      incompleteReturnCheckingSiblings: 'Tarkistetaan samaa luovutuserää…',
      incompleteReturnUncheckHint: 'Voit poistaa rastin, jos et halua merkitä palautusta puutteelliseksi.',
      incompleteReturnAutoNote: 'Samassa luovutuserässä palauttamatta: {{keys}}',
      incompleteReturnAddHeading: 'Lisää puuttuvat tähän palautukseen',
      incompleteReturnAddAll: 'Lisää kaikki',
      incompleteReturnMissingHint: 'Nämä avaimet lainattiin samalla kertaa ja ovat vielä palauttamatta.',
      originalDueDatePreserved: 'Määräaika määräytyy alkuperäisen luovutuksen mukaan',
      originalDueDateSame: 'Palautuspäivä on sama kuin alkuperäisessä luovutuksessa',
      markLost: 'Merkitse kadonneeksi',
      markLostMessage: 'Haluatko varmasti merkitä avaimen #{{id}} kadonneeksi?',
      markFound: 'Merkitse löytyneeksi',
      markFoundMessage: 'Haluatko varmasti merkitä avaimen #{{id}} löytyneeksi?',
      deleteKey: 'Poista avain',
      deleteKeyMessage: 'Haluatko varmasti poistaa avaimen #{{id}}? Tätä toimintoa ei voi peruuttaa.',
      deleteOnLoanNote: 'Avain on tällä hetkellä lainassa.',
      deleteOnLoanNoteWithHolder: 'Avain on tällä hetkellä lainassa ({{holder}}).',
      deleteOnLoanBulkNote: '{{count}} valituista avaimista on lainassa.',
      time: 'Aika',
      eventLabel: 'Tapahtuma',
      dueDate: 'Eräpäivä',
      performer: 'Tekijä',
      view: 'Tarkastele',
      event: {
        return: 'Palautus',
        give: 'Luovutus',
        lost: 'Kadonnut',
        found: 'Löytynyt',
        unknown: 'Tuntematon',
      },
    },
    common: {
      info: 'Lisätietoja',
      users: 'Käyttäjät',
      helpInformation: 'Ohje',
      richText: {
        bold: 'Lihavointi',
        italic: 'Kursivointi',
        bulletList: 'Luettelo',
        orderedList: 'Numeroitu luettelo',
        blockquote: 'Lainaus',
        paragraph: 'Kappale',
        heading1: 'Otsikko 1',
        heading2: 'Otsikko 2',
        undo: 'Kumoa',
        redo: 'Tee uudelleen',
      },
      templateCopyName: '{{name}} (kopio)',
      done: 'Valmis',
      name: 'Nimi',
      firstName: 'Etunimi',
      lastName: 'Sukunimi',
      address: 'Osoite',
      details: 'Yksityiskohdat',
      description: 'Kuvaus',
      space: 'Asunto',
      email: 'Sähköposti',
      invalidEmail: 'Virheellinen sähköpostiosoite',
      phone: 'Puhelinnumero',
      teams: 'Tiimit',
      previous: 'Edellinen',
      next: 'Seuraava',
      back: 'Takaisin',
      actions: 'Toiminnot',
      delete: 'Poista',
      remove: 'Poista',
      cancel: 'Peruuta',
      clear: 'Tyhjennä',
      close: 'Sulje',
      confirm: 'Vahvista',
      save: 'Tallenna',
      create: 'Luo',
      confirmDelete: 'Vahvista poisto',
      confirmDeleteMessage: 'Haluatko varmasti poistaa tämän kohteen? Tätä toimintoa ei voi peruuttaa.',
      deleteEntityMessage: 'Haluatko varmasti poistaa kohteen "{{entityName}}"? Tätä toimintoa ei voi peruuttaa.',
      unsavedChangesTitle: 'Tallentamattomia muutoksia',
      unsavedChangesMessage: 'Sinulla on tallentamattomia muutoksia. Haluatko varmasti poistua? Muutoksesi menetetään.',
      leave: 'Poistu',
      stay: 'Pysy',
      loading: 'Ladataan...',
      appVersion: 'Sovellus v.{{version}}',
      apiVersion: 'Rajapinta v.{{version}}',
      generalError: 'Tapahtui virhe',
      authShellErrorDescription: 'Sovelluksessa tapahtui virhe. Päivitä sivu.',
      basicInfo: 'Perustiedot',
      tags: 'Tagit',
      noData: 'Ei tietoja saatavilla',
      location: 'Sijainti',
      duplicateWarning: {
        title: 'Mahdollinen kaksoiskappale',
        message:
          'Järjestelmässä on jo {{count}} vastaavaa tietuetta. Haluatko luoda uuden vai käyttää olemassa olevaa?',
        createAnyway: 'Luo silti',
        useExisting: 'Käytä olemassa olevaa',
      },
      createdAt: 'Luotu',
      updatedAt: 'Päivitetty',
      copyLink: 'Kopioi linkki',
      copyLinkFailed: 'Linkin kopiointi epäonnistui. Aktivoi tämä ikkuna ja yritä uudelleen.',
      linkCopied: 'Linkki kopioitu leikepöydälle',
      deleted: 'Poistettu',
      deleteFailed: 'Poisto epäonnistui',
      yes: 'Kyllä',
      no: 'Ei',
    },
    languages: {
      finnish: 'Suomi',
      english: 'English',
      swedish: 'Svenska',
    },
    customerService: {
      header: 'Asiakaspalvelu',
    },
    login: {
      header: 'Kirjaudu sisään',
      email: 'Sähköposti',
      password: 'Salasana',
      login: 'Kirjaudu',
      emailRequired: 'Sähköposti on pakollinen',
      emailInvalid: 'Sähköposti on virheellinen',
      passwordRequired: 'Salasana on pakollinen',
      showPassword: 'Näytä salasana',
      hidePassword: 'Piilota salasana',
      mfaHeader: 'Vahvista kirjautuminen',
      mfaDescription: 'Lähetimme kuusinumeroisen koodin osoitteeseen jolla kirjaudut. Syötä koodi alle.',
      mfaCodeLabel: 'Vahvistuskoodi',
      mfaCodeInvalid: 'Syötä kuusinumeroinen koodi',
      mfaSubmit: 'Jatka',
      mfaBack: 'Takaisin',
      mfaResend: 'Lähetä koodi uudelleen',
      mfaMethodTotp: 'Authenticator',
      mfaMethodEmail: 'Sähköposti',
      mfaMethodRecovery: 'Palautuskoodi',
    },
    register: {
      header: 'Rekisteröityminen',
      code: 'Kutsukoodi',
      firstName: 'Etunimi',
      lastName: 'Sukunimi',
      email: 'Sähköposti',
      phone: 'Puhelinnumero',
      password: 'Salasana',
      passwordAgain: 'Salasana uudelleen',
      passwordHint: 'Vähintään 8 merkkiä, joista vähintään yksi on iso kirjain, yksi on numero ja yksi erikoismerkki',
      register: 'Rekisteröidy',
      welcome: 'Tervetuloa käyttäjäksi!',
      codeInvalid: 'Kutsukoodi on virheellinen',
      codeAlreadyUsed: 'Kutsukoodi on jo käytetty',
      emailAlreadyInUse: 'Sähköposti on jo käytössä',
      invitationExistingUser:
        'Sinulle on kutsu sähköpostiin {{email}}. Kirjaudu sisään liittyäksesi yritykseen {{company}} roolilla {{role}}.',
      loginToAccept: 'Kirjaudu sisään',
      confirmJoinCompany: 'Haluatko liittyä yritykseen {{company}}? Sinulle annetaan rooli {{role}}.',
      joinCompany: 'Liity yritykseen',
      joinedCompanySuccess: 'Liityit yritykseen {{company}}',
      alreadyInCompany: 'Olet jo tämän yrityksen jäsen',
      emailMismatch: 'Kutsu ei ole tälle käyttäjätilille',
      emailMismatchDescription:
        'Kutsu on osoitettu sähköpostiin {{invitedEmail}}, mutta olet kirjautunut sisään osoitteella {{currentEmail}}. Kirjaudu ulos ja yritä uudelleen.',
    },
    auth: {
      backToLogin: 'Takaisin kirjautumiseen',
    },
    signature: {
      label: 'Allekirjoitus',
      importImage: 'Tuo kuva',
      takePhoto: 'Ota kuva',
      clear: 'Tyhjennä',
      instructions: 'Piirrä allekirjoituksesi yllä hiirellä tai kosketuksella',
    },
    handoverSignature: {
      pageTitle: 'Allekirjoituslaite',
      waiting: 'Ei avointa allekirjoituspyyntöä. Odota, kunnes aloitat allekirjoituksen tietokoneella.',
      signGive: 'Avaimen luovutus',
      signReturn: 'Avaimen palautus',
      submit: 'Lähetä allekirjoitus',
      submitted: 'Allekirjoitus lähetettiin tietokoneelle.',
      agreementToggle: 'Näytä sopimusteksti',
      keysToggle: 'Näytä avainlista',
      signOnDevice: 'Allekirjoitus laitteella',
      waitingForDevice: 'Odotetaan laitetta…',
      cancelDevice: 'Peruuta',
      permissionDenied: 'Sinulla ei ole oikeutta käyttää tätä sivua.',
      myPageHint:
        'Käytä tätä, kun allekirjoitus tehdään toisella laitteella (esim. tabletti) samalla käyttäjätunnuksella.',
      connectionIssue:
        'Palvelimeen ei saatu yhteyttä useaan kertaan peräkkäin. Tarkista yhteys ja yritä uudelleen. Jos aloitit jo luovutuksen tietokoneella, se voi näkyä onnistuneen uudelleenyrityksen jälkeen.',
      retryConnection: 'Yritä uudelleen',
      checkForRequest: 'Tarkista pyyntö',
      fullscreenEnter: 'Koko näyttö',
      fullscreenExit: 'Poistu koko näytöstä',
    },
    trash: {
      showDeleted: 'Näytä poistetut',
      deleted: 'Poistettu',
      deletedBanner:
        'Tämä kohde on poistettu. Et voi muokata tai poistaa sitä. Voit palauttaa sen alla olevalla painikkeella.',
      restore: 'Palauta',
      restoreConfirmTitle: 'Palautetaanko kohde?',
      restoreConfirmMessage: 'Haluatko varmasti palauttaa kohteen "{{name}}"?',
      restoreSuccess: 'Kohde palautettu',
      restoreDeadlineExpired: 'Palautusaika on umpeutunut',
      restoreDeadlineLastDay: 'Viimeinen palautuspäivä',
      restoreDeadlineOneDay: '1 päivä aikaa palauttaa',
      restoreDeadlineDays: '{{count}} päivää aikaa palauttaa',
      restoreWindowFileHint: 'Voit palauttaa tiedoston 7 päivän sisällä poistamisesta.',
    },
    tablePreferences: {
      columns: 'Sarakkeet',
      saveFilters: 'Tallenna suodattimet',
      columnsTitle: 'Taulukon sarakkeet',
      columnsDescription:
        'Järjestä vetämällä. Poista valinta piilottaaksesi sarakkeen. Uusia sarakkeita voi ilmestyä sovelluspäivitysten yhteydessä.',
      columnsSaved: 'Sarakkeiden asettelu tallennettu',
      filtersSaved: 'Suodattimet tallennettu',
      saveFailed: 'Taulukon asetusten tallennus epäonnistui',
      resetColumns: 'Palauta oletukset',
    },
    export: {
      noData: 'Ei vietävää dataa',
      success: 'Viedään {{count}} riviä',
      failed: 'Vienti epäonnistui',
      datePresets: {
        all: 'Kaikki',
        today: 'Tänään',
        thisMonth: 'Tässä kuussa',
        lastMonth: 'Viime kuussa',
        thisYear: 'Tänä vuonna',
        custom: 'Aikaväli',
      },
      audit: {
        title: 'Vie CSV-muotoon ({{target}})',
        heading: 'Vie tiedot ({{target}})',
        description: 'Valitse suodattimet ja aikaväli viedäksesi lokitiedot CSV-tiedostoon.',
        exportButton: 'Vie CSV',
      },
      columns: {
        id: 'ID',
        stamp: 'Leima',
        keyType: 'Avaintyyppi',
        lockType: 'Lukkotyyppi',
        apartment: 'Asunto',
        condominium: 'Taloyhtiö',
        listName: 'Listanimi',
        currentHolder: 'Nykyinen haltija',
        dueDate: 'Eräpäivä',
        received: 'Vastaanotettu',
        returned: 'Palautettu',
        lost: 'Kadonnut',
        tags: 'Tagit',
        firstName: 'Etunimi',
        lastName: 'Sukunimi',
        email: 'Sähköposti',
        phone: 'Puhelin',
        name: 'Nimi',
        addressStreet: 'Katuosoite',
        addressPostalCode: 'Postinumero',
        addressCity: 'Kaupunki',
        fullAddress: 'Koko osoite',
        businessId: 'Y-tunnus',
        superintendent: 'Hallinnoija',
        apartmentKeyType: 'Asuntoavaimen tyyppi',
        propertyType: 'Kiinteistötyyppi',
        identifier: 'Kiinteistötunnus',
        apartmentIdentifier: 'Tilatunnus',
        title: 'Otsikko',
        description: 'Kuvaus',
        status: 'Tila',
        priority: 'Prioriteetti',
        type: 'Tyyppi',
        requesterName: 'Pyytäjän nimi',
        requesterEmail: 'Pyytäjän sähköposti',
        requesterPhone: 'Pyytäjän puhelin',
        assignedTo: 'Vastuuhenkilö',
        createdAt: 'Luotu',
        updatedAt: 'Päivitetty',
        nextUpkeepDate: 'Seuraava',
        upkeepIntervalStart: 'Välin alku',
        upkeepIntervalEnd: 'Välin loppu',
        agreedDate: 'Sovittu päivä',
        effectiveDueDate: 'Eräpäivä',
        inspector: 'Vastuuhenkilö',
        assignee: 'Vastuuhenkilö',
        notes: 'Muistiinpanot',
        active: 'Aktiivinen',
        role: 'Rooli',
        company: 'Yritys',
        audit: {
          timestamp: 'Aikaleima',
          event: 'Tapahtuma',
          location: 'Sijainti',
          key: 'Avain',
          holder: 'Haltija',
          performedBy: 'Tekijä',
          entityType: 'Kohdetyyppi',
          action: 'Toiminto',
          entityName: 'Kohde',
        },
      },
    },
    search: {
      searchFailed: 'Haku epäonnistui. Yritä uudelleen.',
      noSearchResults: 'Ei hakutuloksia',
    },
    messagingInbox: {
      title: 'Viestit',
      description: 'Palvelupyynnöt, suorat viestit ja tiimikanavat.',
      newMessage: 'Uusi viesti',
      loadFailed: 'Viestien lataus epäonnistui.',
      emptyTitle: 'Ei keskusteluja',
      emptyDescription: 'Kun saat viestejä, ne näkyvät tässä.',
      searchPlaceholder: 'Hae osoitteella, nimellä tai viestillä',
      searchEmptyTitle: 'Ei hakutuloksia',
      searchEmptyDescription: 'Kokeile osoitetta, henkilön nimeä tai viestin sisältöä.',
      loadMore: 'Näytä lisää',
      loadingMore: 'Ladataan…',
      selectTitle: 'Valitse keskustelu',
      selectDescription: 'Valitse keskustelu listasta tai aloita uusi viesti.',
      openServiceRequest: 'Avaa palvelupyyntö',
      noMessages: 'Ei viestejä vielä.',
      peerUser: 'Vastaanottaja',
      peerUserPlaceholder: 'Valitse käyttäjä...',
      peerTeam: 'Tiimi',
      peerTeamPlaceholder: 'Valitse tiimi...',
      recipientType: 'Viestin tyyppi',
      recipientTypeUser: 'Käyttäjä',
      recipientTypeTeam: 'Tiimi',
      noTeams: 'Et kuulu vielä mihinkään tiimiin.',
      openTeamChannel: 'Avaa tiimikanava',
      startConversation: 'Aloita keskustelu',
      createDmFailed: 'Keskustelun aloitus epäonnistui.',
      filters: {
        all: 'Kaikki',
        unread: 'Lukemattomat',
        service_request: 'Palvelupyynnöt',
        staff_direct: 'Suorat',
        staff_team: 'Tiimit',
      },
      source: {
        service_request: 'Palvelupyyntö',
        staff_direct: 'Suora viesti',
        staff_team: 'Tiimikanava',
      },
    },
    notifications: {
      title: 'Muistutukset',
      empty: 'Ei mitään, joka vaatisi huomiotasi juuri nyt.',
      viewAll: 'Näytä kaikki',
      unreadMessages: 'Lukemattomat viestit',
      assignedToMe: 'Palvelupyynnöt',
      markRead: 'Merkitse luetuksi',
      markAllRead: 'Merkitse kaikki luetuiksi',
      dueSoonKeys: 'Pian erääntyvät avaimet',
      openKeyTasks: 'Avoimet avaintehtävät',
      pendingSignatures: 'Allekirjoitusta odottavat sopimukset',
      unconfirmedDeposits: 'Vahvistamattomat vakuudet',
      terminatingSoon: 'Pian päättyvät irtisanomiset',
      relistingRequested: 'Uudelleenlistauspyynnöt',
      newApplicants: 'Uudet hakijat',
      awaitingLandlord: 'Vuokranantajan vastattavat ehdotukset',
      acceptedCreateLease: 'Hakija hyväksytty – aloita sopimus',
      overdueInvoices: 'Erääntyneet vuokrauslaskut',
      overdueUpkeeps: 'Myöhässä olevat kunnossapidot',
      upcomingUpkeeps: 'Pian tulevat kunnossapidot',
    },
    general: {
      unknown: 'Tuntematon',
      error: 'Virhe',
      notFound: 'Tietoja ei löytynyt',
      open: 'Avaa',
      pcs: 'kpl',
      forgotPassword: 'Unohdin salasanani',
      backToLogin: 'Takaisin kirjautumiseen',
      appName: 'Xkey',
      logout: 'Kirjaudu ulos',
      profile: 'Profiili',
      lightMode: 'Vaalea teema',
      darkMode: 'Tumma teema',
      instructions: 'Ohjeet',
      search: 'Hae',
      searchGlobalPlaceholder: 'Hae kaikkialta…',
      searchTablePlaceholder: 'Suodata listaa…',
      noSearchResults: 'Ei hakutuloksia',
      noSearchResultsDescription: 'Ei tuloksia haulla "{{searchTerm}}". Kokeile muita hakusanoja.',
      clearSearch: 'Tyhjennä haku',
      searchShortcutHint: 'paina / hakeaksesi',
      openMenu: 'Avaa valikko',
      closeMenu: 'Sulje valikko',
      goToDashboard: 'Siirry työpöydälle',
      selectAllRows: 'Valitse kaikki rivit',
      selectRow: 'Valitse rivi',
      showMore: 'Näytä lisää',
      showLess: 'Näytä vähemmän',
      sortColumnActivate: 'Lajittele sarakkeen {{column}} mukaan',
      globalSearchShortcutHint: 'Cmd+K tai Ctrl+K hakeaksesi',
      searchStartTyping: 'Kirjoita hakusana hakeaksesi järjestelmästä',
      noResults: 'Ei tuloksia',
      more: 'Lisää',
      notAvailable: 'Ei saatavilla',
      searching: 'Etsitään',
      clear: 'Tyhjennä',
      select: 'Valitse...',
      dateFilterFrom: 'Alkaen',
      dateFilterTo: 'Asti',
      actions: 'Toiminnot',
      edit: 'Muokkaa',
      view: 'Näytä',
      delete: 'Poista',
      description: 'Kuvaus',
      save: 'Tallenna',
      saving: 'Tallennetaan...',
      processing: 'Käsitellään...',
      cancel: 'Peruuta',
      close: 'Sulje',
      loading: 'Ladataan...',
      tabs: 'Välilehdet',
      tabCount: '{{count}} välilehteä',
      moreTabs: 'Muut',
      download: 'Lataa',
      uploading: 'Ladataan...',
      errorOccurred: 'Tapahtui virhe',
      unknownError: 'Tuntematon virhe',
      company: 'Yritys',
      noApartments: 'Ei asuntoja',
      noCompanies: 'Ei yrityksiä',
      noInvitations: 'Ei kutsuja',
      noPermissions: 'Ei käyttöoikeuksia',
      noRoles: 'Ei rooleja',
      noResidents: 'Ei asukkaita',
      noKeys: 'Ei avaimia määritelty',
      notDefined: 'Ei määritelty',
      noRole: 'Ei roolia',
      noRoleDefined: 'Ei roolia määritelty',
      copyright: '© {{year}} Xkey. Kaikki oikeudet pidätetään.',
      owner: 'Omistaja',
      indefinite: 'Toistaiseksi',
      fixedTerm: 'Määräaika',
      sendEmail: 'Lähetä sähköposti',
      sendSms: 'Lähetä tekstiviesti',
      copyLink: 'Kopioi linkki',
      deleteDelayCountdown: 'Odota {{seconds}} sekuntia ennen poistamista',
      readyToDelete: 'Voit nyt poistaa kohteen',
      confirmDeleteMessage: 'Haluatko varmasti poistaa kohteen "{{name}}"? Tätä toimintoa ei voi peruuttaa.',
      deleteRole: 'Poista rooli',
      changePassword: 'Vaihda salasana',
      done: 'Valmis',
      loadingUserData: 'Ladataan käyttäjätietoja...',
      errorLoadingUserData: 'Virhe käyttäjätietojen lataamisessa',
      errorLoadingData: 'Virhe tietojen lataamisessa',
      workInfo: 'Työtiedot',
      displaySettings: 'Näyttöasetukset',
      displaySettingsGroupProperties: 'Kohteet ja avaimet',
      displaySettingsGroupTasks: 'Tarkastukset ja palvelupyynnöt',
      displaySettingsGroupRental: 'Vuokraus',
      displaySettingsGroupWidgets: 'Muut widgetit',
      behaviorSettings: 'Toiminta-asetukset',
      name: 'Nimi',
      weekdayMon: 'Ma',
      weekdayTue: 'Ti',
      weekdayWed: 'Ke',
      weekdayThu: 'To',
      weekdayFri: 'Pe',
      weekdaySat: 'La',
      weekdaySun: 'Su',
      previousMonth: 'Edellinen kuukausi',
      nextMonth: 'Seuraava kuukausi',
      previousYears: 'Edelliset vuodet',
      nextYears: 'Seuraavat vuodet',
      showYearPicker: 'Valitse vuosi',
      hour: 'Tunti',
      minute: 'Minuutti',
      listView: 'Lista',
      calendarView: 'Kalenteri',
      calendarSpan: 'Kalenterinäkymä',
      calendarSpanMonth: 'Kuukausi',
      calendarSpanWeek: 'Viikko',
      calendarSpanDay: 'Päivä',
      previousWeek: 'Edellinen viikko',
      nextWeek: 'Seuraava viikko',
      previousDay: 'Edellinen päivä',
      nextDay: 'Seuraava päivä',
      email: 'Sähköposti',
      phoneNumber: 'Puhelinnumero',
      role: 'Rooli',
      showMyProperties: 'Näytä omat',
      showMineOnly: 'Näytä omat',
      mineFilterShort: 'Omat',
      emptyFilterShort: 'Tyhjät',
      showMyKeys: 'Näytä omat avaimet',
      showBorrowedKeys: 'Näytä kaikki lainatut avaimet',
      showLateKeys: 'Näytä myöhässä olevat avaimet',
      showMissingKeys: 'Näytä kadonneet avaimet',
      showUpkeeps: 'Näytä tulevat kunnossapidot',
      showServiceRequests: 'Näytä palvelupyynnöt',
      showEvents: 'Näytä tapahtumat',
      showFavorites: 'Näytä suosikit',
      showReadyToTransferKeys: 'Näytä luovutusvalmiit avaimet',
      showCalendar: 'Näytä kalenteri',
      showTodoList: 'Näytä tehtävälista',
      showKeyHistoryTasks: 'Näytä luovutustehtävät',
      showRentalLeaseOverview: 'Näytä vuokrasopimusten tilannekatsaus',
      showBrokerageAgreements: 'Näytä välityssopimusten tilannekatsaus',
      enableDeleteDelay: 'Käytä poiston vahvistusviivettä',
      enableDeleteDelayDescription: 'Vaadi 5 sekunnin odotus ennen poiston vahvistamista',
      showBulkDelete: 'Näytä massapoisto-taulukoissa',
      showBulkDeleteDescription:
        'Mahdollistaa usean kohteen valinnan ja poiston asunnoissa, asukkaissa, taloyhtiöissä ja avaimissa.',
      receiveAnnouncementEmails: 'Vastaanota ilmoitukset sähköpostitse',
      receiveAnnouncementEmailsDescription: 'Saat sähköposti-ilmoituksen, kun uusi ilmoitus julkaistaan',
    },
    quickCreate: {
      fabLabel: 'Luo uusi',
      title: 'Luo uusi',
      searchPlaceholder: 'Hae luotavaa…',
      noResults: 'Ei hakutuloksia',
      groups: {
        properties: 'Kohteet',
        keys: 'Avaimet',
        services: 'Palvelut',
        maintenance: 'Kunnossapito',
        rental: 'Vuokraus',
        other: 'Muut',
      },
    },
    assistant: {
      fabLabel: 'Tekoälyavustaja',
      title: 'Tekoälyavustaja',
      placeholder: 'Kysy käytöstä, luo asukas tai avain, tai pyydä antamaan avain…',
      send: 'Lähetä',
      close: 'Sulje',
      newConversation: 'Uusi keskustelu',
      you: 'Sinä',
      thinking: 'Haetaan tietoja…',
      error: 'Avustaja ei vastannut. Yritä uudelleen.',
      emptyReply: 'Vastausta ei saatu. Yritä kysyä uudelleen.',
      openResident: 'Avaa asukas',
      openKey: 'Avaa avain',
      tabs: {
        chat: 'Keskustelu',
      },
      suggestionsLabel: 'Kokeile esimerkiksi',
      suggestions: {
        help: 'Miten lisään asukkaan?',
        create: 'Luo asukas Teppo Testaaja',
        give: 'Anna tämä avain asukkaalle',
      },
      confirm: {
        title: 'Vahvista muutos',
        accept: 'Vahvista',
        cancel: 'Peru',
        accepted: 'Vahvistin toiminnon.',
        cancelled: 'Peruin toiminnon.',
        createResident: 'Luon asukkaan {{firstName}} {{lastName}} asuntoon {{apartmentLabel}}.',
        createResidentDuplicate: 'Samanniminen asukas on jo olemassa. Luodaanko {{firstName}} {{lastName}} silti?',
        createKey: 'Luon asunnon avaimen kohteeseen {{place}}.',
        createKeyGeneral: 'Luon yleisavaimen kohteeseen {{place}}.',
        updateResident: 'Päivitän asukkaan {{residentName}} tiedot.',
        giveKey: 'Annan avaimen {{keyStamp}} asukkaalle {{residentName}}.',
        returnKey: 'Palautan avaimen {{keyStamp}} toimistolle.',
      },
    },
    dashboard: {
      myKeys: 'Minulla lainassa olevat avaimet',
      lateKeys: 'Myöhässä olevat avaimet',
      missingKeys: 'Kateissa olevat avaimet',
      borrowedKeys: 'Lainassa olevat avaimet',
      retryAction: 'Yritä uudelleen',
      myManagedProperties: 'Minun hallinnoimani taloyhtiöt',
      noProperties: 'Ei taloyhtiöitä näytettäväksi',
      noKeys: 'Ei avaimia näytettäväksi',
      dragToReorder: 'Vedä muuttaaksesi järjestystä',
      makeTwoColumnsWide: 'Tee kahden sarakkeen levyiseksi',
      makeOneColumnWide: 'Tee yhden sarakkeen levyiseksi',
      available: 'Vapaa',
      dueDate: 'Palautettava',
      editLayout: 'Muokkaa asettelua',
      exitEditMode: 'Valmis',
      resetLayout: 'Palauta oletusasettelu',
      hideWidget: 'Piilota widgetti',
      showWidget: 'Näytä widgetti',
      hiddenWidgets: 'Piilotetut widgetit',
      focusMode: 'Keskittymistila',
      focusModeTooltip: 'Piilottaa widgetit, joissa ei ole tietoja',
      calendar: 'Kalenteri',
      todoList: 'Tehtävälista',
      todoListPlaceholder: 'Lisää tehtävä...',
      todoListEmpty: 'Ei tehtäviä. Lisää uusi yllä.',
      todoDueDate: 'Päivämäärä',
      todoCalendarEvent: 'Tehtävä',
      todoDone: 'Tehty',
      keyHistoryTasks: {
        title: 'Luovutustehtävät',
        empty: 'Ei avoimia luovutustehtäviä.',
        columns: {
          task: 'Tehtävä',
          location: 'Kohde',
          holder: 'Haltija',
          createdAt: 'Luotu',
        },
      },
      rentalLeaseOverview: {
        title: 'Vuokrasopimusten tilanne',
        empty: 'Ei avoimia vuokrasopimuksia',
        noAttention: 'Kaikki avoimet sopimukset ovat kunnossa',
        openCount: 'Näytä {{label}} ({{count}})',
        noticeEndsOn: 'Irtisanomisaika päättyy {{date}}',
        columnItem: 'Kohde',
        columnAttention: 'Huomio',
        columnDetail: 'Lisätieto',
        counts: {
          acceptedWithoutLease: 'Sopimus odottaa',
          depositUnconfirmed: 'Vakuus avoinna',
          overdueInvoices: 'Erääntyneet',
          unsentBrokerageFees: 'Palkkio lähettämättä',
        },
        attention: {
          create_lease: 'Aloita sopimus',
          pending_signature: 'Odottaa allekirjoitusta',
          final_inspection_pending: 'Sovi lopputarkastus',
          keys_not_returned: 'Avaimet palauttamatta',
          deposit_unconfirmed: 'Vakuus vahvistamatta',
          terminating: 'Irtisanottu',
          overdueInvoice: 'Erääntynyt lasku',
          unsentBrokerageFee: 'Välityspalkkio lähettämättä',
          relisting_requested: 'Luonnosilmoitus on tehty',
        },
      },
      brokerageAgreements: {
        title: 'Välityssopimusten tilanne',
        empty: 'Ei välityssopimuksia',
        noAttention: 'Kaikki välityssopimukset ovat kunnossa',
        openCount: 'Näytä {{label}} ({{count}})',
        columnAttention: 'Huomio',
        counts: {
          draft: 'Luonnos',
          pendingSignature: 'Allekirjoitus',
          active: 'Aktiivinen',
          ended: 'Päättynyt',
          unsentBrokerageFees: 'Palkkio lähettämättä',
        },
        attention: {
          pending_signature: 'Odottaa allekirjoitusta',
          unsigned_draft: 'Allekirjoittamaton luonnos',
          unsent_brokerage_fee: 'Välityspalkkio lähettämättä',
        },
      },
      serviceRequests: 'Palvelupyynnöt',
      readyToTransferKeys: {
        title: 'Esivalmistellut avaimet',
        noCarts: 'Ei esivalmisteltuja avaimia',
        addCarts: 'Valmistele avaimia tallentamalla ostoskori',
        keyCount_one: '{{count}} avain',
        keyCount_other: '{{count}} avainta',
        noResident: 'Ei vastaanottajaa',
        searchPlaceholder: 'Hae vastaanottajan nimellä...',
        noResults: 'Ei tuloksia haulle',
        complete: 'Viimeistele',
        completeReturn: 'Viimeistele palautus',
      },
    },
    favorites: {
      title: 'Suosikit',
      noFavorites: 'Ei suosikkeja',
      addFavorite: 'Lisää suosikkeja klikkaamalla tähti-ikonia',
      noContact: 'Ei yhteystietoja',
      unknownLocation: 'Tuntematon sijainti',
      remove: 'Poista suosikeista',
      markAsFavorite: 'Merkitse suosikiksi',
    },
    pagination: {
      page: 'Sivu',
      previousPage: 'Edellinen sivu',
      nextPage: 'Seuraava sivu',
    },
    contractor: {
      addAccess: 'Lisää käyttöoikeus',
      editAccess: 'Muokkaa käyttöoikeutta',
      accessType: 'Käyttöoikeuden tyyppi',
      property: 'Taloyhtiö',
      apartment: 'Asunto',
      key: 'Avain',
      companyScope: 'Kaikki kiinteistöt',
      companyScopeTarget: 'Kaikki yrityksen kiinteistöt',
      companyScopeHelp:
        'Myöntää pääsyn kaikkiin nykyisiin ja tuleviin kiinteistöihin tässä yrityksessä. Uusia kiinteistöjä ei tarvitse lisätä erikseen.',
      companyAccessAlreadyExists: 'Yritystason käyttöoikeus on jo olemassa tälle käyttäjälle.',
      grantAllAccess: 'Anna kaikki oikeudet',
      grantAllAccessConfirm:
        'Myönnetään yritystason käyttöoikeus kaikkiin nykyisiin ja tuleviin kiinteistöihin, mukaan lukien asukkaat, avaimet, palvelupyynnöt ja tarkastukset.',
      grantAllAccessFailed: 'Kaikkien oikeuksien myöntäminen epäonnistui.',
      selectProperty: 'Valitse taloyhtiö',
      selectApartment: 'Valitse asunto',
      selectKey: 'Valitse avain',
      searchTargets: 'Hae kohteita...',
      targetsShown: '{{count}} kohdetta',
      selectAllShown: 'Valitse kaikki näkyvät',
      selectAllAccess: 'Valitse kaikki',
      bulkAccessSuccess: 'Käyttöoikeudet tallennettu: {{created}} luotu, {{skipped}} ohitettu.',
      bulkAccessFailed: 'Käyttöoikeuksien tallennus epäonnistui.',
      copyAccess: 'Kopioi käyttöoikeudet',
      copyAccessHelp: 'Kopioi käyttäjän {{name}} voimassa olevat käyttöoikeudet valituille ulkopuolisille toimijoille.',
      copyAccessTargets: 'Kohdekäyttäjät',
      copyAccessSubmit: 'Kopioi',
      copyAccessSuccess: 'Käyttöoikeudet kopioitu: {{created}} luotu, {{skipped}} ohitettu.',
      copyAccessFailed: 'Käyttöoikeuksien kopiointi epäonnistui.',
      accessListTitle: 'Käyttöoikeudet',
      espAccessSectionTitle: 'Ulkopuolisen toimijan käyttöoikeudet',
      noAccessDefined: 'Ei käyttöoikeuksia määritelty',
      noAccessDefinedHint: 'Lisää käyttöoikeuksia yllä olevalla painikkeella',
      keyAccessFilterCondominiumPlaceholder: 'Kaikki taloyhtiöt',
      keyAccessFilterApartmentPlaceholder: 'Kaikki asunnot',
      description: 'Kuvaus',
      descriptionPlaceholder: 'Lisätietoja käyttöoikeudesta...',
      validUntil: 'Viimeinen voimassaolopäivä',
      validUntilHelper: 'Tyhjä = ei päättymispäivää. Päivä on mukaan lukien (myös valittu päivä).',
      noExpiry: 'Ei päättymispäivää',
      accessStatus: 'Tila',
      accessValid: 'Voimassa',
      accessExpired: 'Vanhentunut',
    },
    contractorDashboard: {
      inspections: 'Tarkastukset',
      properties: 'Taloyhtiöt',
      apartments: 'Asunnot',
      keys: 'Avaimet',
      additionalInfo: 'Lisätiedot',
      noItems: 'Ei käytettävissä olevia kohteita',
      noItemsDescription: 'Sinulle ei ole vielä myönnetty käyttöoikeuksia mihinkään kohteisiin.',
      upkeep: 'Kunnossapito',
      noUpkeeps: 'Ei kunnossapitoa',
      noUpkeepsDescription: 'Sinulla ei ole saatavilla kunnossapitoa käyttöoikeuksiesi piirissä.',
    },
    externalServiceProviderDashboard: {
      attentionCount: 'Vaatii huomiota ({{count}})',
      allUpkeepCount: 'Kaikki ({{count}})',
      noAttentionUpkeeps: 'Ei huomiota vaativia tehtäviä',
      showAllUpkeepCount: 'Näytä kaikki ({{count}})',

      title: 'Ulkopuolinen toimija',
      errorLoading: 'Virhe ladattaessa tietoja',
      tryRefresh: 'Yritä päivittää sivu',
      serviceRequests: 'Palvelupyynnöt',
      noServiceRequests: 'Ei palvelupyyntöjä',
      noServiceRequestsDescription: 'Sinulle ei ole vielä osoitettu palvelupyyntöjä.',
      removeUpkeep: 'Lopeta käsittely',
      removeUpkeepConfirm:
        'Haluatko varmasti lopettaa käsittelyn tarkastukselle "{{inspectionName}}"? Sinut poistetaan käsittelijänä tältä tarkastukselta.',
      assignUpkeep: 'Ota käsiteltäväksi',
      removeServiceRequest: 'Poista palvelupyyntö',
      removeServiceRequestConfirm:
        'Haluatko varmasti poistaa tämän käyttäjän palvelupyynnöstä "{{serviceRequestTitle}}"?',
      changeStatus: 'Muuta tilaa',
      noMessages: 'Ei viestejä vielä.',
      announcements: 'Ilmoitukset',
    },
    companies: {
      title: 'Yritykseni',
    },
    company: {
      exportAllData: 'Vie kaikki tiedot (ZIP)',
      exportPreparing: 'Valmistellaan vientiä…',
      exportFailed: 'Yrityksen tietojen vienti epäonnistui',

      companies: 'Yritykset',
      companyDetails: 'Yrityksen tiedot',
      selectCompany: 'Valitse yritys',
      name: 'Nimi',
      address: 'Osoite',
      fullAddress: 'Osoite',
      email: 'Sähköposti',
      phone: 'Puhelinnumero',
      emailPlaceholder: 'info@yritys.fi',
      phonePlaceholder: '+358 40 123 4567',
      create: 'Luo yritys',
      edit: 'Muokkaa yritystä',
      deleteTitle: 'Poista yritys',
      deleteMessage: 'Haluatko varmasti poistaa yrityksen "{{name}}"? Tätä toimintoa ei voi peruuttaa.',
      keyAgreement: 'Avainsopimus',
      invoiceIban: 'Laskutuksen IBAN',
      invoiceBic: 'Laskutuksen BIC',
      defaultVatPercent: 'Oletus-ALV (%)',
      street: 'Katuosoite',
      postalCode: 'Postinumero',
      city: 'Postitoimipaikka',
      cancel: 'Peruuta',
      notFound: 'Yritystä ei löytynyt',
      noKeyAgreement: 'Ei avainsopimusta',
      translationType: 'Käännöstyyppi',
      selectTranslationType: 'Valitse käännöstyyppi...',
      translationTypeHousingAptResident: 'Taloyhtiö / Asunto / Asukas',
      translationTypePropertyAptResident: 'Kiinteistö / Asunto / Asukas',
      translationTypePropertySpacePerson: 'Kiinteistö / Tila / Henkilö',
      namePlaceholder: 'Esim. Taloyhtiö Oy Kauppakatu',
      streetPlaceholder: 'Esim. Kauppakatu 1',
      postalCodePlaceholder: '00100',
      cityPlaceholder: 'Helsinki',
      keyAgreementPlaceholder: 'Avainsopimuksen sisältö...',
      loadingCompanies: 'Ladataan yrityksiä...',
      searchPlaceholder: 'Hae yrityksiä...',
      slugLabel: 'Portaalien osoite',
      slugDescription:
        'Asukas- ja vuokranantajaportaalien URL-osoite. Vain pieniä kirjaimia, numeroita ja väliviivoja.',
      slugEdit: 'Vaihda osoite',
      slugPlaceholder: 'esim. yritys-oy',
      slugAvailable: 'Osoite on vapaana',
      slugUnavailable: 'Osoite on jo käytössä',
      slugSave: 'Tallenna osoite',
      publicListingBaseUrl: 'Vuokraussivuston osoite',
      publicListingBaseUrlHint:
        'Julkiset ilmoituslinkit osoittavat tähän sivustoon (esim. https://vuokraus.xkey.fi/asunnot/…). Tyhjä käyttää xkeyn /vuokraus/:token -polkua.',
      oikotieEnabled: 'Oikotie käytössä',
      oikotieEnabledDescription:
        'Kun käytössä, vuokrailmoituksia voi julkaista Oikotiehen ilmoituksen Oikotie-välilehdeltä (edellyttää vuokrausta).',
      oikotieSettings: 'Oikotie',
      oikotieSettingsHint:
        'Kopioi API-avain ja yritystunnus Oikotien yritystiedoista (API-avain -sivu). Julkaisu voi vaatia listing-oikeudet Oikotielta.',
      oikotieCompanyId: 'Oikotie-yritystunnus',
      oikotieCompanyIdHint: 'Näkyy Oikotien osoitepalkissa välilehdellä API-avain, esim. …/yritystiedot/api/24864801.',
      oikotieApiKey: 'Oikotie API-avain',
      oikotieApiKeyPlaceholder: 'Liitä API-avain',
      oikotieApiKeyConfiguredPlaceholder: 'Jätä tyhjäksi säilyttääksesi nykyisen avaimen',
      oikotieApiKeyConfigured: 'API-avain on tallennettu.',
      oikotieApiKeyMissing: 'API-avainta ei ole vielä tallennettu.',
      oikotieClearApiKey: 'Poista API-avain',
      oikotieTestConnection: 'Testaa yhteys',
      oikotieConnectionOk: 'Oikotie-yhteys toimii',
      oikotieConnectionFailed: 'Oikotie-yhteyden testaus epäonnistui',
      branding: {
        title: 'Brändäys',
        description:
          'Mukauta asukas- ja vuokranantajaportaalien sekä vuokrauksen julkisten sivujen ulkoasua. Staff-sovellus säilyy Xkey-brändillä.',
        displayName: 'Näyttönimi',
        displayNameHint: 'Jos tyhjä, käytetään yrityksen nimeä.',
        primaryColor: 'Pääväri',
        primaryColorHint:
          'Painikkeet, linkit, korostukset ja sivun taustasävy portaaleissa sekä vuokrauksen julkisilla sivuilla.',
        navbarColor: 'Yläpalkin väri',
        navbarColorHint: 'Asukas-, vuokranantaja- ja ESP-portaalin sekä vuokrauksen julkisten sivujen yläpalkki.',
        textColor: 'Tekstin väri',
        textColorHint: 'Sisällön perusfontti portaaleissa ja vuokrauksen julkisilla sivuilla. Tyhjä = teeman oletus.',
        navbarTextColor: 'Navigaation tekstin väri',
        navbarTextColorHint:
          'Yläpalkin otsikot, painikkeet ja valikko (portaalit ja vuokrauksen julkiset sivut). Tyhjä = automaattinen kontrasti.',
        previewNavbar: 'Yläpalkin esikatselu',
        previewBody: 'Sisällön tekstin esikatselu',
        invalidColor: 'Värin on oltava muodossa #RRGGBB.',
        logo: 'Logo',
        logoHint: 'PNG, JPEG tai WebP. Näkyy portaaleissa ja vuokrauksen julkisilla sivuilla.',
        uploadLogo: 'Lataa logo',
        removeLogo: 'Poista logo',
        save: 'Tallenna brändäys',
        reset: 'Nollaa brändäys',
        resetConfirmTitle: 'Nollaa brändäys?',
        resetConfirmMessage:
          'Näyttönimi, värit ja logo poistetaan. Portaalit ja julkiset vuokraussivut palaavat Xkey-oletuksiin ja yrityksen nimeen.',
      },
      optionalServices: 'Valinnaiset palvelut',
      optionalServicesModules: 'Moduulit',
      optionalServicesOther: 'Muut',
      propertiesEnabled: 'Kohteet käytössä',
      propertiesEnabledDescription: 'Kun käytössä, käyttäjät voivat hallita taloyhtiöitä, asuntoja ja asukkaita.',
      keysEnabled: 'Avaimet käytössä',
      keysEnabledDescription: 'Kun käytössä, käyttäjät voivat hallita avaimia sekä luovutuksia ja palautuksia.',
      serviceRequestsEnabled: 'Palvelupyynnöt käytössä',
      serviceRequestsEnabledDescription:
        'Kun palvelupyynnöt on käytössä, käyttäjät voivat luoda ja hallinnoida palvelupyyntöjä.',
      maintenanceEnabled: 'Kunnossapito käytössä',
      maintenanceEnabledDescription:
        'Kun kunnossapito on käytössä, käyttäjät voivat hallita kunnossapitoa, kunnossapitotarveselvitystä ja korjaushistoriaa.',
      smsEnabled: 'SMS-viestit käytössä',
      smsEnabledDescription:
        'Kun SMS-viestit on käytössä, käyttäjät voivat lähettää tekstiviestejä avainten luovutuksissa ja palautuksissa.',
      apiTokensEnabled: 'API-tunnukset käytössä',
      apiTokensEnabledDescription:
        'Kun API-tunnukset ovat käytössä, oikeuksien omaavat käyttäjät voivat luoda henkilökohtaisia API-tunnuksia Oma sivu -näkymässä integraatioita varten.',
      measurementsEnabled: 'Mittaukset käytössä',
      measurementsEnabledDescription:
        'Kun mittaukset ovat käytössä, vedenkulutusmittaukset näkyvät ja niitä voidaan hallita asunnonäkymässä sekä asukas- ja vuokranantajaportaaleissa.',
      reportsEnabled: 'Analytiikkasivu käytössä',
      reportsEnabledDescription: 'Kun analytiikkasivu on käytössä, käyttäjät voivat tarkastella ja viedä raportteja.',
      conversationalBiEnabled: 'Keskustelu datan kanssa käytössä',
      conversationalBiEnabledDescription:
        'Kun keskustelu datan kanssa on käytössä, käyttäjät voivat kysyä analytiikkasivulla kysymyksiä yrityksen datasta. Vaatii analytiikkasivun.',
      assistantEnabled: 'Tekoälyavustaja käytössä',
      assistantEnabledDescription:
        'Kun käytössä, oikeaan alakulmaan tulee avustaja. Se vastaa käyttöohjeen perusteella, hakee yhteystietoja sekä voi luoda asukkaan tai avaimen ja antaa tai palauttaa avaimen.',
      billingEnabled: 'Laskutus käytössä',
      billingEnabledDescription:
        'Kun laskutus on käytössä, käyttäjät voivat hallita asiakkuuksia ja luoda laskutusesikatseluita.',
      documentBankEnabled: 'Tiedostot käytössä',
      documentBankEnabledDescription:
        'Kun käytössä, käyttäjät voivat hallita dokumenttipankkia, liitteitä ja ilmoitusmedioita, sekä nähdä tiedostoja portaaleissa.',
      trackedAssetsEnabled: 'Laitteet ja QR käytössä',
      trackedAssetsEnabledDescription: 'Kun käytössä, käyttäjät voivat hallita laitteita ja QR-koodeja.',
      portalsEnabled: 'Portaalit käytössä',
      portalsEnabledDescription:
        'Kun käytössä, asukas- ja vuokranantajaportaalit ovat käytettävissä (kirjautuminen, QR-linkit ja aukioloajat).',
      rentalBrokerageEnabled: 'Vuokraus käytössä',
      rentalBrokerageEnabledDescription: 'Kun käytössä, käyttäjät voivat hallita vuokranantajia ja vuokrausprosessia.',
      reminders: {
        title: 'Muistutukset',
        description:
          'Määritä, milloin avaimen palautuksesta ja ylläpidosta lähtee muistutus. Oletuksena muistutus lähtee päivää ennen eräpäivää.',
        keyReturn: 'Avaimen palautus',
        keyReturnDescription: 'Viesti lähtee avaimen haltijalle.',
        upkeep: 'Ylläpito',
        upkeepDescription:
          'Viesti lähtee tekijälle. Jos tekijää ei ole, viesti lähtee käyttäjille, joilla ilmoitussähköpostit ovat päällä.',
        enabled: 'Ajastetut muistutukset käytössä',
        enabledDescription: 'Kun pois päältä, tästä ei lähde ajastettuja sähköposteja eikä tekstiviestejä.',
        leadDays: 'Ennen eräpäivää',
        leadDaysHint: 'Muistutus lähtee valittuina päivinä ennen eräpäivää. Voit valita useamman.',
        leadDay1: '1 päivä ennen',
        leadDay3: '3 päivää ennen',
        leadDay7: '7 päivää ennen',
        overdueEvery: 'Myöhässä',
        overdueEveryOff: 'Ei myöhästymismuistutuksia',
        overdueEvery1: 'Joka päivä',
        overdueEveryN: '{{count}} päivän välein',
        overdueMax: 'Kerroista enintään',
        overdueMaxN: '{{count}} kertaa',
        overdueHint:
          'Myöhästymismuistutukset loppuvat, kun enimmäismäärä on täynnä. Eräpäivän siirto aloittaa laskurin alusta.',
      },
      documentBankTemplateStructuresTitle: 'Oletushakemistorakenteet',
      documentBankTemplateStructuresDescription:
        'Määritä erilliset oletushakemistorakenteet kiinteistöille ja asunnoille. Muutokset synkronoidaan lisäämällä puuttuvat oletuskansiot olemassa oleviin kohteisiin.',
      documentBankCondominiumTemplateTitle: 'Kiinteistöjen oletushakemistorakenne',
      documentBankCondominiumTemplateDescription:
        'Kun rakennetta muokataan, puuttuvat oletuskansiot synkronoidaan kaikkiin olemassa oleviin kiinteistöihin.',
      documentBankApartmentTemplateTitle: 'Asuntojen oletushakemistorakenne',
      documentBankApartmentTemplateDescription:
        'Kun rakennetta muokataan, puuttuvat oletuskansiot synkronoidaan kaikkiin olemassa oleviin asuntoihin.',
      subcompanyInfo: 'Uudet yritykset luodaan aliyrityksiksi yritykselle {{name}}.',
      subcompany: 'Alayritys',
      selectedCompanyChanged: 'Valittu yritys vaihdettiin: {{name}}',
      membershipCompanyFallback: 'Yritys {{id}}',
      openingHours: {
        title: 'Aukioloajat',
        description:
          'Aseta viikoittaiset aukioloajat ja poikkeuspäivät. Näkyvät asukas- ja vuokranantajaportaaleissa, kun portaalit ovat käytössä.',
        enabled: 'Aukioloajat käytössä',
        enabledDescription:
          'Kun pois päältä, aukioloajat eivät näy portaaleissa eikä päiväasetuksia näytetä tällä sivulla.',
        weekdays: {
          monday: 'Maanantai',
          tuesday: 'Tiistai',
          wednesday: 'Keskiviikko',
          thursday: 'Torstai',
          friday: 'Perjantai',
          saturday: 'Lauantai',
          sunday: 'Sunnuntai',
        },
        open: 'Auki',
        closed: 'Kiinni',
        openTime: 'Avautuu',
        closeTime: 'Sulkeutuu',
        saveWeekly: 'Tallenna aukioloajat',
        exceptions: 'Poikkeuspäivät',
        noExceptions: 'Ei poikkeuspäiviä.',
        addException: 'Lisää poikkeuspäivä',
        editException: 'Muokkaa poikkeuspäivää',
        date: 'Päivämäärä',
        exceptionLabel: 'Nimi',
        closedAllDay: 'Suljettu koko päivän',
        invalidTimeRange: 'Sulkeutumisaika pitää olla avautumisen jälkeen',
        suggestHolidays: 'Ehdota pyhäpäiviä',
        suggestHolidaysDescription:
          'Suomen kalenterin mukaiset pyhäpäivät vuodelle {{year}}. Valitse päivät ja merkitse ne suljetuiksi tai aseta poikkeavat aukioloajat.',
        acceptSelected: 'Lisää valitut',
        alreadyAdded: 'jo lisätty',
        noSuggestions: 'Ei ehdotuksia.',
        selectAll: 'Valitse kaikki',
        customHours: 'Poikkeavat aukioloajat',
        deleteExceptionTitle: 'Poista poikkeuspäivä',
        deleteExceptionMessage: 'Haluatko poistaa poikkeuspäivän "{{label}}"?',
        portalOpen: 'Avoinna',
        portalClosed: 'Suljettu',
        portalOpenNow: 'Avoinna nyt',
        portalClosedNow: 'Suljettu nyt',
        portalToday: 'Tänään: {{label}}',
        portalWeeklySummary: 'Normaalisti: {{summary}}',
      },
    },
    myPage: {
      apiAccessTitle: 'API-käyttö',
      apiAccessDescription:
        'Voit luoda henkilökohtaisen API-tunnuksen, jonka avulla integraatiot voivat kutsua samoja taustajärjestelmän rajapintoja kuin sinä selaimessa. Säilytä tunnus turvallisesti ja kohtele sitä kuten salasanaa.',
      apiAccessTokenPlaceholder: 'henkilokohtainen-api-tunnus',
      apiAccessNoTokenInfo:
        'Sinulla ei ole tällä hetkellä henkilökohtaista API-tunnusta. Luo tunnus, jos haluat integroida Xkeyn toiseen järjestelmään.',
      apiAccessExistingTokenInfo:
        'Sinulla on jo henkilökohtainen API-tunnus. Luotu: {{createdAt}}. Viimeksi käytetty: {{lastUsedAt}}.',
      generateApiToken: 'Luo API-tunnus',
      regenerateApiToken: 'Luo uusi API-tunnus',
      revokeApiToken: 'Poista API-tunnus käytöstä',
      apiTokenSecurityWarning:
        'Henkilökohtaiset API-tunnukset antavat saman tason käyttöoikeudet kuin käyttäjätunnuksesi. Säilytä tunnus turvallisesti, vaihda se säännöllisesti ja poista se heti käytöstä, jos epäilet sen vuotaneen.',
      apiAccessNewTokenLabel: 'Uusi API-tunnus (näytetään vain kerran)',
      apiAccessNewTokenHint:
        'Kopioi tunnus ja tallenna se turvallisesti. Et näe tätä tunnusta uudelleen tämän jälkeen.',
      mfaTitle: 'Kaksivaiheinen kirjautuminen',
      mfaToggle: 'Käytä kertakoodia sähköpostilla',
      mfaEmailDisabledWhenTotp:
        'Sähköpostivahvistus ei ole käytettävissä, kun Authenticator on käytössä. Poista Authenticator ensin käytöstä.',
      mfaDescription:
        'Kun tämä on päällä, tarvitset kirjautuessa salasanan lisäksi kertakäyttökoodin, joka lähetetään sähköpostiisi.',
      totpTitle: 'Authenticator-sovellus',
      totpDescription: 'Käytä Microsoft/Google Authenticator -tyyppistä sovellusta kirjautumisen vahvistukseen.',
      totpEnable: 'Ota käyttöön',
      totpDisable: 'Poista käytöstä',
      totpSetupTitle: 'Ota Authenticator käyttöön',
      totpSetupDescription: 'Skannaa QR-koodi authenticator-sovelluksella ja syötä sen jälkeen 6-numeroinen koodi.',
      totpVerifyLabel: 'Authenticator-koodi',
      totpEnabled: 'Authenticator otettu käyttöön',
      totpEnableFailed: 'Authenticatorin käyttöönotto epäonnistui',
      totpSetupStartFailed: 'Authenticator-asetuksen aloitus epäonnistui',
      totpQrAlt: 'Authenticator QR-koodi',
      totpQrLoading: 'Ladataan QR-koodia…',
      totpManualSecret: 'Manuaalinen avain (jos et voi skannata QR-koodia)',
      recoveryCodesIntro:
        'Tallenna palautuskoodit turvalliseen paikkaan. Voit käyttää niitä kirjautumiseen, jos et pääse authenticator-sovellukseen. Koodit näytetään vain kerran.',
      recoveryCodesDownload: 'Lataa tiedostona',
      recoveryCodesRegenerate: 'Luo uudet palautuskoodit',
      recoveryRegenerateFailed: 'Palautuskoodien luonti epäonnistui',
    },
    invitations: {
      email: 'Sähköposti',
      created: 'Luotu',
      edit: 'Muokkaa',
      delete: 'Poista',
      deleteConfirmMessage: 'Haluatko varmasti poistaa kutsun "{{email}}"? Tätä toimintoa ei voi peruuttaa.',
      searchInvitations: 'Hae kutsuja...',
      createInvitation: 'Luo kutsu',
      editInvitation: 'Muokkaa kutsua',
      sendInvitation: 'Lähetä kutsu',
      createNew: 'Luo uusi kutsu',
      role: 'Rooli',
      selectRole: 'Valitse rooli...',
      status: 'Tila',
      accepted: 'Hyväksytty',
      expired: 'Vanhentunut',
      invitations: 'Kutsut',
      condominium: 'Taloyhtiö',
      apartment: 'Tila',
      key: 'Avain',
      company: 'Kaikki kiinteistöt',
      contractor: 'Ulkopuolinen toimija',
      externalActorDescription:
        'Ulkopuolisella toimijalla on rajoitetut käyttöoikeudet kohteisiin sekä pääsy palvelupyyntöihin. Lisää tarvittaessa käyttöoikeudet alle rajataksesi pääsyn tiettyihin taloyhtiöihin, tiloihin tai avaimiin.',
      externalServiceProvider: 'Ulkopuolinen toimija',
      yes: 'Kyllä',
      no: 'Ei',
      cannotBeInvited: 'ei voida kutsua',
      extraPermissions: 'Lisäoikeudet',
      canDoUpkeeps: 'Voi tehdä tarkastuksia',
      canRespondToServiceRequests: 'Voi vastata palvelupyyntöihin',
      canSeeResidents: 'Näkee asukkaat',
      canAccessAllApartments: 'Pääsy kaikkiin taloyhtiön asuntoihin',
      canAccessAllKeys: 'Pääsy kaikkiin avaimiin',
      canAccessAllServiceRequests: 'Pääsy kaikkiin palvelupyyntöihin',
    },
    announcement: {
      announcements: 'Ilmoitukset',
      header: 'Ilmoitukset',
      createNewAnnouncement: 'Luo uusi ilmoitus',
      deleteTitle: 'Poista ilmoitus',
      deleteMessage: 'Haluatko varmasti poistaa ilmoituksen "{{title}}"? Tätä toimintoa ei voi peruuttaa.',
      showMore: 'Näytä lisää',
      title: 'Otsikko',
      message: 'Viesti',
      create: 'Luo ilmoitus',
      edit: 'Muokkaa ilmoitusta',
      delete: 'Poista ilmoitus',
      confirmDelete: 'Haluatko varmasti poistaa tämän ilmoituksen?',
      cancel: 'Peruuta',
      defaultTitle: 'Ilmoitus',
      notFound: 'Ilmoitusta ei löytynyt',
      titlePlaceholder: 'Esim. Järjestelmäpäivitys huomenna',
      messagePlaceholder: 'Ilmoituksen sisältö. Voit käyttää markdown-muotoilua...',
      titleRequired: 'Otsikko on pakollinen',
      messageRequired: 'Viesti on pakollinen',
      messageMaxLength: 'Viesti voi olla enintään 1000 merkkiä',
      loadingAnnouncements: 'Ladataan ilmoituksia...',
      noAnnouncements: 'Ei ilmoituksia',
      createFirstAnnouncement: 'Luo ensimmäinen ilmoitus klikkaamalla yllä olevaa painiketta.',
      noAnnouncementsYet: 'Tällä hetkellä ei ole yhtään ilmoitusta.',
      bannerLink: 'Avaa ilmoitukset',
      bannerDismiss: 'Sulje',
      bannerAriaLabel: 'Lukemattomat ilmoitukset',
      bannerShowMore: 'Näytä {{count}} muuta',
      bannerShowLess: 'Näytä vähemmän',
      isGlobal: 'Yleinen ilmoitus',
      isGlobalDescription: 'Tee tästä ilmoituksesta näkyvä kaikille yrityksille',
    },
    notes: {
      title: 'Muistiinpanot',
      addNote: 'Lisää muistiinpano',
      editNote: 'Muokkaa muistiinpanoa',
      deleteNote: 'Poista muistiinpano',
      noNotes: 'Ei muistiinpanoja',
      contentPlaceholder: 'Kirjoita muistiinpano...',
      contentRequired: 'Syötä muistiinpanon sisältö',
      saveNote: 'Tallenna',
      cancel: 'Peruuta',
      updatedAt: 'päivitetty',
      confirmDelete: 'Haluatko varmasti poistaa tämän muistiinpanon?',
      createError: 'Muistiinpanon luonti epäonnistui',
      updateError: 'Muistiinpanon päivitys epäonnistui',
      deleteError: 'Muistiinpanon poisto epäonnistui',
      noPermissionCreate: 'Ei oikeutta luoda muistiinpanoja',
      noPermissionUpdate: 'Ei oikeutta päivittää muistiinpanoja',
      noPermissionDelete: 'Ei oikeutta poistaa muistiinpanoja',
      createSuccess: 'Muistiinpano luotu',
      updateSuccess: 'Muistiinpano päivitetty',
      deleteSuccess: 'Muistiinpano poistettu',
    },
    condominiums: {
      addressStreet: 'Katuosoite',
      address: 'Postinumero ja kaupunki',
      businessId: 'Y-tunnus',
      identifier: 'Kiinteistötunnus',
      apartmentKeyType: 'Asunnon avaintyyppi',
    },
    condominium: {
      header: 'Taloyhtiöt',
      condominiums: 'Taloyhtiöt',
      condominiumDetails: 'Taloyhtiön tiedot',
      name: 'Taloyhtiö',
      listName: 'Listanimi',
      selectCondominium: 'Valitse taloyhtiö',
      address: 'Osoite',
      street: 'Katuosoite',
      addressStreet: 'Katuosoite',
      postalCode: 'Postinumero',
      addressPostalCode: 'Postinumero',
      city: 'Postitoimipaikka',
      addressCity: 'Postitoimipaikka',
      superIntendent: 'Hallinnoija',
      selectSuperIntendent: 'Valitse hallinnoija...',
      lockType: 'Lukkotyyppi',
      lockAndKeyTypes: 'Lukko- ja avaintyypit',
      selectLockType: 'Valitse lukkotyyppi...',
      keyType: 'Yleisten avainten tyyppi',
      selectKeyType: 'Valitse avaintyyppi...',
      apartmentKeyType: 'Asunnon avaintyyppi',
      selectApartmentKeyType: 'Valitse asunnon avaintyyppi...',
      defaultServiceRequestTeam: 'Palvelupyyntöjen oletustiimi',
      defaultUpkeepTeam: 'Kunnossapidon oletustiimi',
      selectDefaultServiceRequestTeam: 'Valitse palvelupyyntöjen oletustiimi...',
      selectDefaultUpkeepTeam: 'Valitse kunnossapidon oletustiimi...',
      create: 'Luo taloyhtiö',
      edit: 'Muokkaa taloyhtiötä',
      update: 'Päivitä taloyhtiö',
      deleteTitle: 'Poista taloyhtiö',
      deleteMessage: 'Haluatko varmasti poistaa taloyhtiön',
      apartments: 'Asunnot',
      files: 'Tiedostot',
      cancel: 'Peruuta',
      searchPlaceholder: 'Hae taloyhtiöitä...',
      businessId: 'Y-tunnus',
      identifier: 'Kiinteistötunnus',
      propertyType: 'Kiinteistötyyppi',
      selectPropertyType: 'Valitse kiinteistötyyppi...',
      propertyTypes: {
        general: 'Yleinen',
        apartment_building: 'Kerrostalo',
        row_house: 'Rivitalo',
        public: 'Julkinen',
        other: 'Muu',
      },
      notFound: 'Kiinteistöä ei löytynyt',
      overview: 'Yleiskatsaus',
      generalKeys: 'Yleiset avaimet',
      allKeys: 'Kaikki avaimet',
      keys: 'Avaimet',
      keysScope: 'Avainten laajuus',
      fileName: 'Tiedoston nimi',
      fileModified: 'Viimeksi muokattu',
      deleteFile: 'Poista tiedosto',
      confirmDeleteFile: 'Haluatko varmasti poistaa tiedoston',
      noFiles: 'Ei tiedostoja',
      dragDropFiles: 'Raahaa ja pudota tiedostoja tähän',
      clickToSelect: 'tai klikkaa valitaksesi',
      dropFilesHere: 'Pudota tiedostot tähän',
      searchKeys: 'Hae avaimia...',
      nameRequired: 'Nimi on pakollinen',
      streetRequired: 'Katuosoite on pakollinen',
      postalCodeRequired: 'Postinumero on pakollinen',
      postalCodeFormat: 'Postinumeron täytyy olla 5 numeroa',
      postalCodeInvalid: 'Virheellinen postinumero',
      cityRequired: 'Postitoimipaikka on pakollinen',
      businessIdFormat: 'Y-tunnus täytyy olla muodossa 1234567-8 ja tarkistussumman täytyy olla oikein',
      identifierFormat: 'Kiinteistötunnus voi olla enintään 32 merkkiä pitkä',
      identifierInvalid: 'Anna kiinteistötunnus muodossa 091-401-0001-0002',
      namePlaceholder: 'Esim. Asunto Oy Esimerkkikatu 1',
      listNamePlaceholder: 'Esim. Norppakivi',
      streetPlaceholder: 'Esimerkkikatu 1',
      postalCodePlaceholder: '00100',
      cityPlaceholder: 'Helsinki',
      businessIdPlaceholder: '1234567-8',
      identifierPlaceholder: '123-456-7890-1',
      selectSuperintendent: 'Valitse hallinnoija...',
      additionalInfo: 'Lisätiedot',
      nocondominiumsForSearch: 'Ei taloyhtiöitä haulle "{{searchTerm}}"',
      nocondominiumsYet: 'Ei taloyhtiöitä.',
      additionalAddresses: 'Lisäosoitteet',
      additionalAddressesHelp: 'Pääosoite on yllä. Lisää tähän muut osoitteet.',
      addAdditionalAddress: 'Lisää lisäosoite',
      noAdditionalAddresses: 'Ei lisäosoitteita.',
      additionalAddressLabel: 'Lisäosoite {{index}}',
      additionalAddressIncomplete: 'Täytä lisäosoitteen katuosoite, postinumero ja kaupunki.',
      additionalAddressPostalCodeInvalid: 'Lisäosoitteen postinumeron täytyy olla 5 numeroa.',
      transfer: {
        toSubCompany: 'Siirrä aliyritykselle',
        transferredTooltip: 'Siirretty aliyritykselle',
        transferredTo: 'Siirretty yritykselle {{name}}',
        subCompanyCanEdit: 'Alayritys voi muokata siirrettyjä tietoja',
        revokeTransfer: 'Peruuta siirto',
        changeEditAccess: 'Muuta muokkausoikeutta',
        selectSubCompany: 'Valitse aliyritys',
        confirmTransfer: 'Vahvista siirto',
        transferConfirmNote: 'Kohteen aktiiviset esiluovutetut korit siirtyvät aliyritykselle.',
        transferSuccess: 'Siirto tehty',
        revokeSuccess: 'Siirto peruutettu',
        revokeConfirm:
          'Haluatko varmasti peruuttaa siirron? Alayritys menettää pääsyn taloyhtiöön. Kohteen tiedot, avaimet ja esiluovutetut korit siirtyvät pääyritykselle.',
        transferredAt: 'Siirretty',
        back: 'Edellinen',
        next: 'Seuraava',
      },
    },
    files: {
      expiresInTooltip_one: 'Vanhenee {{date}} ({{count}} päivä jäljellä)',
      expiresInTooltip_other: 'Vanhenee {{date}} ({{count}} päivää jäljellä)',
      expiresInDays_one: '{{count}} päivä jäljellä',
      expiresInDays_other: '{{count}} päivää jäljellä',
      visibility: 'Näkyvyys',
      visibleToResidents: 'Näkyy asukkaille',
      hiddenFromResidents: 'Piilotettu asukkailta',
      visibleToLandlords: 'Näkyy vuokranantajille',
      hiddenFromLandlords: 'Piilotettu vuokranantajilta',
      versionHistory: 'Versiohistoria',
      versionHistoryTitle: 'Versiohistoria – {{name}}',
      versionHistoryDescription:
        'Uusin versio ylimpänä. Vanhempia versioita säilytetään enintään {{versions}} kappaletta ja enintään {{days}} vuorokautta siitä hetkestä, kun ne korvattiin uudemmalla. Säilytysaikana version voi ladata tai palauttaa uusimmaksi.',
      noVersions: 'Versiohistoriaa ei löytynyt tälle tiedostolle.',
      version: 'Versio',
      uploadedAt: 'Ladattu',
      uploadedBy: 'Lataaja',
      size: 'Koko',
      currentVersion: 'Uusin versio',
      downloadVersion: 'Lataa versio',
      restoreVersion: 'Palauta tämä versio',
      restoreConfirmTitle: 'Palauta versio uusimmaksi?',
      restoreConfirmMessage: 'Tämä versio kopioidaan nykyiseksi versioksi. Vanhat versiot säilyvät historiassa.',
      restoreSuccess: 'Versio palautettu uusimmaksi',
      restoreFailed: 'Version palauttaminen epäonnistui',
      versionReplacedNotice:
        'Saman nimisen tiedoston lataaminen tallentaa uuden version. Aiemmat versiot näet Versiohistoriasta.',
      sendByEmail: 'Lähetä sähköpostilla',
      nativeEmailShareUnsupported: 'Tämän laitteen selain ei tue tiedoston jakamista sähköpostiin.',
      addFiles: 'Lisää tiedostoja',
      uploadModalTitle: 'Lataa tiedostoja',
      rejectedType: 'Tiedostotyyppiä ei sallita. Sallitut tyypit on lueteltu alla.',
      rejectedTooLarge: 'Tiedosto on liian suuri.',
      rejectedTooMany: 'Liian monta tiedostoa kerralla.',
      expires: 'Poistuu',
      expiresNever: '—',
      expiresExpired: 'Vanhentunut',
    },
    forgot: {
      header: 'Salasanan nollaaminen',
      email: 'Sähköposti',
      forgot: 'Nollaa salasana',
      password: 'Salasana',
      passwordAgain: 'Salasana uudelleen',
      passwordHint: 'Vähintään 8 merkkiä, joista vähintään yksi on iso kirjain, yksi on numero ja yksi erikoismerkki',
      passwordRequired: 'Salasana on pakollinen',
      passwordsMustBeSame: 'Salasanojen pitää olla samat',
      linkInvalid: 'Salasanan nollaus -linkki on vanhentunut tai virheellinen!',
      description: 'Syötä sähköpostiosoitteesi, niin lähetämme sinulle linkin salasanan nollaamiseen.',
    },
    messages: {
      deleteFailed: 'Poisto epäonnistui',
      saveSuccess: 'Tallennettu',
      keyRemoveFailed: 'Avaimen poistaminen epäonnistui',
      notFound: 'Tietoja ei löytynyt',
      createSuccess: 'Luotu onnistuneesti',
      apartmentCreated: 'Asunto luotu onnistuneesti',
      apartmentsCreated: 'Asunnot luotu onnistuneesti',
      apartmentUpdated: 'Asunto päivitetty onnistuneesti',
      apartmentDeleted: 'Asunto poistettu onnistuneesti',
      apartmentsDeletedBulk: '{{count}} asuntoa poistettu onnistuneesti',
      saveApartmentSuccess: 'Asunto tallennettu onnistuneesti',
      companyCreated: 'Yritys luotu onnistuneesti',
      companyUpdated: 'Yritys päivitetty onnistuneesti',
      companyDeleted: 'Yritys poistettu onnistuneesti',
      saveCompanySuccess: 'Yritys tallennettu onnistuneesti',
      condominiumCreated: 'Taloyhtiö luotu onnistuneesti',
      condominiumUpdated: 'Taloyhtiö päivitetty onnistuneesti',
      condominiumDeleted: 'Taloyhtiö poistettu onnistuneesti',
      condominiumsDeletedBulk: '{{count}} taloyhtiötä poistettu onnistuneesti',
      announcementCreated: 'Ilmoitus luotu onnistuneesti',
      announcementUpdated: 'Ilmoitus päivitetty onnistuneesti',
      announcementDeleted: 'Ilmoitus poistettu onnistuneesti',
      invitationCreated: 'Kutsu luotu onnistuneesti',
      invitationUpdated: 'Kutsu päivitetty onnistuneesti',
      invitationDeleted: 'Kutsu poistettu onnistuneesti',
      invitationSent: 'Kutsu lähetetty onnistuneesti',
      sendInvitationSuccess: 'Kutsu lähetetty onnistuneesti',
      copyLinkSuccess: 'Kutsulinkin kopioiminen onnistui',
      apiTokenCreated: 'API-tunnus luotu onnistuneesti',
      apiTokenCreateFailed: 'API-tunnuksen luominen epäonnistui',
      apiTokenDeleted: 'API-tunnus poistettu onnistuneesti',
      apiTokenDeleteFailed: 'API-tunnuksen poistaminen epäonnistui',
      billingAccountCreated: 'Asiakkuus luotu onnistuneesti',
      billingAccountUpdated: 'Asiakkuus päivitetty onnistuneesti',
      billingAccountCreateFailed: 'Asiakkuuden luominen epäonnistui',
      billingAccountUpdateFailed: 'Asiakkuuden päivitys epäonnistui',
      billingAccountDeleted: 'Asiakkuus poistettu onnistuneesti',
      billingAccountsDeletedBulk: '{{count}} asiakkuutta poistettu onnistuneesti',
      trackedAssetsDeletedBulk: '{{count}} laitetta poistettu onnistuneesti',
      rentalListingsDeletedBulk: '{{count}} vuokrailmoitusta poistettu onnistuneesti',
      brokerageAgreementsDeletedBulk: '{{count}} välityssopimusta poistettu onnistuneesti',
      rentalTemplatesDeletedBulk: '{{count}} sopimuspohjaa poistettu onnistuneesti',
      finalCleaningTemplatesDeletedBulk: '{{count}} loppusiivouspohjaa poistettu onnistuneesti',
      rentalLeasesDeletedBulk: '{{count}} vuokrasopimusta poistettu onnistuneesti',
      rentalApplicantsDeletedBulk: '{{count}} hakijaa poistettu onnistuneesti',
      brokerageInvoicesDeletedBulk: '{{count}} laskua poistettu onnistuneesti',
      finalInspectionsDeletedBulk: '{{count}} lopputarkastusta poistettu onnistuneesti',
      moveInInspectionsDeletedBulk: '{{count}} muuttotarkastusta poistettu onnistuneesti',
      needsAssessmentsDeletedBulk: '{{count}} tarveselvitystä poistettu onnistuneesti',
      repairHistoryReportsDeletedBulk: '{{count}} korjaushistoriaa poistettu onnistuneesti',
      espAccessDeletedBulk: '{{count}} käyttöoikeutta poistettu onnistuneesti',
      billingAccountDeleteFailed: 'Asiakkuuden poistaminen epäonnistui',
      keyTypeCreated: 'Avaintyyppi luotu onnistuneesti',
      keyTypeUpdated: 'Avaintyyppi päivitetty onnistuneesti',
      upkeepTypeCreated: 'Kunnossapitotyyppi luotu onnistuneesti',
      upkeepTypeUpdated: 'Kunnossapitotyyppi päivitetty onnistuneesti',
      upkeepTypeDeleted: 'Kunnossapitotyyppi poistettu onnistuneesti',
      serviceRequestTypeCreated: 'Palvelupyyntötyyppi luotu onnistuneesti',
      serviceRequestTypeUpdated: 'Palvelupyyntötyyppi päivitetty onnistuneesti',
      serviceRequestTypeDeleted: 'Palvelupyyntötyyppi poistettu onnistuneesti',
      serviceRequestCreated: 'Palvelupyyntö luotu onnistuneesti',
      serviceRequestUpdated: 'Palvelupyyntö päivitetty onnistuneesti',
      serviceRequestDeleted: 'Palvelupyyntö poistettu onnistuneesti',
      serviceRequestsDeletedBulk: '{{count}} palvelupyyntöä poistettu onnistuneesti',
      measurementDeleted: 'Mittaus poistettu onnistuneesti',
      measurementsDeletedBulk: '{{count}} mittausta poistettu onnistuneesti',
      keyTypeDeleted: 'Avaintyyppi poistettu onnistuneesti',
      lockTypeCreated: 'Lukkotyyppi luotu onnistuneesti',
      lockTypeUpdated: 'Lukkotyyppi päivitetty onnistuneesti',
      lockTypeDeleted: 'Lukkotyyppi poistettu onnistuneesti',
      roleCreated: 'Rooli luotu onnistuneesti',
      roleUpdated: 'Rooli päivitetty onnistuneesti',
      roleDeleted: 'Rooli poistettu onnistuneesti',
      permissionCreated: 'Käyttöoikeus luotu onnistuneesti',
      permissionUpdated: 'Käyttöoikeus päivitetty onnistuneesti',
      permissionDeleted: 'Käyttöoikeus poistettu onnistuneesti',
      settingsUpdated: 'Asetukset päivitetty onnistuneesti',
      userSettingsUpdated: 'Käyttäjäasetukset päivitetty onnistuneesti',
      profileUpdated: 'Profiili päivitetty onnistuneesti',
      userProfileUpdated: 'Käyttäjäprofiili päivitetty onnistuneesti',
      passwordChanged: 'Salasana vaihdettu onnistuneesti',
      userCreated: 'Käyttäjä luotu onnistuneesti',
      userCreateFailed: 'Käyttäjän luominen epäonnistui',
      userUpdated: 'Käyttäjä päivitetty onnistuneesti',
      userUpdateFailed: 'Käyttäjän päivittäminen epäonnistui',
      userDeleted: 'Käyttäjä poistettu onnistuneesti',
      userDeleteFailed: 'Käyttäjän poistaminen epäonnistui',
      saveFailed: 'Tallentaminen epäonnistui',
      restoreFailed: 'Kohteen palauttaminen epäonnistui',
      residentCreated: 'Asukas luotu onnistuneesti',
      residentUpdated: 'Asukas päivitetty onnistuneesti',
      residentDeleted: 'Asukas poistettu onnistuneesti',
      residentsDeletedBulk: '{{count}} asukasta poistettu onnistuneesti',
      landlordCreated: 'Vuokranantaja luotu onnistuneesti',
      landlordUpdated: 'Vuokranantaja päivitetty onnistuneesti',
      landlordDeleted: 'Vuokranantaja poistettu onnistuneesti',
      landlordsDeletedBulk: '{{count}} vuokranantajaa poistettu onnistuneesti',
      saveResidentSuccess: 'Asukas tallennettu onnistuneesti',
      keyCreated: 'Avain luotu onnistuneesti',
      keysCreated: 'Avaimet luotu onnistuneesti',
      keysBatchUpdated: 'Valitut avaimet päivitetty onnistuneesti',
      keysBatchUpdateFailed: 'Valittujen avainten massapäivitys epäonnistui',
      keyUpdated: 'Avain päivitetty onnistuneesti',
      keyDeleted: 'Avain poistettu onnistuneesti',
      keysDeletedBulk: '{{count}} avainta poistettu onnistuneesti',
      keyGiven: 'Avain annettu onnistuneesti',
      keyRegiven: 'Avain uudelleenluovutettu onnistuneesti',
      keyReturned: 'Avain palautettu onnistuneesti',
      keyMarkedLost: 'Avain merkitty kadonneeksi',
      keyMarkedFound: 'Avain merkitty löytyneeksi',
      reminderSent: 'Muistutus lähetetty onnistuneesti',
      keyDueDateChanged: 'Eräpäivä muutettu onnistuneesti',
      keysDueDateChanged: 'Valittujen avainten eräpäivä päivitetty',
      addedToCart: 'Avain lisätty ostoskoriin',
      keysAddedToCart: '{{count}} avainta lisätty ostoskoriin',
      removedFromCart: 'Avain poistettu ostoskorista',
      cartCleared: 'Ostoskori tyhjennetty',
      keysGiven: 'Avaimet luovutettu onnistuneesti',
      keysGivenSuccessfully: 'Avaimet luovutettu onnistuneesti',
      keysGiveFailed: 'Avainten luovuttaminen epäonnistui',
      addToCartFailed: 'Avaimen lisääminen ostoskoriin epäonnistui',
      removeFromCartFailed: 'Avaimen poistaminen ostoskorista epäonnistui',
      clearCartFailed: 'Ostoskorin tyhjentäminen epäonnistui',
      giveKeysFailed: 'Avainten luovuttaminen epäonnistui',
      cartSaved: 'Kori tallennettu onnistuneesti',
      cartSaveFailed: 'Korin tallentaminen epäonnistui',
      keysAddedToSavedCart: 'Avaimet lisätty tallennettuun koriin',
      keysAddToSavedCartFailed: 'Avaimien lisääminen koriin epäonnistui',
      presavedCartUpdated: 'Tallennettu kori päivitetty',
      presavedCartUpdateFailed: 'Tallennetun korin päivitys epäonnistui',
      presavedCartReadyNotificationSent: 'Ilmoitus lähetetty (avaimet valmiina noudettavaksi)',
      presavedCartReadyNotificationFailed: 'Ilmoituksen lähettäminen epäonnistui',
      cartDeleted: 'Kori poistettu onnistuneesti',
      cartDeleteFailed: 'Korin poistaminen epäonnistui',
      cartsCombined: 'Korit yhdistetty onnistuneesti',
      cartsCombineFailed: 'Korien yhdistäminen epäonnistui',
      selectResident: 'Valitse asukas',
      selectUser: 'Valitse käyttäjä',
      selectLandlord: 'Valitse vuokranantaja',
      holderResidentRequired: 'Asukas on pakollinen. Valitse asukas listasta.',
      holderUserRequired: 'Käyttäjä on pakollinen. Valitse käyttäjä listasta.',
      holderLandlordRequired: 'Vuokranantaja on pakollinen. Valitse vuokranantaja listasta.',
      landlordModeDisabled:
        'Vuokraus ei ole käytössä tällä yrityksellä. Ota se käyttöön yrityksen asetuksista hallitaksesi vuokranantajia.',
      deleteKeyFailed: 'Avaimen poistaminen epäonnistui',
      deletePropertyFailed: 'Taloyhtiön poistaminen epäonnistui',
      deleteApartmentFailed: 'Asunnon poistaminen epäonnistui',
      deleteResidentFailed: 'Asukkaan poistaminen epäonnistui',
      firstNameRequired: 'Etunimi on pakollinen',
      lastNameRequired: 'Sukunimi on pakollinen',
      dueDateRequired: 'Palautuspäivä on pakollinen',
      signatureRequired: 'Allekirjoitus on pakollinen',
      loginSuccess: 'Kirjautuminen onnistui',
      logoutSuccess: 'Uloskirjautuminen onnistui',
      passwordResetSuccess: 'Salasana nollattu onnistuneesti',
      resetEmailSent: 'Salasanan nollauslinkki lähetetty sähköpostiin',
      apartmentCreateFailed: 'Asunnon luominen epäonnistui',
      apartmentsCreateFailed: 'Asuntojen luominen epäonnistui',
      apartmentUpdateFailed: 'Asunnon päivittäminen epäonnistui',
      apartmentDeleteFailed: 'Asunnon poistaminen epäonnistui',
      saveApartmentFailed: 'Asunnon tallentaminen epäonnistui',
      companyCreateFailed: 'Yrityksen luominen epäonnistui',
      companyUpdateFailed: 'Yrityksen päivittäminen epäonnistui',
      companyDeleteFailed: 'Yrityksen poistaminen epäonnistui',
      saveCompanyFailed: 'Yrityksen tallentaminen epäonnistui',
      announcementCreateFailed: 'Ilmoituksen luominen epäonnistui',
      announcementUpdateFailed: 'Ilmoituksen päivittäminen epäonnistui',
      announcementDeleteFailed: 'Ilmoituksen poistaminen epäonnistui',
      invitationCreateFailed: 'Kutsun luominen epäonnistui',
      invitationUpdateFailed: 'Kutsun päivittäminen epäonnistui',
      invitationDeleteFailed: 'Kutsun poistaminen epäonnistui',
      invitationSendFailed: 'Kutsun lähettäminen epäonnistui',
      sendInvitationFailed: 'Kutsun lähettäminen epäonnistui',
      keyTypeCreateFailed: 'Avaintyypin luominen epäonnistui',
      keyTypeUpdateFailed: 'Avaintyypin päivittäminen epäonnistui',
      keyTypeDeleteFailed: 'Avaintyypin poistaminen epäonnistui',
      lockTypeCreateFailed: 'Lukkotyypin luominen epäonnistui',
      lockTypeUpdateFailed: 'Lukkotyypin päivittäminen epäonnistui',
      lockTypeDeleteFailed: 'Lukkotyypin poistaminen epäonnistui',
      upkeepTypeCreateFailed: 'Kunnossapitotyypin luominen epäonnistui',
      upkeepTypeUpdateFailed: 'Kunnossapitotyypin päivittäminen epäonnistui',
      upkeepTypeDeleteFailed: 'Kunnossapitotyypin poistaminen epäonnistui',
      serviceRequestTypeCreateFailed: 'Palvelupyyntötyypin luominen epäonnistui',
      serviceRequestTypeUpdateFailed: 'Palvelupyyntötyypin päivittäminen epäonnistui',
      serviceRequestTypeDeleteFailed: 'Palvelupyyntötyypin poistaminen epäonnistui',
      roleCreateFailed: 'Roolin luominen epäonnistui',
      roleUpdateFailed: 'Roolin päivittäminen epäonnistui',
      roleDeleteFailed: 'Roolin poistaminen epäonnistui',
      permissionCreateFailed: 'Käyttöoikeuden luominen epäonnistui',
      permissionUpdateFailed: 'Käyttöoikeuden päivittäminen epäonnistui',
      permissionDeleteFailed: 'Käyttöoikeuden poistaminen epäonnistui',
      settingsUpdateFailed: 'Asetusten päivittäminen epäonnistui',
      userSettingsUpdateFailed: 'Käyttäjäasetusten päivittäminen epäonnistui',
      profileUpdateFailed: 'Profiilin päivittäminen epäonnistui',
      userProfileUpdateFailed: 'Käyttäjäprofiilin päivittäminen epäonnistui',
      passwordChangeFailed: 'Salasanan vaihto epäonnistui',
      condominiumCreateFailed: 'Taloyhtiön luominen epäonnistui',
      condominiumUpdateFailed: 'Taloyhtiön päivittäminen epäonnistui',
      condominiumDeleteFailed: 'Taloyhtiön poistaminen epäonnistui',
      residentCreateFailed: 'Asukkaan luominen epäonnistui',
      residentUpdateFailed: 'Asukkaan päivittäminen epäonnistui',
      residentDeleteFailed: 'Asukkaan poistaminen epäonnistui',
      landlordCreateFailed: 'Vuokranantajan luominen epäonnistui',
      landlordUpdateFailed: 'Vuokranantajan päivittäminen epäonnistui',
      landlordDeleteFailed: 'Vuokranantajan poistaminen epäonnistui',
      saveResidentFailed: 'Asukkaan tallentaminen epäonnistui',
      keyCreateFailed: 'Avaimen luominen epäonnistui',
      keysCreateFailed: 'Avainten luominen epäonnistui',
      keyUpdateFailed: 'Avaimen päivittäminen epäonnistui',
      keyDeleteFailed: 'Avaimen poistaminen epäonnistui',
      keyGiveFailed: 'Avaimen antaminen epäonnistui',
      keyRegiveFailed: 'Avaimen uudelleenluovuttaminen epäonnistui',
      keyReturnFailed: 'Avaimen palautus epäonnistui',
      keyMarkLostFailed: 'Avaimen merkitseminen kadonneeksi epäonnistui',
      keyMarkFoundFailed: 'Avaimen merkitseminen löytyneeksi epäonnistui',
      reminderSendFailed: 'Muistutuksen lähettäminen epäonnistui',
      keyDueDateChangeFailed: 'Eräpäivän muuttaminen epäonnistui',
      keysDueDateChangeFailed: 'Eräpäivän massamuutos epäonnistui',
      markKeyLostFailed: 'Avaimen merkitseminen kadonneeksi epäonnistui',
      sendReminderFailed: 'Muistutuksen lähetys epäonnistui',
      changeDueDateFailed: 'Eräpäivän muutos epäonnistui',
      giveKeyFailed: 'Avainten luovutus epäonnistui',
      regiveKeyFailed: 'Avainten uudelleenluovutus epäonnistui',
      markKeyFoundFailed: 'Avaimen merkitseminen löytyneeksi epäonnistui',
      keyAgreementCopyFailed: 'Avainsopimusten kopiointi epäonnistui',
      copyToClipboardFailed: 'Kutsulinkin kopioiminen epäonnistui',
      loginFailed: 'Kirjautuminen epäonnistui',
      mfaLoginFailed: 'Vahvistus epäonnistui. Tarkista koodi ja yritä uudelleen.',
      mfaCodeResent: 'Uusi koodi lähetettiin sähköpostiisi',
      mfaResendFailed: 'Koodin uudelleen lähetys epäonnistui',
      sessionExpired: 'Istunto on vanhentunut, kirjaudu uudelleen sisään',
      passwordResetFailed: 'Salasanan nollaus epäonnistui',
      keycheckStampSuccess: 'Avaimen leiman tarkistaminen onnistui',
      keycheckStampFailed: 'Avaimen leiman tarkistaminen epäonnistui',
      updateFailed: 'Päivitys epäonnistui',
      rateLimited: 'Liian monta pyyntöä kerralla. Odota hetki ja yritä uudelleen.',
    },
    resident: {
      title: 'Asukas',
      residentDetails: 'Asukkaan tiedot',
      notFound: 'Asukasta ei löytynyt',
      firstName: 'Etunimi',
      lastName: 'Sukunimi',
      email: 'Sähköposti',
      phoneNumber: 'Puhelinnumero',
      apartment: 'Asunto',
      noApartment: 'Ei asuntoa',
      deleteTitle: 'Poista asukas',
      deleteMessage: 'Haluatko varmasti poistaa asukkaan "{{name}}"? Tätä toimintoa ei voi peruuttaa.',
      searchKeys: 'Hae avaimia...',
    },
    paginator: {
      showing: 'Näytetään',
      results: 'tulosta',
      resultsPerPage: 'Tuloksia sivua kohden',
    },
    table: {
      loadError: 'Tietojen lataus epäonnistui',
      filterPlaceholder: 'Suodata...',
      filterAll: 'Kaikki',
      filterActive: 'Suodatin aktiivinen',
      clearFilter: 'Tyhjennä suodatin',
      activeFilters: '{{count}} suodatinta aktiivisena',
      clearAllFilters: 'Tyhjennä kaikki',
    },
    audit: {
      title: 'Lokitiedot',
      noPermission: 'Ei käyttöoikeutta',
      noPermissionDescription: 'Sinulla ei ole oikeutta tarkastella lokitietoja.',
      loading: 'Ladataan lokitietoja...',
      searchUsersPlaceholder: 'Hae nimellä, sähköpostilla tai yrityksellä...',
      historyNotFound: 'Lokitietoa ei löytynyt',
      historyTitle: 'Avaimen lokitieto',
      tabSameBatch: 'Muut samassa erässä',
      sameBatchCardTitle: 'Muut samassa erässä',
      additionalInfo: 'Lisätiedot',
      holderInfo: 'Haltija',
      holderType: 'Tyyppi',
      resident: 'Asukas',
      user: 'Käyttäjä',
      landlord: 'Vuokranantaja',
      externalPerson: 'Ulkoinen henkilö',
      noHolderInfo: 'Ei haltijatietoja',
      noKeyInfo: 'Ei avaintietoja',
      eventLabel: 'Tapahtuma',
      time: 'Aika',
      dueDate: 'Eräpäivä',
      location: 'Sijainti',
      signature: 'Allekirjoitus',
      mandate: 'Valtakirja',
      openMandateInNewWindow: 'Avaa valtakirja uudessa ikkunassa',
      attachMandateDescription:
        'Jos valtakirjaa ei tallennettu luovutuksella, voit liittää sen tähän tapahtumaan jälkikäteen.',
      attachMandateSave: 'Tallenna valtakirja',
      attachMandateSuccess: 'Valtakirja liitetty tapahtumaan',
      attachMandateFailed: 'Valtakirjan liittäminen epäonnistui',
      keyAgreement: 'Avainsopimus',
      name: 'Nimi',
      email: 'Sähköposti',
      phone: 'Puhelin',
      company: 'Yritys',
      handoverNotifications: 'Ilmoitukset luovutuksella',
      handoverNotifyEmail: 'Sähköposti-ilmoitus',
      handoverNotifySms: 'Tekstiviesti-ilmoitus',
      preHandoverSnapshot: 'Luovutuksen lisätiedot',
    },
    permissions: {
      editTitle: 'Muokkaa käyttöoikeutta: {{name}}',
      createTitle: 'Luo uusi käyttöoikeus',
      nameLabel: 'Nimi',
      nameRequired: 'Nimi on pakollinen',
      namePlaceholder: 'Esim. User_Read',
      nameHint: 'Käytä englanninkielisiä nimiä, esim. User_Create, Company_Read',
      cancel: 'Peruuta',
      create: 'Luo rooli',
      edit: 'Muokkaa',
      confirmDelete: 'Vahvista käyttöoikeuden poisto',
      confirmDeleteMessage: 'Haluatko varmasti poistaa käyttöoikeuden "{{name}}"? Tätä toimintoa ei voi peruuttaa.',
      createButton: 'Luo käyttöoikeus',
      noPermissions: 'Ei käyttöoikeuksia',
      searchPlaceholder: 'Hae käyttöoikeuksia...',
      descriptionPlaceholderEn: 'Description in English',
      descriptionPlaceholderFi: 'Kuvaus suomeksi',
      descriptionPlaceholderSv: 'Beskrivning på svenska',
      hidePermission: 'Piilota oikeus',
      hidePermissionDescription: 'Vain Super Admin voi nähdä ja käyttää tätä oikeutta rooleissa',
    },
    properties: {
      tabs: {
        landlords: 'Vuokranantajat',
      },
      tabProperties: 'Taloyhtiöt',
      tabApartments: 'Asunnot',
      tabResidents: 'Asukkaat',
      tabTrackedAssets: 'Laitteet',
      createProperty: 'Luo taloyhtiö',
      createApartment: 'Luo asunto',
      createResident: 'Luo asukas',
      createLandlord: 'Luo vuokranantaja',
      searchApartments: 'Hae asuntoja...',
      title: 'Kohteet',
      residentPortalLink: 'Asukasportaali',
      residentPortalLinkDescription:
        'Kopioi linkki ja jaa se asukkaille. Linkin kautta asukkaat voivat kirjautua asukasportaaliin ja hallita palvelupyyntöjään.',
    },
    companyDetail: {
      tabUsers: 'Käyttäjät',
      tabAgreement: 'Avainsopimus',
    },
    userAudit: {
      searchLogs: 'Hae lokitietoja...',
      noLogs: 'Ei lokitietoja',
      time: 'Aika',
      eventType: 'Tapahtuma',
      holder: 'Haltija',
    },
    userKeys: {
      title: 'Minun avaimeni',
      allKeys: 'Kaikki',
      borrowedKeys: 'Lainassa',
      availableKeys: 'Vapaana',
      lateKeys: 'Myöhässä olevat avaimet',
      lateAndMissingKeys: 'Myöhässä ja kadonneet',
    },
    keyTypes: {
      editTitle: 'Muokkaa avaintyyppiä: {{name}}',
      createTitle: 'Luo uusi avaintyyppi',
      generalKey: 'Yleinen avain',
      warnAboutDuplicateStamp: 'Varoita kaksoisleimoista',
      inUse: 'Käytössä',
      notInUse: 'Ei käytössä',
      searchPlaceholder: 'Hae avaintyyppejä...',
      noKeyTypes: 'Ei avaintyyppejä',
      deleteConfirm: 'Haluatko varmasti poistaa avaintyypin "{{name}}"? Tätä toimintoa ei voi peruuttaa.',
      namePlaceholder: 'Esim. Pääavain',
    },
    tags: {
      createTitle: 'Luo uusi tagi',
      editTitle: 'Muokkaa tagia: {{name}}',
      namePlaceholder: 'Esim. Tärkeä',
      color: 'Väri',
      colorInvalid: 'Anna väri muodossa #RGB tai #RRGGBB tai tyhjennä väri.',
      archived: 'Arkistoitu',
      searchPlaceholder: 'Hae tageja...',
      noTags: 'Ei tageja',
      createButton: 'Luo tagi',
      deleteTitle: 'Poista tagi',
      deleteConfirm: 'Haluatko varmasti poistaa tagin "{{name}}"? Liitokset kohteisiin poistetaan.',
      pickerPlaceholder: 'Hae tai lisää tageja...',
      loadingSuggestions: 'Haetaan...',
      noSuggestions: 'Ei ehdotuksia',
      createNewNamed: 'Luo uusi tagi "{{name}}"',
      removeTag: 'Poista tagi {{name}}',
      messages: {
        created: 'Tagi luotu onnistuneesti',
        updated: 'Tagi päivitetty onnistuneesti',
        deleted: 'Tagi poistettu onnistuneesti',
        createFailed: 'Tagin luominen epäonnistui',
        updateFailed: 'Tagin päivittäminen epäonnistui',
        deleteFailed: 'Tagin poistaminen epäonnistui',
      },
    },
    lockTypes: {
      nameLabel: 'Nimi',
      delete: 'Poista lukkotyyppi',
      deleteConfirm: 'Haluatko varmasti poistaa lukkotyypin "{{name}}"? Tätä toimintoa ei voi peruuttaa.',
      createButton: 'Luo lukkotyyppi',
      noLockTypes: 'Ei lukkotyyppejä',
      searchPlaceholder: 'Hae lukkotyyppejä...',
      editTitle: 'Muokkaa lukkotyyppiä: {{name}}',
      createTitle: 'Luo uusi lukkotyyppi',
      nameRequired: 'Nimi on pakollinen',
      namePlaceholder: 'Esim. Abloy',
    },
    upkeepTypes: {
      editTitle: 'Muokkaa kunnossapitotyyppiä: {{name}}',
      createTitle: 'Luo uusi kunnossapitotyyppi',
      searchPlaceholder: 'Hae kunnossapitotyyppejä...',
      noUpkeepTypes: 'Ei kunnossapitotyyppejä',
      deleteConfirm: 'Haluatko varmasti poistaa kunnossapitotyypin "{{name}}"? Tätä toimintoa ei voi peruuttaa.',
      deleteUpkeepType: 'Poista kunnossapitotyyppi',
      namePlaceholder: 'Esim. Palovaroitin',
      descriptionPlaceholder: 'Kuvaus kunnossapitotyypistä',
      followUpType: 'Huollon tyyppi',
      followUpTypePlaceholder: 'Valitse huoltotyyppi',
      followUpTypeHelp: 'Tätä tyyppiä ehdotetaan, kun huolto luodaan allekirjoituksen yhteydessä.',
      createFollowUp: 'Avaa huolto huomautuksista ja virheistä',
      createFollowUpHelp:
        'Kun kierros allekirjoitetaan, huomautus- ja virhekohteista voidaan muodostaa yksi yhteinen huolto. Poikkeustiloista ei avata huoltoa.',
      followUpTypeRequired: 'Valitse huollon tyyppi.',
      followUpThisType: 'Tämä tyyppi',
      followUpThisTypeNamed: '{{name}} (tämä tyyppi)',
    },
    serviceRequestTypes: {
      editTitle: 'Muokkaa palvelupyynnön tyyppiä: {{name}}',
      createTitle: 'Luo uusi palvelupyynnön tyyppi',
      searchPlaceholder: 'Hae palvelupyyntötyyppejä...',
      noServiceRequestTypes: 'Ei palvelupyyntötyyppejä',
      deleteConfirm: 'Haluatko varmasti poistaa palvelupyynnön tyypin "{{name}}"? Tätä toimintoa ei voi peruuttaa.',
      deleteServiceRequestType: 'Poista palvelupyynnön tyyppi',
      namePlaceholder: 'Esim. Yleinen',
      descriptionPlaceholder: 'Kuvaus palvelupyynnön tyypistä',
      autoReply: 'Automaattivastaus',
      autoReplyPlaceholder: 'Viesti, joka lähetetään pyytäjälle, kun tämän tyypin palvelupyyntö luodaan',
      autoReplyHelp: 'Lähetetään pyytäjälle vahvistussähköpostissa, kun tämän tyypin palvelupyyntö luodaan.',
    },
    controlPanel: {
      title: 'Hallintapaneeli',
      myPage: 'Oma Sivu',
      userTracking: 'Lokitiedot',
      events: 'Tapahtumat',
      companies: 'Kaikki yritykseni',
      transferredCondominiums: 'Siirretyt taloyhtiöt',
      lockTypes: 'Lukkotyypit',
      keyTypes: 'Avaintyypit',
      tags: 'Tagit',
      upkeepTypes: 'Kunnossapitotyypit',
      upkeepFormTemplates: 'Kunnossapitopohjat',
      contractTemplates: 'Sopimuspohjat',
      finalInspectionFormTemplates: 'Lopputarkastuspohjat',
      finalCleaningTemplates: 'Loppusiivouspohjat',
      moveInInspectionFormTemplates: 'Muuttotarkastuspohjat',
      serviceRequestTypes: 'Palvelupyyntötyypit',
      teams: 'Tiimit',
      serviceProviders: 'Palveluntarjoajat',
      roles: 'Roolit',
      permissions: 'Käyttöoikeudet',
      import: 'Tuonti',
      companyStats: 'Yritystilastot',
      personalData: 'Tietojen poisto',
      navSearchPlaceholder: 'Hae hallinnan osa-aluetta...',
      navAriaLabel: 'Hallinnan osa-alueet',
      groups: {
        organization: 'Yritys',
        audit: 'Lokit ja seuranta',
        types: 'Tyypit ja mallit',
        access: 'Käyttäjät ja oikeudet',
      },
      noAccess: 'Ei Käyttöoikeutta',
      noAccessDescription: 'Sinulla ei ole oikeutta käyttää hallintapaneelia.',
      personalDataPurge: {
        title: 'Tietojen poisto',
        description:
          'Valitse tietotyypit, hae tekstillä ja rajaa suodattimella. Esikatsele osumat ja siirrä ne 7 päivän roskakoriin. Avainhistorian, audit-lokin ja sopimustekstien kopioita tämä ei siivoa.',
        targets: 'Mitä poistetaan',
        targetsHint: 'Henkilöt on valittu valmiiksi. Taloyhtiöt, asunnot ja avaimet voi lisätä tarvittaessa.',
        peopleGroup: 'Henkilöt',
        peopleGroupHint: 'Asukkaat, vuokranantajat ja vuokrahakijat.',
        propertyGroup: 'Kohteet ja avaimet',
        propertyGroupHint: 'Taloyhtiöt, asunnot ja avaimet siirtyvät samaan 7 päivän roskakoriin.',
        filter: 'Suodatin',
        filterHint:
          'Tekstihaku rajaa kaikkia valittuja tyyppejä. Säännöillä voi tarkentaa ikää, yritystä tai kohdetta.',
        search: 'Tekstihaku',
        searchPlaceholder: 'Nimi, sähköposti, osoite, avainleima…',
        searchHint: 'Haku kohdistuu nimiin, sähköposteihin, puhelinnumeroihin, osoitteisiin ja avainleimoihin.',
        preview: 'Esikatsele',
        previewTitle: 'Esikatselu',
        previewCapped: 'Näytetään {{count}} / {{total}} osumaa.',
        delete: 'Poista osumat',
        previewFailed: 'Esikatselu epäonnistui',
        deleteFailed: 'Poisto epäonnistui',
        deleteSuccess: '{{count}} tietuetta siirretty roskakoriin',
        noMatches: 'Suodatin ei tuottanut osumia.',
        keepHint: 'Merkitse rivit, joita ei poisteta. Muut suodattimen osumat poistetaan silti.',
        keepRow: 'Älä poista: {{name}}',
        warningNotApplicable: 'Kenttä "{{field}}" ei koske kohdetta {{target}}.',
        confirmTitle: 'Vahvista tietojen poisto',
        confirmMessage:
          'Haluatko varmasti siirtää {{count}} tietuetta roskakoriin ({{summary}})? Palautus onnistuu 7 päivän ajan.',
        confirmDelete: 'Siirrä roskakoriin',
        addRule: 'Lisää sääntö',
        addGroup: 'Lisää ryhmä',
        remove: 'Poista',
        combinatorAnd: 'JA',
        combinatorOr: 'TAI',
        targetTypes: {
          resident: 'Asukkaat',
          landlord: 'Vuokranantajat',
          rentalApplicant: 'Vuokrahakijat',
          condominium: 'Taloyhtiöt',
          apartment: 'Asunnot',
          key: 'Avaimet',
        },
        fields: {
          createdOlderThan: 'Luotu yli',
          createdBefore: 'Luotu ennen',
          createdAfter: 'Luotu jälkeen',
          createdBetween: 'Luotu välillä',
          companyId: 'Yritys',
          condominiumId: 'Taloyhtiö',
          apartmentId: 'Asunto',
          nameContains: 'Nimi sisältää',
          emailEquals: 'Sähköposti on',
          emailContains: 'Sähköposti sisältää',
          emailEmpty: 'Sähköposti puuttuu',
        },
        units: {
          days: 'päivää sitten',
          months: 'kuukautta sitten',
          years: 'vuotta sitten',
        },
        columns: {
          keep: 'Älä poista',
          type: 'Tyyppi',
          name: 'Nimi',
          email: 'Sähköposti',
          company: 'Yritys',
          condominium: 'Taloyhtiö',
          createdAt: 'Luotu',
        },
        validation: {
          emptyTargets: 'Valitse vähintään yksi tietotyyppi.',
          emptyFilter: 'Lisää vähintään yksi suodatinsääntö.',
          emptyGroup: 'Suodatinryhmä ei voi olla tyhjä.',
          tooManyRules: 'Suodattimessa on liikaa sääntöjä.',
          tooDeep: 'Suodatin on liian syvä.',
          invalidCombinator: 'Virheellinen suodattimen yhdistäjä.',
          invalidField: 'Tuntematon suodatinkenttä.',
          invalidAge: 'Anna kelvollinen ikä ja yksikkö.',
          invalidDate: 'Anna kelvollinen päivämäärä.',
          invalidRange: 'Aikavälin alku ei voi olla loppua myöhempi.',
          invalidId: 'Valitse kelvollinen kohde.',
          invalidText: 'Anna hakuteksti.',
        },
      },
      companyStatsSection: {
        title: 'Yritystilastot',
        description: 'Yhteenveto kaikista yrityksistä. Valitse yritys nähdäksesi kaaviot ja aikavälisuodattimen.',
        error: 'Yritystilastojen lataus epäonnistui.',
        allCompanies: 'Kaikki yritykset',
        filterCompany: 'Yritys',
        detailTitle: 'Yrityksen tiedot: {{name}}',
        storageMb: 'Tallennustila (Mt)',
        columns: {
          company: 'Yritys',
          keys: 'Avaimia',
          keyHistories: 'Avainhistoria',
          storage: 'Tallennus',
          activeLeases: 'Aktiiviset vuokrasopimukset',
          activeBrokerageAgreements: 'Aktiiviset välityssopimukset',
          openRentalListings: 'Avoimet ilmoitukset',
          rentalApplicants: 'Hakijat (pipeline)',
          maintenanceNeedsAssessments: 'Kunnossapitotarveselvitykset',
          trackedAssets: 'Seurattavat laitteet',
          documentBankFiles: 'Dokumenttipankin tiedostot',
        },
        charts: {
          keyHistoriesPerDay: 'Avainhistoria / päivä',
          keyHistoriesPerDayDescription: 'Kaikki avainhistoriatapahtumat valitulla aikavälillä.',
          serviceRequestsPerDay: 'Palvelupyynnöt / päivä',
          serviceRequestsPerDayDescription: 'Luodut palvelupyynnöt valitulla aikavälillä.',
          noKeyHistoryData: 'Ei avainhistoriaa valitulla aikavälillä.',
          noServiceRequestData: 'Ei palvelupyyntöjä valitulla aikavälillä.',
        },
        empty: 'Ei yrityksiä.',
      },
    },
    reports: {
      title: 'Analytiikka',
      error: 'Analytiikan lataus epäonnistui.',
      filterCondominium: 'Kohde',
      filterHandler: 'Käsittelijä',
      allCondominiums: 'Kaikki kohteet',
      allHandlers: 'Kaikki käsittelijät',
      comparedToPrevious: 'edelliseen jaksoon',
      keysPeriod: 'Avaintapahtumat',
      keysCurrentlyOut: 'Nyt lainassa',
      keysByCondominium: 'Avaintapahtumat kohteittain',
      keysByHandler: 'Avaintapahtumat käsittelijöittäin',
      unknownHandler: 'Tuntematon/järjestelmä',
      serviceRequestsCreated: 'Luodut palvelupyynnöt',
      serviceRequestsResolved: 'Ratkaistut palvelupyynnöt',
      serviceRequestsByType: 'Palvelupyynnöt tyypeittäin',
      serviceRequestsByCondominium: 'Palvelupyynnöt kohteittain',
      noServiceRequestData: 'Valitulla ajanjaksolla ei ole palvelupyyntöjä.',
      inspectionsCompleted: 'Tehdyt tarkastukset',
      inspectionsByCondominium: 'Tarkastukset kohteittain',
      inspectionsByType: 'Tarkastukset tyypeittäin',
      breakdownHint: 'Klikkaa riviä suodattaaksesi ja avataksesi rivit.',
      drillTitle: 'Porautuminen',
      drillEmpty: 'Ei rivejä tällä valinnalla.',
      drillError: 'Rivien lataus epäonnistui.',
      drillId: 'Tunniste',
      drillDate: 'Päivä',
      drillLabel: 'Tyyppi',
      eventGive: 'Luovutus',
      eventReturn: 'Palautus',
      eventLost: 'Kadonnut',
      eventFound: 'Löytynyt',
      tabOverview: 'Yleiskatsaus',
      chat: {
        title: 'Keskustele datan kanssa',
        placeholder: 'Kirjoita kysymys…',
        send: 'Lähetä',
        emptyTitle: 'Kysy yrityksen datasta',
        empty: 'Kysymys käyttää yleiskatsauksen jaksoa ja suodattimia, ellei toisin pyydetä.',
        suggestionsLabel: 'Kokeile esimerkiksi',
        suggestions: {
          handovers: 'Missä kohteessa avaimia luovutettiin eniten?',
          borrowed: 'Kuinka monta avainta on nyt lainassa?',
          openRequests: 'Mitkä palvelupyynnöt ovat avoinna?',
          combined: 'Missä asunnossa on sekä avoin palvelupyyntö että avain lainassa?',
        },
        you: 'Sinä',
        assistant: 'Analytiikka',
        thinking: 'Haetaan tietoja valitulta jaksolta…',
        sources: 'Lähteet: {{sources}}',
        sourcePeriod: '{{from}}–{{to}}',
        sourceRows: '{{count}} riviä',
        sourceTools: {
          get_analytics: 'analytiikka',
          list_keys: 'avaimet',
          list_register: 'rekisteri',
          get_drill: 'tapahtumat',
        },
        sourceKinds: {
          properties: 'kohteet',
          apartments: 'asunnot',
          residents: 'asukkaat',
          serviceRequests: 'palvelupyynnöt',
          upkeeps: 'kunnossapito',
          maintenancePlans: 'tarveselvitykset',
          rentalListings: 'ilmoitukset',
          leases: 'sopimukset',
          landlords: 'vuokranantajat',
          trackedAssets: 'laitteet',
        },
        error: 'Keskustelu epäonnistui. Yritä uudelleen.',
        emptyReply: 'Vastausta ei saatu. Yritä kysyä uudelleen.',
        disclaimer:
          'Vastaukset yhdistävät kohteita, asuntoja, asukkaita ja avaimia. Palvelupyynnöt, kunnossapito, vuokraus ja laitteet tulevat mukaan vain, jos ominaisuus on yrityksellä käytössä. Vapaata tekstiä, kuten kuvauksia ja yhteystietoja, ei lähetetä mallille.',
        newConversation: 'Uusi keskustelu',
        noConversations: 'Ei tallennettuja keskusteluja.',
        deleteConversation: 'Poista keskustelu',
        deleteConfirm: 'Haluatko varmasti poistaa tämän keskustelun? Tätä ei voi perua.',
        deleted: 'Keskustelu poistettu',
        deleteFailed: 'Keskustelun poisto epäonnistui',
      },
      dateRange: 'Aikaväli',
      range: {
        thisWeek: 'Tämä viikko',
        lastWeek: 'Viime viikko',
        last30Days: '30 päivää',
        thisMonth: 'Tämä kuukausi',
        lastMonth: 'Viime kuukausi',
        thisYear: 'Tämä vuosi',
        lastYear: 'Viime vuosi',
        custom: 'Mukautettu',
      },
      entitySummary: 'Yhteenveto',
      totalKeys: 'Avaimia yhteensä',
      totalApartments: 'Asuntoja',
      totalResidents: 'Asukkaita',
      totalCondominiums: 'Taloyhtiöitä',
      totalUsers: 'Käyttäjiä',
      keysPerDay: 'Päivittäin luovutetut ja palautetut avaimet',
      keysPerDayTitle: 'Avainten luovutukset ja palautukset',
      keysPerDayDescription: 'Avainten luovutusten ja palautusten määrä valitulla ajanjaksolla.',
      keysGiven: 'Luovutetut avaimet',
      keysReturned: 'Palautetut avaimet',
      dateLabel: '{{date}}',
      serviceRequests: 'Palvelupyyntöjen mittarit',
      serviceRequestsTitle: 'Palvelupyynnöt',
      serviceRequestsDescription: 'Yhteenveto avoimista palvelupyynnöistä ja ratkaisunopeudesta.',
      openRequests: 'Avoimet pyynnöt',
      openRequestsShort: 'Avoimet',
      inProgressRequests: 'Käsittelyssä olevat',
      inProgressRequestsShort: 'Käsittelyssä',
      waitingForResponseRequests: 'Vastausta odottavat',
      waitingForResponseRequestsShort: 'Odottaa vastausta',
      resolvedRequests: 'Ratkaistut',
      resolvedRequestsShort: 'Ratkaistut',
      closedRequests: 'Suljetut',
      closedRequestsShort: 'Suljetut',
      requests: 'Pyynnöt',
      resolvedLast30Days: 'Ratkaistu 30 päivän aikana',
      averageResolutionTimeTitle: 'Keskimääräinen ratkaisu-aika',
      hours: 'h',
      minutes: 'min',
      seconds: 's',
      notEnoughResolutionData: 'Ratkaistuja pyyntöjä ei vielä ole riittävästi keskiarvon laskemiseen.',
      noKeyEvents: 'Valitulla ajanjaksolla ei ole avainten luovutuksia tai palautuksia.',
      inspectionsTitle: 'Tarkastukset',
      inspectionsDescription: 'Tarkastusten määrä valitulla ajanjaksolla.',
      noUpkeepData: 'Valitulla ajanjaksolla ei ole tarkastuksia.',
      exportPdf: 'Vie PDF',
      exportPdfFailed: 'PDF:n vienti epäonnistui.',
      exportPdfAria: 'Lataa tilastoraportti PDF-tiedostona',
      pdf: {
        documentTitle: 'Tilastoraportti',
        generated: 'Luotu: {{date}}',
        company: 'Yritys: {{name}}',
        period: 'Ajanjakso: {{from}} – {{to}}',
        tableDate: 'Päivä',
        tableGiven: 'Luovutettu',
        tableReturned: 'Palautettu',
        tableCount: 'Määrä',
        fileName: 'tilastot_{{from}}_{{to}}',
      },
    },
    billing: {
      title: 'Laskutus',
      tabBillingAccounts: 'Asiakkuudet',
      tabBilling: 'Luo lasku',
      tabInvoices: 'Laskut',
      tabPricelists: 'Hinnastot',
      stepConfigure: 'Vaihe 1: Asetukset',
      stepPreview: 'Vaihe 2: Esikatselu ja muokkaus',
      billingAccount: 'Asiakkuus',
      billingAccountPlaceholder: 'Valitse asiakkuus',
      dateRange: 'Aikaväli',
      dateFrom: 'Alkupäivä',
      dateTo: 'Loppupäivä',
      auditSection: 'Tapahtumatyypit',
      auditCondominium: 'Taloyhtiöt',
      auditApartment: 'Asunnot',
      auditKey: 'Avaimet',
      auditResident: 'Asukkaat',
      auditUpkeep: 'Tarkastukset',
      auditServiceRequest: 'Palvelupyynnöt',
      keyHistoryGive: 'Luovutus',
      keyHistoryReturn: 'Palautus',
      keyHistoryLost: 'Kadonnut',
      keyHistoryFound: 'Löytynyt',
      keyHistorySection: 'Avainhistorian tapahtumat',
      useKeyHistoryBatches: 'Laskuta avainhistoriat per erä',
      useKeyHistoryBatchesHint:
        'Erän hinta on 1 × yksikköhinta, ei avainkohtainen. Kaikki erän avainhistoriat merkitään laskutetuiksi.',
      generatePreview: 'Luo esikatselu',
      generatingPreview: 'Luodaan…',
      back: 'Takaisin',
      addRow: 'Lisää rivi',
      combineSelected: 'Yhdistä valitut',
      removeSelected: 'Poista valitut',
      selectBillingAccount: 'Valitse asiakkuus.',
      customRangeIncomplete: 'Valitse alkamis- ja päättymispäivä.',
      previewFailed: 'Esikatselun luonti epäonnistui.',
      selectEventType: 'Valitse vähintään yksi tapahtumatyyppi.',
      skippedBilledCount: '{{count}} jo laskutettua tapahtumaa ohitettiin.',
      keyCount: '{{count}} avainta',
      createInvoice: 'Luo lasku',
      creatingInvoice: 'Luodaan…',
      createInvoiceHint: 'Hinnat ovat verottomia. ALV lisätään laskulle.',
      dueDate: 'Eräpäivä',
      dueDateRequired: 'Valitse eräpäivä.',
      vatPercent: 'ALV (%)',
      vatPercentInvalid: 'Anna ALV-prosentti väliltä 0–100.',
      netTotal: 'Veroton',
      vatAmount: 'ALV {{percent}} %',
      grossTotal: 'Verollinen',
      invoiceEmpty: 'Lisää vähintään yksi rivi ennen laskun luontia.',
      invoiceCreated: 'Lasku luotu',
      invoiceCreateFailed: 'Laskun luonti epäonnistui',
      invoiceVoided: 'Lasku mitätöity',
      invoiceVoidFailed: 'Laskun mitätöinti epäonnistui',
      invoicePdfFailed: 'Laskun PDF-lataus epäonnistui',
      invoicePdfFilename: 'lasku-{{id}}.pdf',
      downloadInvoicePdf: 'Lataa PDF',
      voidInvoice: 'Mitätöi lasku',
      voidInvoiceConfirm:
        'Mitätöidäänkö tämä lasku? Lähdetapahtumat vapautuvat uudelleen laskutettaviksi. Lasku jää historiaan.',
      invoiceCustomer: 'Asiakas',
      invoiceStatusLabel: 'Tila',
      invoiceStatus: {
        issued: 'Avoin',
        void: 'Mitätöity',
      },
      period: 'Jakso',
      referenceNumber: 'Viite',
      payerBusinessId: 'Y-tunnus',
      payerAddress: 'Laskutusosoite',
      invoiceNumber: 'Lasku {{id}}',
      invoiceDetailTitle: 'Lasku',
      invoiceNotFound: 'Laskua ei löytynyt',
      searchInvoices: 'Hae laskuja...',
      noInvoices: 'Ei laskuja.',
      pdfSubtitle: 'Jakso {{period}} · Luotu {{createdAt}}',
      combineNeedTwo: 'Valitse vähintään kaksi riviä yhdistettäväksi.',
      combineModalTitle: 'Yhdistä rivit',
      combineModalDescription: 'Valitse, miten päivä, summat, luokka ja kuvaus muodostetaan yhdistetylle riville.',
      combineAmountSection: 'Summa',
      combineAmountSum: 'Laske rivien summat yhteen',
      combineAmountSumHint: 'Määrät lasketaan yhteen ja yksikköhinta johdetaan niin, että rivin summa on {{total}}.',
      combineAmountCustom: 'Oma summa',
      combineCustomTotalInvalid: 'Anna kelvollinen summa (vähintään 0).',
      combineDateFromRow: 'Päivän lähderivi (rivin alkuperäinen päivä)',
      combineDateRowOption: 'Rivi {{index}} · {{date}}',
      combineCategoryFromRow: 'Luokan lähderivi',
      combineDescriptionFromRow: 'Kuvauksen lähderivi',
      combineConfirm: 'Yhdistä',
      combineRowPickerOption: 'Rivi {{index}} · {{date}} · {{category}} · {{description}} · {{total}}',
      summaryRowCount: 'Rivejä: {{count}}',
      grandTotal: 'Yhteensä',
      tableSelectAll: 'Valitse kaikki rivit',
      rowSelect: 'Valitse rivi',
      noLineItems: 'Ei rivejä. Lisää rivi tai palaa asetuksiin ja luo esikatselu.',
      colDate: 'Päivä',
      colCategory: 'Luokka',
      colDescription: 'Kuvaus',
      colCondominium: 'Taloyhtiö',
      colApartment: 'Asunto',
      colQuantity: 'Määrä',
      colUnitPrice: 'Yksikköhinta (€)',
      colTotal: 'Summa (€)',
      quantityUnit: 'kpl',
      previewCategoryKeyHistory: 'Avainhistoria',
      previewCategoryKeyHistoryAdditionalWork: 'Avainhistorian lisätyö',
      editLineItems: 'Muokkaa',
      stopEditingLineItems: 'Lopeta muokkaaminen',
      exportCsv: 'Vie CSV',
      csvKeyId: 'Avain (ID)',
      csvCondominiumId: 'Kiinteistö (ID)',
      csvApartmentId: 'Tila (ID)',
      dateTimeTimeAria: 'Kellonaika',
      exportPdf: 'Vie PDF',
      pdfTitle: 'Laskutuksen esikatselu',
      pdfTitleWithAccount: 'Laskutuksen esikatselu — {{name}}',
    },
    pricelists: {
      noPermission: 'Sinulla ei ole oikeutta hallita hinnastoja.',
      searchPlaceholder: 'Hae hinnastoja...',
      createButton: 'Luo hinnasto',
      createTitle: 'Luo hinnasto',
      editTitle: 'Muokkaa hinnastoa: {{name}}',
      deleteTitle: 'Poista hinnasto',
      namePlaceholder: 'Esim. perushinnasto 2025',
      empty: 'Ei hinnastoja. Luo hinnasto määrittääksesi oletushinnat laskutukselle.',
      ratesSection: 'Hinnat tapahtumatyypeittäin (EUR)',
      detailLoadError: 'Hinnaston lataus epäonnistui. Sulje ikkuna ja yritä uudelleen.',
      rateKey: {
        keyHistory: 'Oletus (tuntematon tapahtuma)',
      },
    },
    teams: {
      title: 'Tiimit',
      createButton: 'Luo tiimi',
      createTitle: 'Luo uusi tiimi',
      editTitle: 'Muokkaa tiimiä: {{name}}',
      deleteTitle: 'Poista tiimi',
      members: 'Jäsenet',
      namePlaceholder: 'Tiimin nimi',
      noTeams: 'Tiimejä ei löytynyt.',
      noUsersAvailable: 'Käyttäjiä ei saatavilla.',
      searchMembersPlaceholder: 'Hae nimellä tai sähköpostilla…',
      membersShownOfTotal: '{{visible}} / {{total}} käyttäjää',
      selectAllShown: 'Valitse kaikki näkyvät',
      deselectShown: 'Poista näkyvät valinnasta',
    },
    serviceProviders: {
      searchPlaceholder: 'Hae palveluntarjoajia...',
      unlinkTitle: 'Poistetaanko linkitys?',
      unlinkMessage: 'Poistetaanko linkitys palveluntarjoajaan {{name}} tältä kiinteistöltä?',
      deleteMessage: 'Poistetaanko palveluntarjoaja {{name}}?',
      title: 'Palveluntarjoajat',
      createButton: 'Luo palveluntarjoaja',
      createTitle: 'Luo uusi palveluntarjoaja',
      editTitle: 'Muokkaa palveluntarjoajaa: {{name}}',
      deleteTitle: 'Poista palveluntarjoaja',
      noServiceProviders: 'Palveluntarjoajia ei löytynyt.',
      noneLinked: 'Ei linkitettyjä palveluntarjoajia.',
      editLinks: 'Linkitä palveluntarjoaja',
      editLinksTitle: 'Palveluntarjoajien linkitys',
      linkedAtCondominiumHint:
        'Palveluntarjoajat linkitetään kiinteistöön {{name}} ja näkyvät kaikissa sen tiloissa. Niitä ei lisätä tilakohtaisesti.',
      linkCondominium: 'Linkitä kiinteistö',
      linkCondominiumTitle: 'Linkitä kiinteistöjä',
      unlinkCondominiumTitle: 'Poista kiinteistön linkitys',
      unlinkCondominiumMessage: 'Poistetaanko linkitys kiinteistöön {{name}}?',
      linkSuccess: 'Kiinteistö linkitetty',
      unlinkSuccess: 'Linkitys poistettu',
      unlinkConfirm: 'Poista linkitys',
      fields: {
        name: 'Nimi',
        phone: 'Puhelinnumero',
        address: 'Osoite',
        type: 'Tyyppi',
        members: 'Käyttäjät',
      },
      namePlaceholder: 'Palveluntarjoajan nimi',
      phonePlaceholder: 'Puhelinnumero',
      types: {
        maintenance_company: 'Huoltoyhtiö',
        cleaning: 'Siivouspalvelu',
        property_manager: 'Isännöitsijä',
        rental_agency: 'Vuokravälitys',
      },
    },
    roles: {
      permissionCount: '{{count}} kpl',
      globalRole: 'Globaali rooli',
      ownerDescription:
        'Jos omistajaksi valitaan yritys, rooli on käytettävissä vain kyseisen yrityksen käyttäjille. Jos jätetään tyhjäksi, rooli on globaali.',
      editRole: 'Muokkaa roolia: {{name}}',
      createRole: 'Luo uusi rooli',
      name: 'Nimi',
      namePlaceholder: 'Esim. Järjestelmänvalvoja',
      canBeInvited: 'Voidaan kutsua',
      canBeInvitedDescription: 'Sallii tämän roolin valinnan kutsuja luotaessa',
      hideRole: 'Piilota rooli',
      hideRoleDescription: 'Vain Super Admin voi nähdä ja käyttää tätä roolia',
      dashboardType: 'Näkymä',
      dashboardTypeDefault: 'Oletus',
      dashboardTypeExternalServiceProvider: 'Ulkopuolinen toimija',
      dashboardTypeDescription: 'Valitse mikä näkymä käyttäjälle näytetään kirjautumisen jälkeen',
      filterPermissions: 'Hae käyttöoikeuksia...',
      selectedPermissions: 'Valittu {{count}} käyttöoikeutta',
    },
    users: {
      title: 'Käyttäjät',
      searchPlaceholder: 'Hae käyttäjiä...',
    },
    user: {
      title: 'Käyttäjä',
      users: 'Käyttäjät',
      userDetails: 'Käyttäjän tiedot',
      name: 'Nimi',
      phone: 'Puhelinnumero',
      active: 'Aktiivinen',
      notFound: 'Käyttäjää ei löytynyt',
      firstName: 'Etunimi',
      lastName: 'Sukunimi',
      email: 'Sähköposti',
      firstNamePlaceholder: 'Esim. Matti',
      lastNamePlaceholder: 'Esim. Meikäläinen',
      emailPlaceholder: 'matti@example.com',
      editProfile: 'Muokkaa profiilia: {{name}}',
      cannotChangeRole: 'Roolia ei voi muuttaa itse. Ota yhteyttä järjestelmänvalvojaan.',
      saveChanges: 'Tallenna muutokset',
      phoneNumber: 'Puhelinnumero',
      company: 'Yritys',
      role: 'Rooli',
      externalServiceProviderAdditionalInfo: 'Toimijan lisätieto',
      deleteUser: 'Poista käyttäjä',
      deleteUserConfirm: 'Haluatko varmasti poistaa käyttäjän "{{name}}"?',
      activeYes: 'Aktiivinen',
      activeNo: 'Ei aktiivinen',
      noUsersYet: 'Tällä hetkellä ei ole yhtään käyttäjää.',
      noUsersForSearch: 'Ei käyttäjiä haulle "{{searchTerm}}"',
      deleteFromCompanyMessage:
        'Poista käyttäjä "{{entityName}}" tästä yrityksestä. Käyttäjä säilyttää pääsyn {{remaining}} muuhun yritykseen.',
      deleteLastCompanyMessage: 'Tämä on käyttäjän "{{entityName}}" ainoa yritys. Käyttäjätili poistetaan kokonaan.',
      changePasswordTitle: 'Vaihda salasana',
      newPassword: 'Uusi salasana',
      confirmPassword: 'Vahvista salasana',
      passwordMinLength: 'Vähintään 8 merkkiä',
      passwordRepeat: 'Kirjoita salasana uudelleen',
      passwordRequirements: 'Salasanan tulee sisältää vähintään 8 merkkiä, yksi pieni kirjain, iso kirjain ja numero.',
      passwordValidationLength: 'Salasanan tulee olla vähintään 8 merkkiä pitkä',
      passwordValidationComplexity: 'Salasanan tulee sisältää vähintään yksi pieni kirjain, iso kirjain ja numero',
      passwordValidationMatch: 'Salasanojen tulee olla samat',
    },
    import: {
      selectType: 'Valitse tuontityyppi',
      condominiums: 'Taloyhtiöt',
      apartments: 'Asunnot',
      keys: 'Avaimet',
      residents: 'Asukkaat',
      trackedAssets: 'Laitteet',
      downloadTemplate: 'Lataa pohja',
      uploadFile: 'Lataa tiedosto',
      dragDrop: 'Vedä ja pudota CSV-tiedosto tähän tai klikkaa valitaksesi',
      onlyCSV: 'Vain CSV-tiedostot hyväksytään',
      previewEdit: 'Esikatsele ja muokkaa tietoja',
      validRecords: 'kelvollista',
      withErrors: 'virheellisiä',
      uploadNew: 'Lataa uusi tiedosto',
      importRecords: 'Tuo {{count}} tietuetta',
      backToSelection: 'Takaisin tyypinvalintaan',
      importing: 'Tuodaan...',
      importSuccess: 'Tuonti onnistui!',
      successMessage: 'Onnistuneesti tuotu {{count}} {{type}}!',
      partialSuccessMessage: 'Tuotu {{success}} {{type}}, {{errors}} epäonnistui',
      partialImportRemainingHint:
        'Onnistuneet rivit on jo tallennettu. Alla näkyvät vain epäonnistuneet rivit — korjaa ne ja yritä uudelleen.',
      allFailedMessage: 'Kaikkien {{count}} {{type}} tuonti epäonnistui',
      systemError: 'Järjestelmävirhe tuonnissa',
      importError: 'Tuonnissa tapahtui virhe',
      status: 'Tila',
      actions: 'Toiminnot',
      required: 'Pakollinen',
      notFound: 'Ei löytynyt',
      invalidEmail: 'Virheellinen sähköpostiosoite',
      selectOption: 'Valitse...',
      delimiter: 'CSV-erotin',
      autoDetect: 'Tunnista automaattisesti',
      comma: 'Pilkku (,)',
      semicolon: 'Puolipiste (;)',
      tab: 'Sarkain',
      pipe: 'Pystyviiva (|)',
      mappingSuggested: 'Sarakkeet tunnistettiin automaattisesti.',
      mappingReviewTitle: 'Tarkista sarakkeiden yhdistäminen',
      mappingReviewDescription:
        'Valitse kullekin CSV-sarakkeelle vastaava kenttä. Pakolliset kentät on merkitty tähdellä (*).',
      mappingSourceColumn: 'CSV-sarake',
      mappingTargetField: 'Kohdekenttä',
      mappingSkipColumn: 'Älä tuo',
      mappingConfirm: 'Jatka tarkistukseen',
      howToUseSummary: 'Valitse tyyppi, lataa CSV, tarkista rivit ja tuo. Laajenna nähdäksesi yksityiskohdat.',
      howToExpand: 'Näytä ohje',
      howToCollapse: 'Piilota ohje',
      excelCsvHint: 'Excelistä: Tallenna nimellä → CSV UTF-8 (.csv). .xlsx-tiedostoja ei tueta.',
      noCompanyTitle: 'Valitse yritys',
      noCompanyDescription:
        'Tuonti vaatii aktiivisen yrityksen. Valitse yritys yläpalkista tai alla olevasta valitsimesta ennen jatkamista.',
      resolvingHeaders: 'Tunnistetaan sarakkeita…',
      customCsvNotice:
        'Voit käyttää myös omaa CSV-tiedostoasi: ensimmäisen rivin tulee olla otsikkorivi (sarakkeiden nimet). Järjestelmä yrittää yhdistää sarakkeet oikeisiin kenttiin. Voit myös ladata valmiin pohjan.',
      errors: {
        nameRequired: 'Nimi on pakollinen',
        categoryRequired: 'Kategoria on pakollinen',
        streetRequired: 'Katuosoite on pakollinen',
        postalCodeRequired: 'Postinumero on pakollinen',
        postalCodeInvalid: 'Virheellinen postinumero',
        cityRequired: 'Kaupunki on pakollinen',
        superintendentNotFound: 'Ei löytynyt',
        lockTypeNotFound: 'Ei löytynyt',
        keyTypeNotFound: 'Ei löytynyt',
        onlyGeneralKeyTypes: 'Vain yleiset avaintyypit ovat sallittuja KeyType-kentässä',
        apartmentKeyTypeNotFound: 'Ei löytynyt',
        onlyNonGeneralKeyTypes: 'Vain ei-yleiset avaintyypit ovat sallittuja ApartmentKeyType-kentässä',
        condominiumNotFound: 'Ei löytynyt',
        condominiumRequired: 'Taloyhtiö on pakollinen',
        keyTypeRequired: 'Avaintyyppi on pakollinen',
        lockTypeRequired: 'Lukkotyyppi on pakollinen',
        apartmentRequired: 'Asunnon osoite on pakollinen',
        keyStampRequired: 'Avaimen leima on pakollinen',
        apartmentNotAllowedForGeneral: 'Asuntoa ei voi määrittää yleisille avaimen tyypeille',
        condominiumRequiredForGeneral: 'Taloyhtiö on pakollinen yleisille avaimen tyypeille',
        condominiumNotAllowedForNonGeneral: 'Taloyhtiötä ei voi määrittää ei-yleisille avaimen tyypeille',
        apartmentRequiredForNonGeneral: 'Asunto on pakollinen ei-yleisille avaimen tyypeille',
        apartmentNotFound: 'Ei löytynyt',
        firstNameRequired: 'Etunimi on pakollinen',
        lastNameRequired: 'Sukunimi on pakollinen',
        emailRequired: 'Sähköpostiosoite on pakollinen',
        invalidEmailFormat: 'Virheellinen sähköpostin muoto',
        emailAlreadyExists: 'Sähköpostiosoite on jo käytössä',
        residentAlreadyExists: 'Asukas ({{firstName}} {{lastName}}) on jo olemassa',
        csvParsingFailed: 'CSV-tiedoston jäsentäminen epäonnistui',
        unknownImportType: 'Tuntematon tuontityyppi',
        missingRequiredColumns: 'Pakolliset sarakkeet puuttuvat',
        unrecognizedColumns: 'Tunnistamattomat sarakkeet',
        mappingMissingTargets: 'Näitä pakollisia kenttiä ei voitu yhdistää CSV:n sarakkeisiin: {{fields}}',
        mappingSuggestFailed: 'Sarakemappingin ehdotus epäonnistui. Käytä CSV-pohjaa tai tarkista otsikkorivi.',
        fileTooLarge: 'Tiedosto on liian suuri (max {{maxSize}})',
        serverError: 'Palvelinvirhe',
        noCompanySelected: 'Valitse yritys ennen tuontia',
      },
      stepper: {
        selectType: 'Valitse tyyppi',
        upload: 'Lataa tiedosto',
        review: 'Tarkista',
        import: 'Tuo',
      },
      fields: {
        name: 'Nimi',
        apartmentName: 'Asunnon nimi',
        number: 'Numero',
        addressStreet: 'Katuosoite',
        addressPostalCode: 'Postinumero',
        addressCity: 'Kaupunki',
        businessId: 'Y-tunnus',
        identifier: 'Kiinteistötunnus',
        superIntendent: 'Hallinnoija',
        lockType: 'Lukkotyyppi',
        keyType: 'Avaintyyppi',
        apartmentKeyType: 'Asuntoavaintyyppi',
        condominium: 'Taloyhtiö',
        stamp: 'Avaimen leima',
        apartmentAddress: 'Asunnon osoite',
        firstName: 'Etunimi',
        lastName: 'Sukunimi',
        email: 'Sähköposti',
        phone: 'Puhelin',
        tags: 'Tagit',
      },
      rows: 'riviä',
      noRowsToReview: 'Kaikki rivit on poistettu. Lataa uusi tiedosto tai palaa valitsemaan eri tuontityyppi.',
      removeInvalidRows: 'Poista virheelliset rivit',
      clearOptionalHint: 'Valinnaiset kentät virheellisillä arvoilla voi tyhjentää ✕-painikkeella.',
      confirmImportTitle: 'Vahvista tuonti',
      confirmImportMessage: '{{count}} {{type}} tuodaan. {{skipped}} virheellistä riviä ohitetaan.',
      confirmImportButton: 'Tuo {{count}} tietuetta',
      importMoreSameType: 'Tuo lisää {{type}}',
      maxFileSize: 'max {{maxSize}}',
      pagination: {
        showing: 'Näytetään {{from}}-{{to}} / {{total}}',
      },
      howToUse: 'Käyttöohje',
      step1: 'Vaihe 1',
      step1Description: 'Valitse tuontityyppi (taloyhtiöt, asunnot, avaimet, asukkaat tai laitteet)',
      step2: 'Vaihe 2',
      step2Description: 'Lataa CSV-pohja ja täytä se tiedoillasi',
      step3: 'Vaihe 3',
      step3Description: 'Lataa täytetty CSV-tiedosto järjestelmään',
      step4: 'Vaihe 4',
      step4Description: 'Tarkista ja muokkaa tietoja, korjaa virheet ja suorita tuonti',
      autopopulateTitle: 'Automaattinen täyttö',
      autopopulateDescription:
        'Järjestelmä täyttää automaattisesti pudotusvalikot kun tunnistaa olemassa olevia tietoja:',
      autopopulateExample1: 'Hallinnoijan nimi "Matti Meikäläinen" löytää automaattisesti käyttäjän',
      autopopulateExample2: 'Lukko- ja avaintyypit täytetään nimen perusteella',
      autopopulateExample3: 'Taloyhtiöt ja asunnot tunnistetaan nimien ja osoitteiden perusteella',
      condominiumsInstructions: 'Taloyhtiöjen tuonti',
      condominiumsInstructionsDescription: 'Täytä vähintään nimi ja osoitetiedot. Muut kentät ovat valinnaisia.',
      condominiumsFieldSuperIntendent: 'Hallinnoija: Täydellinen nimi (esim. "Matti Meikäläinen")',
      condominiumsFieldLockType: 'Lukkotyyppi: Olemassa olevan lukkotyypin nimi',
      condominiumsFieldKeyTypes: 'Avaintyypit: Pääavain ja asuntoavain nimillä',
      condominiumsFieldIdentifier: 'Kiinteistötunnus: Maanmittauslaitoksen kiinteistötunnus (esim. 123-456-7890-1)',
      apartmentsInstructions: 'Asuntojen tuonti',
      apartmentsInstructionsDescription: 'Osoite ja taloyhtiö ovat pakollisia tietoja.',
      apartmentsFieldCondominium: 'Taloyhtiö: Olemassa olevan taloyhtiön nimi',
      apartmentsFieldAddress: 'Osoite: Täydellinen katuosoite, postinumero ja kaupunki',
      keysInstructions: 'Avainten tuonti',
      keysInstructionsDescription:
        'Avaimen leima ja tyyppi ovat pakollisia. Valinnainen näyttönimi voidaan antaa sarakkeessa "name". Yleisille avaimille vain taloyhtiö, muille avaimille vain asunto.',
      keysFieldTypes: 'Avaintyyppi: Mikä tahansa olemassa oleva avaintyyppi (yleinen avain tai asuntoavain)',
      keysFieldName: 'Nimi (name): valinnainen näyttönimi listoissa ja haussa; eri asia kuin fyysinen leima',
      keysFieldApartment: 'Asunto: Täydellinen osoite (vain avaimille, jotka eivät ole yleisiä avaimia)',
      keysFieldCondominium: 'Taloyhtiö: Olemassa olevan taloyhtiön nimi (vain yleisille avaimille)',
      residentsInstructions: 'Asukkaiden tuonti',
      residentsInstructionsDescription: 'Nimi, sähköposti ja asunto ovat pakollisia.',
      residentsFieldApartment: 'Asunto: Täydellinen osoite muodossa "Katu, Postinumero Kaupunki"',
      residentsFieldEmail: 'Sähköposti: Kelvollinen sähköpostiosoite pakollinen',
      editingTip: 'Muokkausvinkki',
      editingTipDescription:
        'Klikkaa pudotusvalikkoja nähdäksesi käytettävissä olevat vaihtoehdot. Virheelliset kentät näkyvät punaisina. Korjaa kaikki virheet ennen tuontia.',
      bulkFill: 'Aseta kaikille',
      removeRow: 'Poista rivi',
      showOnlyInvalid: 'Näytä vain virheelliset',
      showAll: 'Näytä kaikki',
      applyToAll: '→',
      csvRow: 'Rivi',
      rowsShort: 'riviä',
      errorSummaryTitle: 'Virheiden yhteenveto',
      errorSummarySubtitle: '{{count}} riviä virheellisiä',
      moreErrorTypes: '+ {{count}} muuta tyyppiä',
      nextError: 'Seuraava virhe',
    },
    privacyPolicy: {
      header: 'Tietosuojaseloste',
    },
    changelog: {
      header: 'Muutosloki',
      current: 'Nykyinen versio',
      bannerTitle: 'Uutta versiossa v{{version}}',
      bannerSummary: 'Tarkastusten jatkotoimet, selkeämpi huoltojen kirjaus ja sujuvampi viestintä.',
      bannerLink: 'Avaa koko muutosloki',
      bannerDismiss: 'Sulje',
      bannerAriaLabel: 'Uuden version ilmoitus',
      added: 'Lisätty',
      fixed: 'Korjattu',
      improvements: 'Parannuksia',
      v4_5_2: {
        added1: 'Tarkastusten luonnokset, raportit ja jatkotoimien seuranta samassa työnkulussa',
        added2: 'Yrityksen tietojen vienti ZIP-tiedostona käyttöoikeuden mukaan',
        added3: 'Palvelupyyntöjen kuva- ja PDF-liitteiden esikatselu',
        improvements1: 'Huollon tuloksen ja havaintojen kirjaus sekä selkeämpi tarkastusketju',
        improvements2:
          'Viestit latautuvat erissä, ja ensimmäinen vastaaja saa ilmoituksen vastuuhenkilöksi siirtymisestä',
        improvements3: 'Selkeämmät lomakevirheet, liitteiden käsittely ja mobiilin toimintovalikot',
        fixed1: 'Avainten haltija, eräpäivä ja myöhästyneet lainat näkyvät johdonmukaisesti',
        fixed2: 'Listojen suodattimet, välilehtien määrät ja karttapohjan lataus toimivat luotettavammin',
        fixed3: 'Huoltoraporttien uudelleenyritykset, tietoturva ja CSV-vientien turvallisuus',
      },
      v4_5_1: {
        added1: 'Keskustelulista ESP-viesteihin sekä asukas- ja vuokranantajaportaaleihin',
        improvements1:
          'Portaalin ja henkilöstön chat-näkymän viimeistely (värit, kiinnittyvät välilehdet, lyhyet ketjut)',
        improvements2: 'Lukemattomien merkit ja uusien viestien erotin portaaleissa',
        fixed1: 'Mobiilin toimintovalikko ei enää avaa taulukon riviä alta',
        fixed2: 'Lomakkeiden 16 px -teksti puhelimella estää iOS-zoomin',
        fixed3: 'Hallinnan luontipainikkeet näkyvät myös mobiilissa',
        fixed4: 'Analytiikan porautuminen pysyy auki suodattimien päivittyessä',
        fixed5: 'Huollon muistiinpanot tallentuvat oikein',
      },
      v4_5_0: {
        added1: 'Sovelluksen avustaja: keskustelu ja luonti samasta kuplasta',
        added2: 'Laskutus: laskujen luonti, listaus ja mitätöinti',
        added3: 'Asiakirjapankissa voi nimetä uudelleen, esikatsella, palauttaa ja hakea',
        added4: 'Vajaa avainpalautus ja ehdotus saman luovutuserän avaimista',
        added5: 'Yrityksen muistutusaikataulut sekä vuokranantajan vuosikorotuspäätös portaalissa',
        added6: 'Asuntojonon välilehti henkilöstölle',
        improvements1: 'Yhtenäinen tiivis yksityiskohtasivu ja selkeämmät mobiilikortit',
        improvements2: 'Portaaleissa kielivalinta sekä lajiteltavat ja suodatettavat taulukot',
        improvements3: 'Kalenteri viikko- tai päivänäkymänä; tiimit näkyvät vastuutiiminä',
        improvements4: 'Palvelupyyntötyypeille HTML-automaattivastaus',
        fixed1: 'Listojen haku ja suodattimet pysyvät yhdellä rivillä puhelimella',
        fixed2: 'Mobiilinavigointi, välilehdet ja portaalin toiminnot eivät enää peitä sisältöä',
      },
      v4_4_x: {
        added1:
          'Vuokraus — ilmoitukset, hakijat, vuokrasopimukset, välityssopimukset, laskutus ja näyttöajat yhdessä kokonaisuudessa',
        added2:
          'Julkiset vuokrailmoitukset ja hakemukset; sähköinen allekirjoitus PDF-tallenuksella dokumenttipankkiin',
        added3: 'Vuokranantaja- ja asukasportaalissa vuokrasopimukset, laskut, hakijaehdotukset ja allekirjoitukset',
        added4: 'Lopputarkastukset, vakuuden palautus ja avainten palautus vuokrasuhteen päättyessä',
        added5: 'Laitepankki, projektit ja ylläpidon talous — kustannuspaikat, suunnitelmat, tavoitteet ja riskit',
        added6:
          'Laitteille päälaite ja osat, laitteen oma sivu sekä huolto epäonnistuneesta tai onnistuneesta kierroksesta',
        added7: 'Analytiikkakeskustelu raporttisivulla ja tiedostoliitteet viesteihin',
        added8: 'Hallinnassa suodatettujen tietojen siirto 7 päivän roskakoriin',
        added9: 'Asukas voi jättää palvelupyynnön kirjautumatta; lomakkeen voi upottaa yrityksen sivulle',
        added10: 'Yrityksen aukioloajat, pikaluonti sekä asukasvälilehti kiinteistön sivulle',
        added11: 'Avainten eräpäivän vaihto usealle kerralla ja saman haltijan avaimet palautuskoriin',
        improvements1: 'Yrityksen asetukset ohjaavat selkeämmin, mitkä osiot näkyvät valikossa ja näkymissä',
        improvements2: 'Portalit, mobiilinäkymät ja navigaation Lisää-valikko toimivat sujuvammin',
        improvements3: 'Kirjautuminen, työpöytä ja listat latautuvat nopeammin ja hyppivät vähemmän',
        improvements4: 'Huoltosykli lasketaan jakson alusta; kirjaus on selkeämpi laitteittain',
        improvements5:
          'Sähköpostipohjat yhtenäistetty Xkey-brändiin; käyttöohjeet ja ulkoisen toimijan opas päivitetty',
        improvements6: 'Ylläpidon käyttöopas PDF:nä; lomakepohjan esikatselu vastaa täytettyä lomaketta',
        improvements7: 'Tietoturvaparannuksia koko sovelluksessa',
        improvements8: 'Useita pieniä käyttöliittymäkorjauksia sekä parannuksia poistettujen tietojen palautukseen',
        fixed1: 'Huollon mobiilinäkymässä otsikot ja vaiheet eivät enää mene päällekkäin',
        fixed2: 'Kartta ja viestit eivät jatka toimintaansa näkymän sulkemisen jälkeen',
        fixed3: 'Hallinta → Tapahtumat näyttää taas, miten muokattua riviä on muutettu',
      },
      v4_3_x: {
        added1: 'Ylläpito-sivu kokoaa kunnossapidon, investoinnit, talouden ja korjaushistorian yhteen',
        added2: 'Monivaiheinen tunnistus (MFA) kirjautumiseen',
        added3: 'Käyttäjä voi kuulua useaan yritykseen; rooli ja oikeudet tallennetaan yrityskohtaisesti',
        added4: 'Laajennetut käyttöoikeudet ja roolit ulkoisille palveluntarjoajille',
        added5: 'Dokumenttipankkiin tiedostojen jakaminen sekä suodatus- ja sähköpostitoiminnot',
        added6: 'Asukasilmoitukset kiinteistösivulla ja portaalissa',
        added7: 'Luovutusohjeet taloyhtiölle sekä avainhistorian tehtävät -työpöytävimpain',
        added8: 'Vuokranantajaportaalissa kiinteistöjen dokumentit; portaali- ja palvelupyyntölinkkien kopiointi',
        added9: 'Poistetut tarkastukset ja palvelupyynnöt voi palauttaa; kuitin voi lähettää myös toiseen sähköpostiin',
        added10: 'Laskutusosio navigointivalikossa; tallennetut korit voi poistaa',
        improvements1: 'Sovellus toimii huomattavasti paremmin puhelimella ja tabletilla',
        improvements2: 'Useampivaiheiset lomakkeet näyttävät vaiheet selkeämmin',
        improvements3: 'Tarkastuslomakkeita ja PDF-näkymiä laajennettu kenttätyypeillä, mallipohjilla ja esikatselulla',
        improvements4: 'Tunnisteita voi hallita suoraan tunnistepoimijasta lomakkeella',
        improvements5: 'Listat ja yksityiskohdat latautuvat valitun yrityksen mukaan',
        improvements6: 'Avain- ja korimodaalit näyttävät enemmän tietoja ja varoituksia ennen luovutusta',
        improvements7: 'Tekstien ja välien koko sekä työpöydän latausilmoitukset päivitetty',
        fixed1: 'Päivämäärien käsittelyä ja editoria korjattu erityisesti Safarissa ja iOS-laitteilla',
        fixed2: 'Korin tallennus päivittää avainten tilat heti ilman sivun uudelleenlatausta',
        fixed3: 'Useita pieniä korjauksia ja käyttöliittymän parannuksia',
      },
      v4_2_x: {
        added1: 'Asukasportaali — kirjaudu kirjautumislinkillä palvelupyyntöjen tekemiseen ja seurantaan',
        added2: 'Ulkoisen palveluntarjoajan hallintapaneeli osoitettujen palvelupyyntöjen käsittelyyn',
        added3: 'Raporttisivu avain- ja asukastietojen vientiin ja tarkasteluun',
        added4: 'Tunnisteluettelo — lisää värikoodattuja tunnisteita avaimille, huoneistoille ja muille tiedoille',
        added5: 'Tarkastuslomakemallit — uudelleenkäytettävät pohjat, jotka pitävät tarkastukset yhtenäisinä',
        added6:
          'Avainten nimeäminen ja huomiomerkinnät — anna avaimelle nimi ja nosta tärkeät tiedot esiin luovutuksia varten',
        added7:
          'Avainten massaluonti ja -muokkaus — luo avaimia automaattisella numerojärjestyksellä tai muokkaa useita kerralla',
        added8:
          'Luovutuksen allekirjoitus etänä — pyydä allekirjoitus erillisellä laitteella reaaliaikaisella synkronoinnilla',
        added9: 'Useita osoitteita taloyhtiöille ja huoneistoille',
        added10: 'Tiedostoliitteet huoneistoille',
        added11: 'QR-koodien PDF-lataus tallennetuista koreista',
        improvements1:
          'Uudistettu luovutusvaihe — helpompi valita asukas ja kohde, luoda avaimia luovutuksen yhteydessä ja tarkistaa tiedot ennen viimeistelyä',
        improvements2: 'Allekirjoitus toimii sujuvammin: parempi kosketustuki ja koko näytön tila',
        improvements3:
          'Parempi työpöytä — parannettu mobiilituki, haku ja sivutus vimpaimissa sekä suorat linkit listanäkymiin',
        improvements4: 'Vuokranantaja- ja asukasportaalit — selkeämpi ulkoasu, monikielisyys ja helpompi navigointi',
        improvements5: 'Yhtenäisempi ulkoasu ja toiminta koko sovelluksessa',
        improvements6: 'Taloyhtiöiden selaus ja haku helpompaa, erityisesti laajoissa kokonaisuuksissa',
        improvements7: 'Tapahtumaloki — ennen- ja jälkeen-arvot muutoksille, helpompi lukea ja selata',
        improvements8:
          'Tiedostojen hallinta — pehmeä poisto palautusmahdollisuudella, tiukemmat käyttöoikeudet ja parannetut tiedostolistat',
        improvements9: 'Tytäryhtiöiden tuki ja helpompi yrityksen vaihtaminen',
        improvements10: 'Jokerimerkkihaku (%) taulukoissa ja listoissa',
        improvements11: 'Parannettu palvelupyyntöjen käsittely, roolien hallinta ja tapahtumaviennit',
        improvements12: 'Tiimitiedot näkyvät käyttäjän tiedoissa ja Omat tiedot -sivulla',
        fixed1: 'Siirrettyjen taloyhtiöiden tallennetut korit toimivat nyt oikein',
        fixed2: 'Vuokranantajaportaali näyttää avainten haltijat oikein kaikissa näkymissä',
        fixed3: 'Selkeämpi kutsu urakoitsijoille ja ulkoisille palveluntarjoajille',
      },
      v4_1_x: {
        added1: 'Palvelupyynnöt huolto- ja palvelupyyntöjen hallintaan',
        added2: 'Tumma teema',
        added3: 'Tarkastaja avaintarkastuksiin, SMS-viestit ja tulostus avainhistorialle',
        added4: 'Tagit taloyhtiöille, huoneistoille, asukkaille ja avaimille',
        added5: 'Suosikit-vimpain usein käytettyjen kohteiden nopeaan avaamiseen',
        added6: 'Muutosloki-sivu ja ohjetekstit sovelluksessa',
        improvements1: 'Parannetut taulukot, käyttöoikeudet, lomakkeet ja yleinen luotettavuus',
        fixed1: 'Avaintoiminnot, pikaohjattu ja syöttökentät',
      },
      v4_0_x: {
        added1:
          'Ensimmäinen versio: täysi avaintenhallinta, käyttäjien ja roolien hallinta sekä suomi, englanti ja ruotsi',
        added2: 'Täysi uudistus modernilla käyttöliittymällä ja uudella teknologialla',
        added3: 'Offline-tuki (PWA), muotoillut ilmoitukset ja yleiset ilmoitukset pääkäyttäjille',
        added4: 'Ostoskori usean avaimen käsittelyyn kerralla',
        improvements1: 'Parempi navigointi ja kiinteistöjen hallinta',
        improvements2: 'Selkeämmät vahvistusikkunat',
        fixed1: 'Yleinen haku',
      },
    },
    guide: {
      title: 'Käyttöohjeet',
      backToIndex: 'Takaisin ohjeisiin',
      notFound: 'Ohjetta ei löytynyt.',
      videosTitle: 'Ohjevideot',
      keyboardShortcutsTitle: 'Pikanäppäimet',
      keyboardShortcutsIntro: 'Pikanäppäimet päätyötilassa:',
      keyboardShortcutsGlobalSearch: 'Avaa yleinen haku.',
      keyboardShortcutsTableSearch:
        'Listasivuilla, joissa on hakukenttä, paina / siirtyäksesi hakuun (vihje näkyy myös kentän kuvauksessa).',
      toc: {
        '01-johdanto-ja-roolit': 'Johdanto ja käyttäjäroolit',
        '02-kirjautuminen-ja-yritysvalinta': 'Kirjautuminen ja yritysvalinta',
        '03-tyopoyta': 'Työpöytä',
        '04-kohteet': 'Kohteet',
        '05-avaimet': 'Avaimet',
        '06-tarkastukset': 'Kunnossapito',
        '07-palvelupyynnot': 'Palvelupyynnöt',
        '22-viestit': 'Viestit',
        '08-hallinta': 'Hallinta',
        '09-ilmoitukset': 'Ilmoitukset',
        '10-oma-sivu': 'Oma sivu',
        '11-haku': 'Haku ja pikanäppäimet',
        '12-julkiset-palvelupyynnot-ja-asukasportaali': 'Julkiset palvelupyynnöt, asukas- ja vuokranantajaportaalit',
        '13-ulkopuolinen-toimija': 'Ulkopuolinen toimija',
        '14-siirto-taloyhtio-alayritykselle': 'Taloyhtiön siirto aliyritykselle',
        '15-api-tunnus-ja-rajapinta': 'API-tunnus ja rajapinta',
        '16-mcp-palvelin': 'MCP-palvelin ja Claude',
        '17-laskutus': 'Laskutus',
        '18-yllapito': 'Ylläpito',
        '19-laitteet-ja-qr': 'Laitteet ja QR-koodit',
        '20-dokumenttipankki': 'Dokumenttipankki',
        '21-vuokranvalitys': 'Vuokranvälitys',
      },
    },
    events: {
      title: 'Tapahtumat',
      loading: 'Ladataan tapahtumia...',
      loadingError: 'Virhe ladattaessa tapahtumia',
      loadingErrorDescription: 'Tapahtumien lataaminen epäonnistui. Yritä uudelleen myöhemmin.',
      noEvents: 'Ei tapahtumia',
      showAll: 'Näytä kaikki',
      noEventsDescription: 'Tällä hetkellä ei ole yhtään tapahtumaa näytettäväksi.',
      search: 'Hae',
      searchPlaceholder: 'Hae nimellä tai tekijällä...',
      entityTypeFilter: 'Kohdetyyppi',
      actionFilter: 'Toiminto',
      all: 'Kaikki',
      eventSingular: 'tapahtuma',
      eventPlural: 'tapahtumaa',
      inSearchResults: 'hakutuloksissa',
      entityType: {
        resident: 'Asukas',
        apartment: 'Asunto',
        condominium: 'Taloyhtiö',
        key: 'Avain',
        landlord: 'Vuokranantaja',
        serviceRequest: 'Palvelupyyntö',
        upkeep: 'Kunnossapito',
        note: 'Muistiinpano',
        company: 'Yritys',
        announcement: 'Ilmoitus',
        presavedCart: 'Tallennettu kori',
        invitation: 'Kutsu',
        role: 'Rooli',
        permission: 'Käyttöoikeus',
        keyType: 'Avaintyyppi',
        lockType: 'Lukkotyyppi',
        serviceRequestType: 'Palvelupyyntötyyppi',
        inspectionType: 'Kunnossapitotyyppi',
        upkeepType: 'Kunnossapitotyyppi',
        rentalListing: 'Vuokrausilmoitus',
        rentalApplicant: 'Vuokraushakija',
        leaseContract: 'Vuokrasopimus',
        brokerageAgreement: 'Välityssopimus',
        brokerageInvoice: 'Vuokrauslasku',
        contractTemplate: 'Sopimuspohja',
        finalInspectionFormTemplate: 'Lopputarkastuspohja',
        leaseFinalInspection: 'Lopputarkastus',
        finalCleaningTemplate: 'Loppusiivouspohja',
        moveInInspectionFormTemplate: 'Muuttotarkastuspohja',
        leaseMoveInInspection: 'Muuttotarkastus',
        viewingSlot: 'Näyttöaika',
        upkeepFormTemplate: 'Kunnossapitopohja',
        maintenanceNeedsAssessment: 'Tarveselvitys',
        repairHistoryReport: 'Korjaushistoria',
        trackedAsset: 'Seurattava omaisuus',
        personalDataPurge: 'Tietojen poisto',
      },
      action: {
        create: 'Luotu',
        update: 'Muokattu',
        delete: 'Poistettu',
        restore: 'Palautettu',
      },
      keyAction: {
        return: 'Palautus',
        give: 'Luovutus',
        lost: 'Kadonnut',
        found: 'Löytynyt',
        unknown: 'Tuntematon',
      },
      changes: {
        show: 'Näytä muutokset',
        hide: 'Piilota muutokset',
        before: 'Ennen',
        after: 'Jälkeen',
        empty: '(tyhjä)',
      },
      auditFields: {
        transferredToCompanyId: 'Siirretty yritykselle',
        transferredAt: 'Siirtoaika',
        subCompanyCanEdit: 'Alayritys voi muokata',
        condominiumIds: 'Linkitetyt taloyhtiöt',
        apartmentIds: 'Linkitetyt asunnot',
        permissionIds: 'Oikeus-ID:t',
        ownerId: 'Omistajayritys',
        typeId: 'Tyyppi-ID',
        assigneeId: 'Vastuuhenkilö',
        formSchema: 'Lomakemäärittely',
        currentHolderInternalId: 'Nykyinen haltija (käyttäjä)',
        currentHolderId: 'Nykyinen haltija (asukas)',
        currentHolderLandlordId: 'Nykyinen haltija (vuokranantaja)',
        currentHolderOther: 'Nykyinen haltija (ulkoinen)',
        originalHolderInternalId: 'Alkuperäinen haltija (käyttäjä)',
        originalHolderId: 'Alkuperäinen haltija (asukas)',
        originalHolderLandlordId: 'Alkuperäinen haltija (vuokranantaja)',
        originalHolderOther: 'Alkuperäinen haltija (ulkoinen)',
        contractorAccess: 'Urakoitsijan käyttöoikeudet',
        externalServiceProviderAccess: 'Palveluntarjoajan käyttöoikeudet',
        isGlobal: 'Yleinen ilmoitus',
        used: 'Kutsu käytetty',
        isExternalServiceProvider: 'Ulkopuolisen toimijan kutsu',
        descriptionFi: 'Kuvaus (suomi)',
        descriptionSv: 'Kuvaus (ruotsi)',
        lost: 'Kadonnut',
        requesterUserId: 'Pyytäjä (käyttäjä)',
      },
      entity: 'Kohde',
      date: 'Päivämäärä',
      performedBy: 'Tekijä',
      performedByLandlordPortal: 'Vuokranantajaportaali',
    },
    residentNotifications: {
      tabTitle: 'Asukasilmoitukset',
      add: 'Lisää ilmoitus',
      createTitle: 'Uusi asukasilmoitus',
      editTitle: 'Muokkaa asukasilmoitusta',
      searchPlaceholder: 'Hae ilmoituksia...',
      empty: 'Ei asukasilmoituksia',
      created: 'Ilmoitus tallennettu',
      updated: 'Ilmoitus päivitetty',
      deleted: 'Ilmoitus poistettu',
      deleteFailed: 'Ilmoituksen poistaminen epäonnistui',
      deleteTitle: 'Poista asukasilmoitus',
      deleteMessage: 'Haluatko varmasti poistaa ilmoituksen "{{title}}"?',
      columns: {
        title: 'Otsikko',
        scope: 'Kohde',
        created: 'Luotu',
      },
      scope: {
        wholeCondominium: 'Koko taloyhtiö',
        apartmentCount: '{{count}} asuntoa',
      },
      field: {
        wholeCondominium: 'Koko taloyhtiö',
        wholeCondominiumHelp: 'Ilmoitus näkyy kaikille taloyhtiön asunnoille asukas- ja vuokranantajaportaalissa.',
        apartments: 'Valitut asunnot',
        apartmentsSearchPlaceholder: 'Hae osoitteella, nimellä tai numerolla...',
        apartmentsSearchNoResults: 'Ei hakutuloksia.',
        apartmentsSelectFiltered: 'Valitse suodatetut ({{count}})',
        apartmentsClearFiltered: 'Poista valinnat suodatetuilta',
        title: 'Otsikko',
        message: 'Viesti',
      },
      validation: {
        title: 'Otsikko on pakollinen',
        message: 'Viesti on pakollinen',
        apartments: 'Valitse vähintään yksi asunto tai koko taloyhtiö.',
      },
      portalTitle: 'Asukasilmoitukset',
    },
    maintenance: {
      title: 'Kunnossapito',
      tabMaintenancePlan: 'Kunnossapitotarveselvitys',
      tabRepairHistory: 'Korjaushistoria',
      repairHistory: {
        createTimeout:
          'Palvelin ei vastannut ajoissa. Tarkista lista: jos raporttia ei näy, paina Luo uudelleen. Raporttia ei luoda kahteen kertaan.',
        selectCondominiumFilter: 'Valitse {{condominium}} suodattaaksesi listaa.',
        empty: 'Ei korjaushistorioita.',
        create: 'Luo korjaushistoria',
        createStepBasic: 'Perustiedot',
        createStepEntries: 'Korjausrivit',
        createStepPdf: 'PDF ja muistiinpanot',
        open: 'Avaa',
        delete: 'Poista',
        deleteMessage: 'Haluatko varmasti poistaa korjaushistorian "{{name}}"?',
        name: 'Nimi',
        nameRequired: 'Nimi on pakollinen',
        target: 'Kohde',
        columnName: 'Nimi',
        columnTarget: 'Kohde',
        columnBoardDate: 'Hallituksen käsittely',
        columnAction: 'Toimenpide',
        columnYear: 'Vuosi',
        entriesSection: 'Korjaushistorian rivit',
        fillFromUpkeeps: 'Täytä huolloista',
        addEntryRow: 'Lisää rivi',
        entryRowIncomplete: 'Täytä sekä toimenpide että vuosi, tai poista tyhjä rivi.',
        notes: 'Muistiinpanot',
        saved: 'Korjaushistoria tallennettu',
        saveFailed: 'Korjaushistorian tallennus epäonnistui',
        created: 'Korjaushistoria luotu',
        createFailed: 'Korjaushistorian luonti epäonnistui',
        printPdf: 'Tulosta PDF',
        pdfFormat: 'PDF-muoto',
        pdfFormatRepairHistory: 'Korjaushistoria',
        pdfFormatCustom: 'Mukautettu',
        pdfCustomFieldTitle: 'Otsikko',
        pdfCustomFieldLegalIntro: 'Johdantoteksti',
        pdfCustomFieldCondominiumName: 'Kohteen tunniste',
        pdfCustomFieldBoardDate: 'Päivämääräkentän otsikko',
        pdfCustomFieldGeneralMeetingDate: 'Toisen päivämääräkentän otsikko',
        pdfTitleSimple: 'Korjaushistoria',
        pdfSimpleBoardDate: 'Laadittu',
        pdfSimpleGeneralMeetingDate: 'Hyväksytty',
        pdfTitle: 'SELVITYS ASUNTO-OSAKEYHTIÖN KORJAUSHISTORIASTA',
        pdfLegalIntro:
          'Osakehuoneistojen korjauksen järjestämisestä annetun lain (953/2010) 5 §:n mukaisesti yhtiökokoukselle esitetään selvitys yhtiön korjaushistoriasta.',
        pdfCondominiumName: 'Asunto-osakeyhtiö',
        pdfBusinessId: 'Y-tunnus',
        pdfBoardDate: 'Hallitus käsitellyt',
        pdfGeneralMeetingDate: 'Esitetty yhtiökokoukselle',
      },
      documentBankArchive: 'Tallenna dokumenttipankkiin',
      documentBankArchiveSuccess: 'PDF tallennettu dokumenttipankkiin.',
      documentBankArchiveFailed: 'PDF:n tallennus dokumenttipankkiin epäonnistui.',
      documentBankArchiveConflictTitle: 'Tiedosto on jo olemassa',
      documentBankArchiveConflictMessage:
        'Dokumenttipankissa on jo tiedosto "{{fileName}}" kansiossa "{{folderPath}}". Haluatko korvata sen vai tallentaa toisella nimellä?',
      documentBankArchiveOverwrite: 'Korvaa',
      documentBankArchiveSaveAsNewName: 'Tallenna uudella nimellä',
      documentBankArchiveRenameLabel: 'Tiedostonimi',
      documentBankArchiveRenamePlaceholder: 'esim. raportti (1).pdf',
      documentBankArchiveRenameRequired: 'Tiedostonimi on pakollinen',
      documentBankArchiveRenameSameAsExisting: 'Valitse toinen nimi tai käytä Korvaa-painiketta',
      needsAssessment: {
        defaultNameSuffix: 'kunnossapitotarveselvitys',
        title: 'Kunnossapitotarveselvitys',
        create: 'Luo selvitys',
        createStepBasic: 'Perustiedot',
        createStepDocuments: 'Dokumentit',
        createStepBuildingParts: 'Rakennusosat',
        empty: 'Ei kunnossapitotarveselvityksiä.',
        selectCondominium: 'Valitse {{condominium}} suodattaaksesi listaa.',
        columnName: 'Nimi',
        columnTarget: 'Kohde',
        columnPeriod: 'Kesto',
        open: 'Avaa',
        delete: 'Poista',
        deleteMessage: 'Haluatko varmasti poistaa selvityksen "{{name}}"?',
        name: 'Nimi',
        nameRequired: 'Nimi on pakollinen',
        target: 'Kohde',
        businessId: 'Y-tunnus',
        period: 'Kesto',
        periodStart: 'Alkupäivä',
        periodEnd: 'Loppupäivä',
        periodEndBeforeStart: 'Loppupäivä ei voi olla ennen alkupäivää',
        notes: 'Muistiinpanot',
        otherInfo: 'Muu selvitykseen liittyvä informaatio',
        tabDocuments: 'Dokumentit',
        tabBuildingParts: 'Rakennusosat',
        documentName: 'Dokumentin nimi',
        documentPreparationDate: 'Laatimispäivä',
        addDocumentRow: 'Lisää dokumentti',
        documentRowIncomplete: 'Täytä dokumentin nimi ja laatimispäivä, tai poista tyhjä rivi.',
        buildingPart: 'Rakennusosa / järjestelmä',
        maintenanceNeed: 'Kunnossapitotarve',
        printPdf: 'Tulosta PDF',
        saved: 'Selvitys tallennettu',
        saveFailed: 'Selvityksen tallennus epäonnistui',
        created: 'Selvitys luotu',
        createFailed: 'Selvityksen luonti epäonnistui',
        parts: {
          yard: 'Piha',
          foundationsAndStructure: 'Perustukset ja runko',
          facades: 'Julkisivut',
          balconies: 'Parvekkeet',
          windowsAndExteriorDoors: 'Ikkunat ja ulko-ovet',
          roof: 'Katto',
          apartmentWetRooms: 'Huoneistojen märkätilat',
          commonAreas: 'Yleiset tilat',
          heatingSystem: 'Lämmitysjärjestelmä',
          waterAndSewer: 'Vesi- ja viemärijärjestelmä',
          ventilation: 'Ilmanvaihto',
          electricalAndData: 'Sähkö- ja tietojärjestelmä',
          elevators: 'Hissit',
          surveys: 'Tutkimukset',
        },
        pdf: {
          page1Title: 'ASUNTO-OSAKEYHTIÖN HALLITUKSEN KUNNOSSAPITOTARVESELVITYS',
          page2Title:
            'Rakennusosat ja järjestelmät – kunnossapitotarve yhtiökokousta seuraavien {{years}} vuoden aikana',
          documentsSection: 'Taustadokumentit',
          colDocumentName: 'Dokumentin nimi',
          colPreparationDate: 'Laatimispäivä',
          colBuildingPart: 'Rakennusosa / järjestelmä',
          colMaintenanceNeed: 'Kunnossapitotarve',
          otherInfoSection: 'Muu selvitykseen liittyvä informaatio',
        },
      },
    },
    upkeep: {
      kind: 'Tyyppi',
      maintenanceFindings: {
        defect: 'Puute',
        inspectionRound: 'Tarkastuskierros',
        step: 'Huoltokuittaukset',
        title: 'Tarkastushavaintojen huoltokuittaukset',
        help: 'Kirjaa jokaiselle havainnolle tehty toimenpide ja sen tila. Alkuperäiset tarkastushavainnot säilyvät muuttumattomina.',
        progress: '{{count}} / {{total}} käsitelty',
        search: 'Etsi havaintoa',
        filter: 'Näytettävät havainnot',
        all: 'Kaikki',
        open: 'Avoimet',
        noMatches: 'Ei hakua vastaavia havaintoja.',
        general: 'Yleinen tarkastushavainto',
        noDescription: 'Tarkastuksessa merkitty huomautus ilman lisäkuvausta.',
        original: 'Alkuperäinen tarkastushavainto',
        state: 'Huollon tila',
        action: 'Huollon toimenpide',
        placeholder: 'Mitä tehtiin? Jos työ jäi kesken, kerro mitä vielä tarvitaan.',
        photos: 'Huollon kuvat',
        notRecorded: 'Toimenpidettä ei ole vielä kirjattu.',
        next: 'Seuraava havainto',
        required: 'Kirjaa toimenpide ja valitse tila ennen viimeistelyä.',
        downloadFailed: 'Alkuperäisen liitteen avaaminen epäonnistui.',
        sourceReport: 'Alkuperäinen tarkastusraportti',
        status: {
          pending: 'Kirjaamatta',
          corrected: 'Korjattu',
          in_progress: 'Kesken',
          needs_action: 'Vaatii lisätoimia',
        },
      },
      workflow: {
        unassigned: 'Vastuuhenkilö valitaan myöhemmin',
        outcomeRequired: 'Valitse tarkastuksen lopputulos.',
        coverageRequired: 'Valitse, jäikö tarkastus osittain vai kokonaan suorittamatta.',
        afterDaysRequired: 'Anna jälkitarkastuksen määräaika päivinä (1–3650).',
        dueDateInvalid: 'Anna kelvollinen päivämäärä.',
        assignmentOptional:
          'Voit jättää vastuuhenkilön ja tiimin tyhjäksi. Ne voidaan valita myöhemmin jatkotehtävälle.',
        remaining: 'Korjattavaa jäi',
        nextAction: 'Jatkotoimi',
        loading: 'Ladataan tarkastustietoja…',
        loadFailed: 'Tarkastustietojen lataaminen epäonnistui.',
        retry: 'Yritä uudelleen',

        draft: 'Luonnos',
        draftSaved: 'Luonnos tallennettu',
        finalized: 'Tarkastus viimeistelty',
        saveDraft: 'Tallenna luonnos',
        finalize: 'Viimeistele tarkastus',
        finalizeMaintenance: 'Merkitse huolto tehdyksi',
        redo: 'Huolto uusittava',
        doneNeedsInspection: 'Tarkastus tarvitaan',
        followUpsDone: 'Jatkotoimet tehty',
        maintenanceResult: {
          label: 'Valitse lopputulos',
          none: 'Huolto tehty – ei jatkotoimenpiteitä',
          redo: 'Huolto uusittava',
          doneNeedsInspection: 'Huolto tehty – tarkastus tarvitaan',
          redoHelp:
            'Tästä luodaan uusi huoltotehtävä. Kirjaa tehdyt työt ja uusimisen syy kunnossapitolomakkeelle tai havaintoihin. Lomakkeelle kirjattuja tietoja ei tarvitse toistaa.',
          doneNeedsInspectionHelp:
            'Tästä luodaan tarkastustehtävä. Jos ketjussa on jo jälkitarkastus, uutta ei luoda vaan se vapautuu tehtäväksi.',
          required: 'Valitse huollon lopputulos.',
          redoReasonRequired: 'Kirjaa tehdyt työt ja uusimisen syy kunnossapitolomakkeelle tai havaintoihin.',
          inspectionTypeRequired: 'Valitse tarkastuksen tyyppi.',
          inspectionType: 'Tarkastuksen tyyppi',
          inspectionTypeHelp: 'Esivalittu tyyppi päätellään huoltotyypistä, kun mahdollista.',
        },
        none: 'Ei jatkotoimenpiteitä',
        reinspect: 'Tarkastus uusittava',
        maintenance: 'Huolto tarvitaan',
        maintenanceAndReview: 'Huolto ja jälkitarkastus tarvitaan',
        accepted: 'Hyväksytty',
        outcome: 'Lopputulos',
        fillForm: 'Täytä tarkastuslomake.',
        fillObservation: 'Kirjaa tarkastuksen havainnot.',
        fillObservationMaintenance: 'Kirjaa tehdyt työt alla olevaan ”Tehdyt työt ja muut havainnot” -kenttään.',
        maintenanceCompletion: 'Huollon suoritus kirjataan',
        reviewAfterMaintenance:
          'Huollon valmistuttua jälkitarkastus vapautuu tehtäväksi. Korjausten hyväksyntä kirjataan jälkitarkastuksessa.',
        reviewHelp:
          'Tarkasta, onko tarvittavat korjaukset tehty hyväksytysti. Kirjaa havainnot lomakkeelle tai havaintokenttään. Jos korjattavaa jäi, valitse huolto tai huolto ja jälkitarkastus.',
        repeatForm: 'Kirjaa lomakkeelle uusinnan syy ja mitä pitää tarkastaa uudelleen.',
        repeatObservation: 'Kirjaa havaintokenttään uusinnan syy ja mitä pitää tarkastaa uudelleen.',
        repairHint: 'Tarvitaanko korjausta? Valitse ”Huolto tarvitaan” tai ”Huolto ja jälkitarkastus tarvitaan”.',
        repeatInfo: 'Lisätietoja uusintatarkastuksesta',
        repeatHelp:
          'Valitse tämä, kun tarkastus pitää uusia esimerkiksi puuttuvan pääsyn, puuttuvien tietojen tai tarkastusolosuhteiden vuoksi. Jos tarvitaan huoltoa tai korjausta, valitse huoltovaihtoehto.',
        coverage: 'Suorittamatta jäänyt osuus',
        partial: 'Osittain suorittamatta',
        notPerformed: 'Kokonaan suorittamatta',
        complete: 'Kokonaan tehty',
        dueDate: 'Määräpäivä',
        dueDateInPast: 'Huom: päivämäärä on menneisyydessä.',
        instructions: 'Täydentävä työohje (vapaaehtoinen)',
        instructionsHelp: 'Tarkastusraportti liitetään huollolle. Lisää työohje tarvittaessa.',
        review: 'Jälkitarkastus',
        afterDays: 'Määräaika päivinä huollon valmistumisesta',
        afterDaysHelp: 'Määräaika alkaa huollon valmistumisesta.',
        daysAfter: 'päivää huollon valmistumisesta',
        summary: 'Viimeistelyn yhteenveto',
        waiting: 'Odottaa huollon valmistumista',
        ready: 'Odottaa suorittamista',
        chain: 'Tarkastus ja jatkotehtävät',
        chainSummary: 'Ketjun eteneminen',
        current: 'Tämä tehtävä',
        stepNumber: 'Vaihe {{n}}',
        steps: {
          inspection: 'Tarkastus',
          maintenance: 'Huolto (korjaukset)',
          review: 'Jälkitarkastus',
        },
        stepsShort: {
          inspection: 'Tarkastus',
          maintenance: 'Huolto',
          review: 'Jälkitarkastus',
        },
        stepAria: 'Vaihe {{n}}: {{type}}',
        openTask: 'Avaa tehtävä',
        stepOutcome: {
          noRemarks: 'Ei puutteita',
          remarks: 'Puutteita: {{count}}',
          corrected: 'Korjattu {{done}}/{{total}}',
        },
        previous: 'Edellisen tarkastuksen tiedot',
        previousMaintenance: 'Liittyvän tarkastuksen tiedot',
        noTasks: 'Ei jatkotehtäviä',
      },
      title: 'Kunnossapito',
      upkeeps: 'Kunnossapito',
      entity: 'Kunnossapito',
      inspectionDetails: 'Kunnossapidon tiedot',
      searchPlaceholder: 'Hae kunnossapitoa...',
      emptyStateDescription: 'Luo ensimmäinen kunnossapito aloittaaksesi',
      createUpkeep: 'Luo kunnossapito',
      createUpkeepCount: 'Luo {{count}} kunnossapitoa',
      createUpkeepCountMaintenance: 'Luo {{count}} huoltoa',
      createUpkeepCountEquipment: 'Luo {{count}} laitetarkastusta',
      createUpkeepCountInspection: 'Luo {{count}} tarkastusta',
      createUpkeepInspection: 'Luo tarkastus',
      createUpkeepMaintenance: 'Luo huolto',
      createUpkeepEquipment: 'Luo laitetarkastus',
      editUpkeep: 'Muokkaa kunnossapitoa',
      editUpkeepInspection: 'Muokkaa tarkastusta',
      editUpkeepMaintenance: 'Muokkaa huoltoa',
      editUpkeepEquipment: 'Muokkaa laitetarkastusta',
      deleteUpkeep: 'Poista kunnossapito',
      allApartments: 'Kaikki asunnot',
      filterApartments: 'Suodata asuntoja',
      filterApartmentsPlaceholder: 'Kirjoita nimi, osoite tai asunto',
      selectFilteredApartments: 'Valitse suodatetut ({{count}})',
      createApartmentInspections: 'Luo asuntokohtaiset tarkastukset',
      editBatchTitle: 'Muokkaa kunnossapitokokonaisuutta',
      deleteBatchTitle: 'Poista kunnossapitokokonaisuus',
      deleteBatchMessage: 'Haluatko varmasti poistaa kokonaisuuden kaikki kunnossapidot?',
      batchUpkeepsTitle: 'Kokonaisuuden kunnossapidot',
      inspectionBatches: 'Kunnossapitokokonaisuudet',
      createInspectionBatch: 'Luo kunnossapitokokonaisuus',
      batch: 'Kunnossapitokokonaisuus',
      batchUntitled: 'Kunnossapitokokonaisuus #{{id}}',
      batchRowCount: 'Rivejä',
      batchSearchPlaceholder: 'Hae kunnossapitokokonaisuutta...',
      selectCondominiums: 'Valitse kohteet',
      multiBatchAllApartmentsHelp: 'Jokaiseen valittuun kohteeseen luodaan rivit kaikille asunnoille.',
      filterCondominiums: 'Suodata kohteita',
      filterCondominiumsPlaceholder: 'Kirjoita kohteen nimi tai osoite',
      selectFilteredCondominiums: 'Valitse suodatetut ({{count}})',
      sendResidentNotification: 'Lähetä asukasilmoitus',
      sendResidentNotificationHelp: 'Sama ilmoitus lähetetään valittujen kohteiden asukkaille (ja näkyy portaaleissa).',
      batchCreatedWithNotification: 'Kunnossapito luotu ({{count}} riviä) ja asukasilmoitus lähetetty',
      multiBatchCreated: 'Luotiin {{batches}} kunnossapitokokonaisuutta ({{count}} riviä)',
      multiBatchCreatedWithNotification:
        'Luotiin {{batches}} kunnossapitokokonaisuutta ({{count}} riviä) ja {{notices}} asukasilmoitusta',
      noInspectionBatches: 'Ei kunnossapitokokonaisuuksia',
      deleteTitle: 'Poista kunnossapito',
      deleteMessage: 'Haluatko varmasti poistaa kunnossapidon "{{name}}"? Tätä toimintoa ei voi peruuttaa.',
      noUpkeeps: 'Ei kunnossapitoja',
      noUpkeepsYet: 'Tällä hetkellä ei ole yhtään kunnossapitoa.',
      name: 'Nimi',
      nameRequired: 'Nimi on pakollinen',
      type: 'Tyyppi',
      typeRequired: 'Tyyppi on pakollinen',
      nextUpkeepDate: 'Eräpäivä',
      dateScheduleNone: 'Ei toistu',
      dateScheduleInterval: 'Kunnossapitoväli',
      dateScheduleAgreedDate: 'Sovittu päivä',
      upkeepInterval: 'Seuraava kunnossapitoväli',
      upkeepIntervalStart: 'Välin alku',
      upkeepIntervalEnd: 'Välin loppu',
      agreedDate: 'Sovittu päivä',
      effectiveDueDate: 'Eräpäivä',
      recurrenceMonths: 'Toistuvuusväli',
      recurrenceNone: 'Ei toistoa',
      recurrence1Month: '1 kk',
      recurrence3Months: '3 kk',
      recurrence6Months: '6 kk',
      recurrence12Months: '12 kk',
      lastCheck: 'Viimeisin tulos',
      executionStatus: 'Työn tila',
      historyCalendarCompleted: 'Suoritettu',
      nextUpkeepDateHelp: 'Päivitä seuraavan kunnossapitovälin tai sovitun päivän tiedot historiatietoa lisätessä',
      notes: 'Muistiinpanot',
      workInstruction: 'Työohje',
      workInstructions: 'Työohjeet',
      target: 'Kohde',
      trackedAsset: 'Laite',
      trackedAssetNone: 'Ei laitetta',
      trackedAssetPlaceholder: 'Valitse laite',
      trackedAssetRequired: 'Valitse laite',
      trackedAssetBatchHelp: 'Jos valitset laitteen, tehtävä luodaan vain asuntoihin, joissa kyseinen laite on.',
      trackedAssetBatchSkipHint: 'Tehtävä luodaan vain asuntoihin, joissa on tämä laite ({{count}}/{{total}}).',
      kindLabel: 'Luokka',
      wizardStepCategory: 'Pääkategoria',
      kindHelpInspection: 'Yksi kierros taloyhtiölle tai asunnoille. Täytät lomakkeen.',
      kindHelpMaintenance: 'Huoltotyö, jossa voi olla laitteita. Laitteet käsitellään kohde kerrallaan.',
      kindHelpEquipment: 'Käyt rekisteröidyt laitteet läpi ja kirjaat jokaiselle tuloksen.',
      wizardStepLocation: 'Kohde & sijainti',
      wizardStepLocationHelp:
        'Valitse taloyhtiö. Asunnot ovat valinnaisia: ei valintaa = taloyhtiötaso, yksi asunto = yksi tehtävä, useita = sama tehtävä jokaiseen.',
      wizardStepLocationHelpEquipment:
        'Valitse taloyhtiö ja tarvittaessa asunto. Jos asuntoa ei valita, valitset asunnot seuraavassa vaiheessa laitteiden kanssa.',
      wizardStepDetails: 'Tiedot',
      wizardStepForm: 'Lomake',
      wizardStepDevices: 'Laitteet',
      wizardStepDetailsInspection: 'Tarkastuksen tiedot',
      wizardStepDetailsMaintenance: 'Huollon tiedot',
      wizardStepDetailsEquipment: 'Laitteen tiedot',
      locationProperty: 'Taloyhtiö',
      locationSpace: 'Asunto',
      nameInspection: 'Tarkastuksen kohde',
      namePlaceholderInspection: 'Esim. yleisten tilojen tarkastus',
      nameMaintenance: 'Huoltotehtävä',
      namePlaceholderMaintenance: 'Esim. IV-koneen huolto',
      nameEquipment: 'Nimi',
      namePlaceholderEquipment: 'Esim. palovaroittimien tarkastus',
      typeInspection: 'Tarkastustyyppi',
      typePlaceholderInspection: 'Valitse tyyppi',
      typeMaintenance: 'Huoltotehtävä (tyyppi)',
      typePlaceholderMaintenance: 'Valitse tyyppi',
      typeEquipment: 'Tarkastustyyppi',
      typePlaceholderEquipment: 'Valitse tyyppi',
      assigneeInspection: 'Tarkastaja',
      assigneeMaintenance: 'Huoltaja / vastuuhenkilö',
      assigneeEquipment: 'Tarkastaja',
      notesInspection: 'Tarkastuksen sisältö',
      notesPlaceholderInspection: 'Kirjaa tarkastuksen sisältö tai huomiot',
      notesMaintenance: 'Toimenpiteet',
      notesPlaceholderMaintenance: 'Kirjaa suunnitellut toimenpiteet',
      formSectionInspection: 'Tarkastuspohja',
      formSectionMaintenance: 'Huoltopohja',
      formSectionEquipment: 'Tarkastuspohja',
      selectTemplateInspection: 'Valitse tarkastuspohja',
      selectTemplateMaintenance: 'Valitse huoltopohja',
      selectTemplateEquipment: 'Valitse tarkastuspohja',
      kindFilterAll: 'Kaikki',
      kindInspection: 'Tarkastus',
      kindMaintenance: 'Huolto',
      kindEquipmentInspection: 'Laitetarkastus',
      performInspection: 'Tee tarkastus',
      performMaintenance: 'Tee huolto',
      performEquipmentInspection: 'Tee laitetarkastus',
      inspectionHistory: 'Tarkastushistoria',
      maintenanceHistory: 'Huoltohistoria',
      equipmentInspectionHistory: 'Laitetarkastushistoria',
      targetsTitle: 'Tarkastuskohteet',
      targetsTitleMaintenance: 'Huoltokohteet',
      targetsLoadFailed: 'Kohteiden lataus epäonnistui.',
      targetsProgress: '{{handled}} / {{total}} käsitelty',
      targetsEmpty: 'Ei tarkastuskohteita',
      targetsEmptyEditable: 'Ei kohteita. Lisää laitteet muokkaamalla tehtävää.',
      targetsWorkflowOpen:
        'Käsittele jokainen kohde. Väripainikkeet suodattavat listaa. Sen jälkeen merkitse kierros suoritetuksi.',
      targetsWorkflowReady:
        'Kaikki kohteet on käsitelty. Merkitse kierros suoritetuksi, niin pääset allekirjoittamaan raportin.',
      targetsFilterHelp: 'Väripainikkeet suodattavat listaa.',
      targetUnhandled: 'Käsittelemättä',
      targetResultStatus: 'Tulos',
      targetResultStatusHelp: {
        ok: 'Kierros voi onnistua. Seuraava kierros siirtyy, kun kaikki kohteet ovat OK.',
        remark: 'Kierros merkitään tehdyksi, mutta avaa huolto. Seuraava kierros ei siirry ennen kuin huolto on tehty.',
        fault: 'Kierros merkitään epäonnistuneeksi ja avaa huolto. Voit myöhemmin uudelleentarkastaa epäonnistuneet.',
        exception:
          'Huoltoa ei synny. Uudelleentarkastus ilmestyy, kun kierros on kirjattu. Toistuvuus ei siirry ennen sitä.',
      },
      targetResultChecklistBlocksOk:
        'Pohjassa on vastauksia, jotka vaativat huomiota. Vaihda tulos huomautukseksi tai virheeksi.',
      targetResultReason: 'Syy',
      targetResultReasonPlaceholder: 'Kirjoita syy',
      targetResultComment: 'Kommentti',
      targetResultCommentPlaceholder: 'Kirjoita kommentti (valinnainen)',
      targetResultPhoto: 'Kuva / liite',
      targetResultPhotoOptionalHelp: 'Voit liittää kuvan, esimerkiksi vaihdetusta osasta.',
      targetResultReasonRequired: 'Kirjoita syy ennen tallennusta',
      targetResultUnhandled: 'Käsittelemättä',
      targetResultStatusRequired: 'Valitse laitteelle tulos.',
      targetResultsUnhandled_one: '{{count}} laite käsittelemättä.',
      targetResultsUnhandled_other: '{{count}} laitetta käsittelemättä.',
      markRemainingOk: 'Merkitse loput kunnossa oleviksi',
      targetResultPhotoUploadFailed: 'Kuvan lataus epäonnistui',
      targetResultSaved: 'Kohteen tulos tallennettu',
      targetResultSaveFailed: 'Kohteen tuloksen tallennus epäonnistui',
      targetStep: 'Kohde {{current}} / {{total}}',
      targetPrevious: 'Edellinen',
      targetSaveAndNext: 'Tallenna ja seuraava',
      targetQrScan: 'Skannaa QR',
      targetQrScanTitle: 'Skannaa laitteen QR',
      targetQrScanHelp:
        'Skannaa laitteen QR-koodi tai liitä /omaisuus/-osoite. Siirryt suoraan kyseiseen tarkastuskohteeseen.',
      targetQrManualLabel: 'Tai liitä QR-osoite / tunniste',
      targetQrManualPlaceholder: 'https://…/omaisuus/… tai UUID',
      targetQrUseManual: 'Avaa kohde',
      targetQrInvalid: 'QR-koodia ei tunnistettu laitteen tunnisteeksi',
      targetQrNotInTask: 'Laite ei kuulu tähän laitetarkastukseen',
      targetQrPartNotInTask:
        '{{name}} ei ole tässä tehtävässä. Se kuuluu laitteeseen {{parent}}. Lisää osat tehtävään tai skannaa emolaite.',
      targetQrMatched: 'Siirryttiin kohteeseen {{name}}',
      targetQrLookupFailed: 'Laitteen haku QR:llä epäonnistui',
      targetQrCameraUnsupported: 'Kamera-skannausta ei tueta tässä selaimessa. Käytä liittämistä.',
      targetQrCameraDenied: 'Kameran käyttö estetty. Käytä liittämistä.',
      summaryOk: 'OK',
      summaryRemark: 'Huomautukset',
      summaryFault: 'Virheet',
      summaryException: 'Poikkeustilat',
      summaryUnhandled: 'Käsittelemättä',
      exportTargetsPdf: 'Lataa koonti-PDF',
      targetsPdfTitle: 'Laitetarkastuksen koontiraportti',
      trackedAssetsTitle: 'Tarkastettavat laitteet',
      trackedAssetsTitleMaintenance: 'Huollettavat laitteet',
      trackedAssetsHelp: 'Valitse tarkastettavat laitteet.',
      trackedAssetsHelpSingleApartment: 'Tarkastetaan tämän asunnon laitteet. Yksi tehtävä, yksi raportti.',
      trackedAssetsHelpSingleApartmentNamed:
        'Tarkastetaan asunnon {{apartment}} laitteet. Yksi tehtävä, yksi raportti.',
      trackedAssetsScopeApartment: 'Asunto: {{apartment}}',
      trackedAssetsHelpWholeBuilding:
        'Valitse talon laitteet (asunnot ja yhteiset tilat). Luodaan yksi tehtävä, jossa kaikki valitut laitteet ovat samassa listassa.',
      trackedAssetsHelpMultiApartment:
        'Valitse asunnot ja niiden laitteet. Luodaan yksi tehtävä, jossa valittujen asuntojen laitteet ovat samassa listassa.',
      buildingScopeMode: 'Laajuus',
      buildingScopeWhole: 'Koko talo',
      buildingScopeApartments: 'Valitut asunnot',
      commonAreasGroup: 'Yhteiset tilat',
      apartmentJump: 'Siirry asuntoon',
      apartmentJumpAll: 'Kaikki asunnot',
      apartmentSummary: {
        ok: 'OK',
        remark: 'Huomautuksia',
        failed: 'Epäonnistui',
        pending: 'Kesken',
      },
      bulkMarkOk: 'Merkitse käsittelemättömät OK ({{count}})',
      bulkMarkOkConfirm: 'Merkitäänkö {{count}} käsittelemätöntä kohdetta OK:ksi?',
      bulkMarkOkSuccess: '{{count}} kohdetta merkitty OK:ksi',
      reinspectFailed: 'Uudelleentarkasta epäonnistuneet ({{count}})',
      reinspectFailedCreated: 'Uudelleentarkastus luotu',
      trackedAssetsSelected: '{{count}} valittu',
      selectWithParts: 'Valitse tämä ja osat',
      includeDescendantAssets: 'Sisällytä valittujen laitteiden osat',
      trackedAssetsEmpty: 'Ei laitteita valitulla taloyhtiöllä',
      trackedAssetsEmptyApartment: 'Ei laitteita asunnossa {{apartment}}',
      trackedAssetsEmptySelectedApartment: 'Ei laitteita valitulla asunnolla',
      filterTrackedAssets: 'Suodata laitteita',
      filterTrackedAssetsPlaceholder: 'Nimi, sijainti tai tunniste',
      trackedAssetCategoryFilter: 'Laitetyyppi',
      trackedAssetApartmentFilter: 'Suodata asunnolla',
      trackedAssetApartmentFilterAll: 'Kaikki asunnot',
      targetApartments: 'Asunnot',
      targetApartmentsHelp: 'Valitse asunnot, joihin kunnossapito luodaan (yksi raportti per asunto).',
      targetApartmentsEquipmentHelp:
        'Valitse asunnot, joiden laitteet otetaan mukaan. Kaikki valitut laitteet tulevat samaan tehtävään.',
      targetApartmentsBatchHelp:
        'Valinnainen. Yksi asunto luo yhden tehtävän kyseiseen asuntoon. Useampi asunto luo saman tarkastuksen tai huollon jokaiseen.',
      targetApartmentsBatchCountHelp: 'Luodaan {{count}} erillistä tehtävää, yksi per asunto.',
      targetApartmentsSelected_one: '{{count}} asunto valittu',
      targetApartmentsSelected_other: '{{count}} asuntoa valittu',
      targetApartmentsRequired: 'Valitse vähintään yksi asunto tai koko talo',
      selectApartmentsBeforeDevices: 'Valitse ensin asunnot, joiden laitteet haluat tarkastaa.',
      noApartmentsForProperty: 'Taloyhtiöllä ei ole asuntoja',
      batchCreated: 'Luotiin {{count}} kunnossapitoa (yksi per asunto)',
      selectFilteredTrackedAssets: 'Valitse suodatetut ({{count}})',
      selectAllActiveOfType: 'Kaikki tämän tyypin aktiiviset',
      clearTrackedAssets: 'Tyhjennä valinta',
      targetSelectionMode: 'Kohteiden valintatapa',
      targetSelectionFromAssets: 'Laitteista',
      targetSelectionByQuantity: 'Määrä',
      anonymousTargetCount: 'Kohteiden määrä',
      anonymousTargetCountHelp: 'Luo nimettyjä anonyymejä kohteita (Kohde 1…N) ilman laiterekisteriä.',
      anonymousTargetCountRequired: 'Anna kohteiden määrä (1–2000)',
      completeTargets: 'Merkitse laitetarkastus suoritetuksi',
      completeInspection: 'Merkitse tarkastus suoritetuksi',
      completeMaintenance: 'Merkitse huolto suoritetuksi',
      completeEquipmentInspection: 'Merkitse laitetarkastus suoritetuksi',
      performRequiresTargets: 'Käsittele ensin kaikki kohteet. Sen jälkeen voit merkitä kierroksen suoritetuksi.',
      targetsCompleted: 'Laitetarkastus merkitty suoritetuksi',
      createFollowUp: 'Luo huolto',
      followUpPrefix: 'Huolto',
      followUpCreated: 'Huolto luotu',
      followUpButton: 'Huolto #{{id}}',
      openFollowUp: 'Avaa huolto',
      followUpStatusOpen: 'Avoin',
      followUpStatusResolved: 'Korjattu',
      followUpType: 'Huollon tyyppi',
      followUpTypeTitle: 'Valitse huollon tyyppi',
      followUpTypeHelp: 'Valitse huoltotyyppi tälle huollolle.',
      followUpTypeRequired: 'Valitse huollon tyyppi.',
      followUpTypeNoneAvailable: 'Ei huoltotyyppejä. Pyydä ylläpitoa luomaan kunnossapitotyyppi (huolto) Hallinnassa.',
      createFollowUpToggle: 'Luo huolto',
      createFollowUpToggleHelp:
        'Huomautus- ja virhekohteista ({{count}}) avataan yksi yhteinen huolto. Poikkeustiloista ei muodosteta huoltoa.',
      createFollowUpToggleUnsuccessfulHelp: 'Epäonnistuneesta kierroksesta avataan yksi huolto koko kierrokselle.',
      createFollowUpToggleAlreadyCreatedHelp: 'Kohteista on jo avattu huolto. Allekirjoitus ei avaa toista.',
      createFollowUpToggleOptionalHelp: 'Voit avata yhden huollon tälle kierrokselle, vaikka kohteet ovat kunnossa.',
      selectFollowUpTarget: 'Valitse kohde yhdistettyyn huoltoon',
      createCombinedFollowUpOpen: 'Luo huolto avoimista ({{count}})',
      cancelUpkeep: 'Peruuta tehtävä',
      cancelUpkeepConfirm: 'Peruutettu tehtävä säilyy jäljitettävänä. Anna syy.',
      cancelReason: 'Peruutuksen syy',
      cancelReasonPlaceholder: 'Kirjoita peruutuksen syy',
      cancelled: 'Tehtävä peruutettu',
      cancelledStatus: 'Peruutettu',
      targetStatus: {
        ok: 'OK',
        remark: 'Huomautus',
        fault: 'Virhe',
        not_inspectable: 'Ei tarkastettavissa',
        not_found: 'Ei löytynyt',
        no_access: 'Ei pääsyä',
      },
      inspector: 'Vastuuhenkilö',
      assignee: 'Vastuuhenkilö',
      inspectorHelp: 'Henkilö, joka vastaa kunnossapidon suorittamisesta',
      selectAssignee: 'Valitse vastuuhenkilö',
      inspectorTeam: 'Tiimi',
      assigneeTeam: 'Tiimi',
      assigneeTeamAutoFilledHelp: 'Täytetty taloyhtiön oletustiimistä. Voit vaihtaa tai tyhjentää.',
      selectAssigneeTeam: 'Valitse tiimi...',
      status: 'Tila',
      overdue: 'Myöhässä',
      upcoming: 'Tulossa',
      scheduled: 'Ajastettu',
      completed: 'Suoritettu',
      unsuccessful: 'Epäonnistunut',
      unsuccessfulHelp: 'Tämä kierros on merkitty tehdyksi, mutta tulos ei ollut OK.',
      hasRemarks: 'Huomautuksia',
      hasRemarksHelp: 'Suoritus on kirjattu. Avoimia huomautuksia tai pyydettyä huoltoa on vielä käsiteltävänä.',
      corrected: 'Korjattu',
      correctedHelp: 'Kierroksella löytyneet huomautukset ja virheet on korjattu huolloilla.',
      remarkResolved: 'Huomautukset korjattu',
      sourceReport: 'Tarkastusraportti',
      sourceReportHelp: 'Raportti tarkastuksen havainnoista ja tuloksista.',
      reports: {
        inspection: 'Tarkastusraportti',
        inspectionHelp: 'Alkuperäiset havainnot ja tulokset.',
        maintenance: 'Huoltoraportti',
        maintenanceHelp: 'Havainnoille tehdyt korjaukset.',
        review: 'Jälkitarkastusraportti',
        reviewHelp: 'Korjausten tarkastuksen tulos.',
      },
      sourceReportDownload: 'Avaa raportti',
      sourceReportMissing: 'Raporttia valmistellaan. Päivitä sivu hetken kuluttua.',
      sourceReportRoundOpen: 'Alkuperäinen kierros on kesken.',
      sourceReportOpenSource: 'Avaa alkuperäinen tehtävä #{{id}}',
      sourceReportDownloadFailed: 'Raportin lataus epäonnistui.',
      sourceReportUploadFailed: 'Tarkastusraportin tallennus huoltoon epäonnistui.',
      noDate: 'Ei päivämäärää',
      upkeepTypesLabel: 'Kunnossapitotyypit',
      createUpkeepType: 'Luo kunnossapitotyyppi',
      editUpkeepType: 'Muokkaa kunnossapitotyyppiä',
      deleteUpkeepType: 'Poista kunnossapitotyyppi',
      noUpkeepTypes: 'Ei kunnossapitotyyppejä',
      fireExtinguisher: 'Palosammutin',
      smokeDetector: 'Palovaroitin',
      electricalUpkeep: 'Sähkötarkastus',
      plumbingUpkeep: 'Putkistotarkastus',
      ventilationUpkeep: 'Ilmanvaihtotarkastus',
      elevatorUpkeep: 'Hissitarkastus',
      fireAlarm: 'Palohälytin',
      emergencyLighting: 'Turvavalaistus',
      history: 'Historia',
      historyTotal: 'Näytetään',
      historySearchPlaceholder: 'Hae historiasta...',
      historySearchPlaceholderNamed: 'Hae: {{historyName}}...',
      historyNoMatches: 'Ei hakutuloksia',
      historyNoMatchesDescription: 'Kokeile toista hakusanaa.',
      historyBrowseEmpty: 'Ei valmiita kunnossapitoja näytettäväksi.',
      historyBrowseEmptyNamed: 'Ei valmiita merkintöjä ({{historyName}}).',
      addHistory: 'Lisää historiatieto',
      editHistory: 'Muokkaa historiatietoa',
      editHistoryInspection: 'Muokkaa tarkastusta',
      editHistoryMaintenance: 'Muokkaa huoltoa',
      editHistoryEquipment: 'Muokkaa laitetarkastusta',
      historyWizardFormStep: 'Kunnossapitolomake',
      historyWizardDetailsStep: 'Suoritustiedot',
      historyExtraFieldsSection: 'Lisäkentät tälle kunnossapidolle',
      historyExtraFieldsHelp:
        'Kentät lisätään vain tähän kunnossapitotietoon ja aina lomakkeen loppuun. Ne eivät muuta kunnossapitopohjaa.',
      historyAddExtraField: 'Lisää kenttä',
      historyEditExtraField: 'Muokkaa lisäkenttää',
      historyPickFieldType: 'Valitse kenttätyyppi',
      historyPickFieldTypeHelp: 'Valitse millaisen kentän lisäät tähän suoritukseen.',
      historyExtraFieldsEmpty: 'Ei lisäkenttiä. Lisää kenttä painikkeesta.',
      historyFormPageSelect: 'Lomakesivu',
      historyFormPageLabel: 'Sivun nimi',
      historyAddFormPage: 'Lisää sivu',
      equipmentInspectionPagesLockedHelp:
        'Voit täyttää vain tähän tehtävään tilatut kohteet. Jos asunnossa on lisälaitteita, sovi lisätyö palvelupyynnöllä.',
      historyRemoveFormPage: 'Poista sivu',
      historyRemoveFormPageConfirm: 'Haluatko varmasti poistaa tämän sivun? Sivun vastaukset ja lisäkentät poistetaan.',
      historyFormPageDefaultLabel: 'Sivu {{n}}',
      deleteHistory: 'Poista suoritusmerkintä',
      deleteHistoryMessage: 'Haluatko varmasti poistaa tämän suoritusmerkinnän? Tätä toimintoa ei voi peruuttaa.',
      upkeepDate: 'Suorituspäivä',
      inspectionTimeAria: 'Kunnossapidon kellonaika',
      serviced: 'Huollettu',
      successful: 'Kohde kunnossa',
      successfulTargetInspection: 'Tarkastettava kohde oli kunnossa',
      successfulTargetMaintenance: 'Huolto suoritettu',
      successfulTargetEquipment: 'Tarkastettavat kohteet olivat kunnossa',
      successfulHelp: 'Kun valinta on pois päältä, kierros merkitään epäonnistuneeksi. Voit silti avata huollon.',
      roundSuccessfulFromTargets: 'Kierros onnistui, koska kohteet ovat kunnossa tai huomautuksella.',
      roundUnsuccessfulFromTargets: 'Kierros epäonnistui, koska vähintään yhdessä kohteessa on virhe tai poikkeus.',
      durationMinutes: 'Kesto (min)',
      durationMinutesPlaceholder: 'esim. 45',
      durationMinutesValue: '{{count}} min',
      observation: 'Havainto',
      observationFieldInspection: 'Muut tarkastuksen yhteydessä tehdyt havainnot',
      observationFieldInspectionNoForm: 'Tarkastuksen yhteydessä tehdyt havainnot',
      observationFieldMaintenance: 'Muut tehdyt työt ja havainnot',
      observationFieldMaintenanceNoForm: 'Tehdyt työt ja muut havainnot',
      observationFieldEquipment: 'Muut laitetarkastuksen yhteydessä tehdyt havainnot',
      observationFieldEquipmentFindings: 'Laitetarkastuksen yhteydessä tehdyt havainnot',
      observationAttachImage: 'Liitä kuva',
      observationImages: 'Kuvat',
      observationTakePhoto: 'Ota kuva',
      doUpkeep: 'Suorita',
      ok: 'OK',
      performedBy: 'Suorittaja',
      noHistory: 'Ei historiaa',
      exportHistoryPdf: 'Vie PDF',
      viewFormResponses: 'Näytä vastaukset',
      historyPdfDocumentTitleInspection: 'Tarkastusraportti',
      historyPdfDocumentTitleMaintenance: 'Huoltoraportti',
      historyPdfDocumentTitleReview: 'Jälkitarkastusraportti',
      historyPdfDocumentTitleEquipment: 'Laiteraportti',
      historyPdfMetadata: 'Perustiedot',
      historyPdfUpkeep: 'Kunnossapito',
      historyPdfTarget: 'Kohde',
      historyPdfType: 'Kunnossapitotyyppi',
      historyPdfPerformedDate: 'Suorituspäivä',
      historyPdfOutcome: 'Tulos',
      historyPdfSuccessful: 'Kohde kunnossa',
      historyPdfUnsuccessful: 'Epäonnistunut',
      historyPdfPerformedBy: 'Suorittaja',
      historyPdfDevices: 'Huoltokohteet',
      historyPdfChecklist: 'Lomakkeen vastaukset',
      historyPdfObservation: 'Havainnot',
      historyPdfNoObservation: 'Ei havaintoja.',
      historyPdfSignature: 'Tarkastajan allekirjoitus',
      historyPdfNoSignature: 'Allekirjoitusta ei ole tallennettuna tälle merkinnälle.',
      inspectorSignatureTooltip:
        'Allekirjoitus vaaditaan kunnossapitotiedon todentamiseen ja suorittajan tunnistamiseen.',
      assigneeSignatureTooltip:
        'Allekirjoitus vaaditaan kunnossapitotiedon todentamiseen ja suorittajan tunnistamiseen.',
      historyPdfEmpty: '—',
      historyPdfYes: 'Kyllä',
      historyPdfNo: 'Ei',
      historyPdfFileNameUnnamed: 'Kunnossapito {{id}}',
      historyPdfExportFailed: 'PDF:n vienti epäonnistui',
      historyPdfDocumentBankArchiveFailed:
        'Kunnossapitokertomuksen tallennus onnistui, mutta PDF:n tallennus dokumenttipankkiin epäonnistui.',
      upcomingUpkeeps: 'Pian tulevat kunnossapidot',
      overdueUpkeeps: 'Myöhässä olevat kunnossapidot',
      dateRange: 'Ajanjakso',
      dateFrom: 'Alkaen',
      dateTo: 'Päättyen',
      checked: 'Kunnossa (Tarkistettu)',
      namePlaceholder: 'Esim. Palosammutin 1. krs',
      typePlaceholder: 'Valitse kunnossapitotyyppi...',
      notesPlaceholder: 'Lisätietoja kunnossapidosta...',
      observationPlaceholderInspection: 'Kirjaa tähän muut tarkastuksen yhteydessä havaitut tärkeät asiat.',
      observationPlaceholderInspectionNoForm: 'Kirjaa tähän tarkastuksen yhteydessä havaitut tärkeät asiat.',
      observationPlaceholderMaintenance:
        'Kirjaa tähän muut huollon yhteydessä havaitut tärkeät asiat, jotka eivät liity huollettujen laitteiden tuloksiin.',
      observationPlaceholderMaintenanceNoForm: 'Kuvaa tehdyt työt, mitä korjattiin ja mitä jäi vielä tekemättä.',
      observationPlaceholderEquipment:
        'Kirjaa tähän muut laitetarkastuksen yhteydessä havaitut tärkeät asiat, jotka eivät liity tarkastettujen laitteiden tuloksiin.',
      observationPlaceholderEquipmentNoForm:
        'Kirjaa tähän laitetarkastuksen yhteydessä havaitut tärkeät asiat, jotka eivät liity tarkastettujen laitteiden tuloksiin.',
      targetRequired: 'Kohde on pakollinen',
      dateRequired: 'Päivämäärä on pakollinen',
      inspectionCreated: 'Kunnossapito luotu onnistuneesti',
      inspectionUpdated: 'Kunnossapito päivitetty onnistuneesti',
      inspectionDeleted: 'Kunnossapito poistettu onnistuneesti',
      inspectionsDeletedBulk: '{{count}} kunnossapitoa poistettu onnistuneesti',
      batchesDeletedBulk: '{{count}} kunnossapitokokonaisuutta poistettu onnistuneesti',
      historyCreated: 'Tiedot lisätty onnistuneesti',
      historyCreatedWithFollowUp: 'Kierros kirjattu ja huolto avattu',
      historyUpdated: 'Historiatieto päivitetty onnistuneesti',
      historyDeleted: 'Historiatieto poistettu onnistuneesti',
      createFailed: 'Kunnossapidon luominen epäonnistui',
      updateFailed: 'Kunnossapidon päivittäminen epäonnistui',
      deleteFailed: 'Kunnossapidon poistaminen epäonnistui',
      checklistFilesHeading: 'Tiedostot:',
      checklistEmpty: 'Ei vastauksia',
      upkeepFormSection: 'Kunnossapitolomake',
      inspectionFormSection: 'Kunnossapitolomake',
      formModeNone: 'Ei lomaketta',
      formModeTemplate: 'Kunnossapitopohjasta',
      formModeCustom: 'Mukautettu',
      saveCustomAsTemplate: 'Tallenna myös kunnossapitopohjaksi',
      saveCustomAsTemplateHint: 'Pohja nimetään tehtävän mukaan, jotta sen voi valita myöhemmin.',
      selectTemplate: 'Valitse kunnossapitopohja',
      formTemplateRequired: 'Valitse kunnossapitopohja',
      formSchemaReadOnlyHint: 'Vain käyttäjät, joilla on kunnossapitojen muokkausoikeus, voivat muuttaa lomaketta.',
      formBuilder: {
        addText: 'Lyhyt tekstikenttä',
        addTextarea: 'Pitkä tekstikenttä',
        addCheckbox: 'Valintaruutu',
        addCheckboxGroup: 'Monta valintaruutua',
        addSelect: 'Valinta',
        addFile: 'Liite',
        addGrading: 'Arvostelu',
        addYesNo: 'Kyllä / ei ja teksti',
        addOkRemark: 'OK / huomautus',
        addStatement: 'Seloste',
        addGroup: 'Ryhmä',
        emptyGroupDropHint: 'Raahaa kenttä tähän',
        groupName: 'Ryhmän nimi',
        groupNamePlaceholder: 'Esim. Paloturvallisuus',
        groupInstructions: 'Ryhmän ohjeet',
        groupInstructionsPlaceholder: 'Näkyy suorittajalle',
        dragOverlayCaption: 'Siirretään',
        dropIntoGroup: 'Pudota kenttä tähän ryhmään',
        addField: 'Lisää kenttä',
        chooseFieldType: 'Valitse kentän tyyppi',
        fieldLabel: 'Kentän otsikko',
        fieldLabelPlaceholder: 'Esim. Sammutin paikallaan',
        statementText: 'Selosteen teksti',
        statementTextPlaceholder: 'Ohjeteksti, joka näytetään tarkastuksessa ja tulosteessa',
        fieldInstructions: 'Kentän ohjeet',
        fieldInstructionsPlaceholder: 'Näkyy suorittajalle',
        checkboxCaption: 'Teksti valintaruudun jälkeen',
        checkboxCaptionPlaceholder: 'Esim. Kyllä, sammutin on paikallaan',
        required: 'Pakollinen',
        options: 'Vaihtoehdot',
        addOption: 'Lisää vaihtoehto',
        maxFiles: 'Tiedostojen enimmäismäärä',
        previewTitle: 'Esikatselu (suorittajan näkymä)',
        unnamed: '(nimetön)',
        reorder: 'Järjestä kenttiä',
        duplicateField: 'Kopioi kenttä',
        gradingTargets: 'Arvosteltavat kohteet',
        gradingTargetPlaceholder: 'Kohteen nimi',
        addGradingTarget: 'Lisää kohde',
        gradingScale: 'Arvosteluasteikko',
        maintenanceNote: 'Kirjaa tämän kentän vastaus huollettavana puutteena',
        maintenanceGrade: 'Tämä arvosana vaatii huoltotoimenpiteen',
        gradingScalePlaceholder: 'Tason nimi (esim. Hyvä)',
        addScaleLevel: 'Lisää asteikon taso',
        removeField: 'Poista kenttä',
        removeGroup: 'Poista ryhmä',
        unnamedGroup: '(nimetön ryhmä)',
        rulesTitle: 'Ehdolliset säännöt',
        rulesHint:
          'Valitse kenttä ja sen vastaus. Kun vastaus täsmää, tältä kentältä vaaditaan kommentti, liite tai täytetty vastaus.',
        addRule: 'Lisää ehto',
        removeRule: 'Poista ehto',
        ruleWhenField: 'Kun kenttä',
        ruleWhenFieldPlaceholder: 'Valitse kenttä',
        ruleWhenEquals: 'Vastaus on',
        ruleWhenContains: 'Valittuna on',
        ruleWhenText: 'Vastaus on täsmälleen',
        ruleWhenGrading: 'Arvosana on',
        ruleValuePlaceholder: 'Valitse vastaus',
        ruleTextPlaceholder: 'Kirjoita vastaus',
        rulePickFieldFirst: 'Valitse ensin kenttä',
        ruleRequireLabel: 'Silloin tältä kentältä vaaditaan',
        ruleNoTriggerFields: 'Lisää ensin toinen kenttä, jonka vastaukseen ehto voi perustua.',
        ruleTriggerMissing: 'Kenttää ei enää löydy',
        ruleNoChoices: 'Lisää tälle kentälle vaihtoehdot, jotta vastauksen voi valita.',
        ruleValueChecked: 'Valittu',
        ruleValueUnchecked: 'Ei valittu',
        ruleRequire: {
          comment: 'Kommentti',
          file: 'Liite',
          value: 'Täytetty vastaus',
        },
        fieldTypes: {
          group: 'Ryhmä',
          text: 'Lyhyt tekstikenttä',
          textarea: 'Pitkä tekstikenttä',
          checkbox: 'Valintaruutu',
          checkboxGroup: 'Monta valintaruutua',
          select: 'Valinta',
          file: 'Liite',
          grading: 'Arvostelu',
          yesNo: 'Kyllä / ei',
          okRemark: 'OK / huomautus',
          statement: 'Seloste',
        },
      },
      formTemplates: {
        createTitle: 'Uusi kunnossapitopohja',
        editTitle: 'Muokkaa kunnossapitopohjaa',
        searchPlaceholder: 'Hae kunnossapitopohjia...',
        createButton: 'Luo kunnossapitopohja',
        empty: 'Ei kunnossapitopohjia',
        fieldCount: 'Kentät',
        deleteTitle: 'Poista kunnossapitopohja',
        deleteConfirm: 'Haluatko varmasti poistaa kunnossapitopohjan "{{name}}"?',
        nameRequired: 'Nimi on pakollinen',
        fieldLabelRequired: 'Jokaisella kentällä on oltava otsikko',
        groupLabelRequired: 'Jokaisella ryhmällä on oltava nimi',
        groupNeedsFields: 'Ryhmässä on oltava vähintään yksi kenttä',
        selectOptionsRequired: 'Valinta- tai monivalintakentällä on oltava vähintään kaksi vaihtoehtoa',
        gradingTargetsRequired: 'Arvostelukentällä on oltava vähintään yksi nimetty kohde',
        gradingScaleRequired: 'Arvostelukentällä on oltava vähintään kaksi asteikon tasoa',
        toastCreated: 'Kunnossapitopohja luotu',
        toastUpdated: 'Kunnossapitopohja päivitetty',
        toastDeleted: 'Kunnossapitopohja poistettu',
        toastCreateFailed: 'Kunnossapitopohjan luonti epäonnistui',
        toastUpdateFailed: 'Kunnossapitopohjan päivitys epäonnistui',
        toastDeleteFailed: 'Kunnossapitopohjan poisto epäonnistui',
      },
      formRuntime: {
        fieldRequired: 'Kenttä "{{label}}" on pakollinen',
        checkboxRequired: 'Kenttä "{{label}}" on hyväksyttävä',
        fileRequired: 'Kenttä "{{label}}" vaatii vähintään yhden liitteen',
        tooManyFiles: 'Kentällä "{{label}}" voi olla enintään {{max}} tiedostoa',
        invalidSelect: 'Valitse kelvollinen vaihtoehto',
        checkboxGroupRequired: 'Valitse vähintään yksi vaihtoehto kentälle "{{label}}"',
        invalidCheckboxGroup: 'Valinnat eivät kelpaa',
        gradingRequired: 'Kenttä "{{label}}" vaatii arvion jokaisesta kohteesta',
        invalidGrading: 'Arvostelu ei kelpaa',
        invalidYesNo: 'Vastaus ei kelpaa',
        yesNoCommentRequired: 'Kenttä "{{label}}" vaatii kommentin, kun vastaus on Ei',
        invalidOkRemark: 'Vastaus ei kelpaa',
        okRemarkCommentRequired: 'Kenttä "{{label}}" vaatii kommentin, kun vastaus on huomautus',
        devicePageUnanswered: 'Tarkasta kohde ennen lähettämistä: {{label}}',
        ruleValueRequired: 'Kenttä "{{label}}" vaatii vastauksen ehdollisen säännön vuoksi',
        ruleCommentRequired: 'Kenttä "{{label}}" vaatii kommentin ehdollisen säännön vuoksi',
        ruleFileRequired: 'Ehdollinen sääntö vaatii vähintään yhden liitteen ({{label}})',
        selectPlaceholder: 'Valitse...',
        yesNoYes: 'Kyllä',
        yesNoNo: 'Ei',
        yesNoNa: 'Ei koske',
        yesNoCommentPlaceholder: 'Kirjoita tähän…',
        yesNoToggleAria: 'Kyllä, ei tai ei koske',
        okRemarkOk: 'OK',
        okRemarkRemark: 'Huomautus',
        okRemarkCommentPlaceholder: 'Kirjoita huomautus…',
        okRemarkToggleAria: 'OK tai huomautus',
        dropzone: 'Vedä ja pudota tiedostoja tai klikkaa valitaksesi',
        dropzoneAllowedTypes: 'Sallitut tyypit: PDF, kuvat, Word/Excel, teksti. Enintään 50 Mt.',
        dropzonePhoto: 'Lisää kuva tai ota valokuva',
        dropzonePhotoTypes: 'Kuvat (JPG, PNG, GIF, HEIC, WebP) tai PDF. Enintään 50 Mt.',
        fileDeleteFailed: 'Liitteen poisto epäonnistui',
      },
    },
    measurements: {
      tab: 'Mittaukset',
      chartTab: 'Kaavio',
      graphTitle: 'Kulutus',
      graphDescription: '',
      latestHot: 'Uusin lämmin vesi',
      latestCold: 'Uusin kylmä vesi',
      latestElectricity: 'Uusin sähkönkulutus',
      totalHot: 'Lämmin vesi yhteensä',
      totalCold: 'Kylmä vesi yhteensä',
      totalElectricity: 'Sähkönkulutus yhteensä',
      waterConsumptionHot: 'Lämmin vesi',
      waterConsumptionCold: 'Kylmä vesi',
      electricityConsumption: 'Sähkönkulutus',
      recordedAt: 'Päivämäärä',
      value: 'Arvo',
      type: 'Tyyppi',
      addMeasurement: 'Lisää mittaus',
      editMeasurement: 'Muokkaa mittausta',
      noMeasurements: 'Ei mittauksia vielä.',
      deleteConfirm: 'Haluatko varmasti poistaa tämän mittauksen?',
      searchPlaceholder: 'Hae mittauksia...',
      invalidValue: 'Syötä kelvollinen arvo (luku ≥ 0).',
      recordedAtRequired: 'Päivämäärä on pakollinen.',
    },
    serviceRequests: {
      statusUpdateFailed: 'Tilan päivitys epäonnistui',
      deleteAttachmentConfirmTitle: 'Poista liite?',
      deleteAttachmentConfirmDescription: 'Liite "{{name}}" poistetaan pysyvästi. Toimintoa ei voi perua.',
      attachmentDeleted: 'Liite poistettu',
      messageAttachmentsTitle: 'Viestien liitteet',
      messageAttachmentsHint: 'Nämä liitteet on lähetetty viestien mukana. Ne poistetaan poistamalla viesti.',
      noInternalNotes: 'Ei sisäisiä muistiinpanoja.',
      serviceRequestsDisabledRedirect:
        'Palvelupyynnöt eivät ole käytössä valitulle yritykselle, joten sinut ohjattiin työpöydälle.',
      titleMaxLength: 'Otsikko voi olla enintään 255 merkkiä',
      descriptionMaxLength: 'Kuvaus voi olla enintään 10 000 merkkiä',
      messageMaxLength: 'Viesti voi olla enintään 5 000 merkkiä',
      title: 'Palvelupyynnöt',
      serviceRequest: 'Palvelupyyntö',
      serviceRequestDetails: 'Palvelupyynnön tiedot',
      overview: 'Yleiskatsaus',
      searchPlaceholder: 'Hae palvelupyyntöjä...',
      emptyStateDescription: 'Luo ensimmäinen palvelupyyntö aloittaaksesi',
      emptyStateDescriptionNoCreate: 'Ei palvelupyyntöjä vielä. Pyydä adminilta luontioikeus, jos tarvitset Luo-napin.',
      publicFormLink: 'Julkinen lomake',
      publicFormLinkDescription:
        'Jaa linkki tai upota lomake omille sivuillesi. Vastaanottaja voi jättää pyynnön ilman kirjautumista.',
      copyEmbedCode: 'Kopioi upotuskoodi',
      embedCodeCopied: 'Upotuskoodi kopioitu',
      anonymousRequester: 'Anonyymi',
      createServiceRequest: 'Luo palvelupyyntö',
      editServiceRequest: 'Muokkaa palvelupyyntöä',
      deleteServiceRequest: 'Poista palvelupyyntö',
      noServiceRequests: 'Ei palvelupyyntöjä',
      allRequests: 'Kaikki',
      openRequests: 'Avoimet',
      inProgressRequests: 'Käsittelyssä',
      resolvedRequests: 'Ratkaistut',
      requestTitle: 'Otsikko',
      titlePlaceholder: 'Kirjoita palvelupyynnön otsikko...',
      titleRequired: 'Otsikko on pakollinen',
      descriptionRequired: 'Kuvaus on pakollinen',
      location: 'Sijainti',
      locationPlaceholder: 'Valitse kiinteistö tai asunto...',
      locationRequired: 'Valitse kiinteistö tai asunto',
      type: 'Tyyppi',
      typePlaceholder: 'Valitse palvelupyyntötyyppi...',
      typeRequired: 'Palvelupyyntötyyppi on pakollinen',
      description: 'Kuvaus',
      descriptionPlaceholder: 'Kirjoita palvelupyynnön kuvaus...',
      status: 'Tila',
      statusPlaceholder: 'Valitse tila...',
      priority: 'Prioriteetti',
      priorityPlaceholder: 'Valitse prioriteetti...',
      requester: 'Pyytäjä',
      requesterInfo: 'Pyytäjän tiedot',
      requesterFirstName: 'Etunimi',
      requesterFirstNamePlaceholder: 'Etunimi',
      requesterLastName: 'Sukunimi',
      requesterLastNamePlaceholder: 'Sukunimi',
      requesterEmail: 'Sähköposti',
      requesterEmailPlaceholder: 'pyytaja@example.com',
      requesterPhone: 'Puhelin',
      requesterPhonePlaceholder: '+358...',
      assignedTo: 'Käsittelijä',
      assignedToPlaceholder: 'Valitse käsittelijä...',
      assignedTeam: 'Vastuutiimi',
      assignedTeamPlaceholder: 'Valitse tiimi...',
      internalNotes: 'Sisäiset muistiinpanot',
      internalNotesPlaceholder: 'Sisäiset muistiinpanot (ei näy pyytäjälle)...',
      createdAt: 'Luotu',
      resolvedAt: 'Ratkaisuajankohta',
      closedAt: 'Sulkemisajankohta',
      messages: 'Viestit',
      noMessages: 'Ei viestejä',
      messageFailed: 'Viestin lähettäminen epäonnistui',
      notFound: 'Palvelupyyntöä ei löytynyt',
      deleteConfirmDescription: 'Haluatko varmasti poistaa tämän palvelupyynnön? Toimintoa ei voi perua.',
      deleteFailed: 'Palvelupyynnön poistaminen epäonnistui',
      attachmentsTitle: 'Liitteet',
      noAttachments: 'Ei liitteitä.',
      uploadAttachment: 'Lisää liite',
      downloadAttachment: 'Lataa',
      autoAssignedToYou: 'Sinut asetettiin pyynnön käsittelijäksi.',
      previewAttachment: 'Esikatsele',
      openAttachmentInNewTab: 'Avaa uudessa välilehdessä',
      attachmentPreviewFailed: 'Esikatselu epäonnistui. Lataa tiedosto.',
      deleteAttachment: 'Poista liite',
      attachmentUploadFailed: 'Liitteen lähetys epäonnistui',
      attachmentDownloadFailed: 'Lataus epäonnistui',
      attachmentDeleteFailed: 'Liitteen poisto epäonnistui',
      attachmentsClosedHint: 'Suljettuun pyyntöön ei voi lisätä liitteitä.',
      scheduledDate: 'Ajankohta',
      statusOpen: 'Avoin',
      statusInProgress: 'Käsittelyssä',
      statusWaitingForResponse: 'Odottaa vastausta',
      statusResolved: 'Ratkaistu',
      statusClosed: 'Suljettu',
      priorityLow: 'Matala',
      priorityNormal: 'Normaali',
      priorityHigh: 'Korkea',
      priorityUrgent: 'Kiireellinen',
    },
    publicServiceRequest: {
      name: 'Nimi',
      email: 'Sähköposti',
      phone: 'Puhelin',
      formTitle: 'Jätä palvelupyyntö',
      formSubtitle: 'Voit jättää pyynnön ilman kirjautumista. Yhteystiedot ovat vapaaehtoisia.',
      formDisabledDescription: 'Tämä yritys ei ota vastaan julkisia palvelupyyntöjä juuri nyt.',
      submit: 'Lähetä palvelupyyntö',
      submitting: 'Lähetetään...',
      submitError: 'Lähetys epäonnistui.',
      addressStreet: 'Katuosoite',
      addressPostalCode: 'Postinumero',
      addressCity: 'Postitoimipaikka',
      successTitle: 'Kiitos, pyyntö on vastaanotettu',
      successDescription: 'Tallenna alla oleva seurantalinkki. Ilman sähköpostia se on ainoa tapa palata pyyntöön.',
      successDescriptionWithEmail:
        'Lähetimme vahvistuksen sähköpostiisi. Voit seurata pyyntöä myös alla olevasta linkistä.',
      openTracking: 'Avaa seuranta',
      submitAnother: 'Jätä uusi pyyntö',
      trackingLinkLabel: 'Seurantalinkki',
      submitErrorDescription: 'Yritä uudelleen hetken kuluttua.',
      requestNumber: 'Pyynnön numero',
      invalidLink: 'Virheellinen linkki',
      invalidLinkDescription: 'Tarkista, että linkki on oikein kirjoitettu.',
      notFound: 'Pyyntöä ei löytynyt',
      notFoundDescription: 'Palvelupyyntöä ei löytynyt tai linkki on virheellinen.',
      yourInfo: 'Yhteystietosi',
      location: 'Sijainti',
      messagesSection: 'Viestit',
      noMessages: 'Ei vielä viestejä. Käsittelijä vastaa mahdollisimman pian.',
      messageRequired: 'Viesti on pakollinen',
      messageError: 'Viestin lähetys epäonnistui. Yritä uudelleen.',
      staff: 'Henkilökunta',
      resolvedTitle: 'Pyyntö ratkaistu',
      resolvedDescription:
        'Tämä palvelupyyntö on merkitty ratkaistuksi. Jos sinulla on lisäkysymyksiä, voit lähettää uuden pyynnön.',
      poweredBy: 'Palvelun tarjoaa',
    },
    portalAuth: {
      wrongPortalGoToResident: 'Oletko asukas? Paina tästä',
      wrongPortalGoToLandlord: 'Oletko vuokranantaja? Paina tästä',
      magicLinkTab: 'Kirjautumislinkki',
      passwordLoginTab: 'Kirjaudu salasanalla',
      passwordLabel: 'Salasana',
      passwordPlaceholder: 'Salasanasi',
      passwordRequired: 'Salasana on pakollinen',
      loginButton: 'Kirjaudu',
      loggingIn: 'Kirjaudutaan...',
      loginFailed: 'Kirjautuminen epäonnistui. Tarkista sähköposti ja salasana.',
      setPasswordBannerTitle: 'Aseta salasana',
      setPasswordBannerDescription: 'Voit asettaa salasanan, jolla kirjaudut jatkossa ilman sähköpostilinkkiä.',
      setPasswordBannerDismiss: 'Ei kiitos',
      setPasswordButton: 'Aseta salasana',
      setPasswordTitle: 'Aseta salasana',
      changePasswordTitle: 'Vaihda salasana',
      currentPassword: 'Nykyinen salasana',
      newPassword: 'Uusi salasana',
      confirmPassword: 'Vahvista salasana',
      passwordMismatch: 'Salasanat eivät täsmää',
      currentPasswordRequired: 'Nykyinen salasana vaaditaan',
      passwordSaved: 'Salasana tallennettu',
      passwordSaveFailed: 'Salasanan tallennus epäonnistui',
      forgotPasswordHint: 'Unohditko salasanasi? Käytä sähköpostilinkkiä ja aseta uusi salasana portaalissa.',
      saveButton: 'Tallenna',
      saving: 'Tallennetaan...',
      cancel: 'Peruuta',
    },
    trackedAssets: {
      title: 'Laitteet',
      create: 'Lisää laite',
      edit: 'Muokkaa laitetta',
      empty: 'Ei laitteita.',
      columnName: 'Laitenimi',
      identifier: 'Laitetunnus',
      columnCategory: 'Kategoria',
      columnCondominium: 'Taloyhtiö',
      columnLocation: 'Sijainti',
      filterCategory: 'Kategoria',
      columnSerial: 'Sarjanumero',
      filterCondominium: 'Suodata taloyhtiö',
      filterAll: 'Kaikki',
      selectCondominium: 'Valitse taloyhtiö',
      selectApartment: 'Valitse asunto',
      parent: 'Kuuluu laitteeseen',
      selectParent: 'Ei emolaitetta',
      partsTitle: 'Osat',
      partBadge: 'Osa',
      partOfDevice: 'Kuuluu laitteeseen {{parent}}',
      partsEmpty: 'Ei osia.',
      addPart: 'Lisää osa',
      attachExisting: 'Liitä olemassa oleva laite',
      attachExistingAction: 'Liitä',
      partsSearchPlaceholder: 'Hae osia…',
      filterRoots: 'Vain päätaso',
      deleteMessageWithParts: 'Poistetaanko laite {{name}} ja sen {{count}} osaa?',
      installedAt: 'Asennettu',
      manufacturer: 'Valmistaja',
      model: 'Malli',
      apartment: 'Asunto',
      viewMode: 'Näkymä',
      viewList: 'Lista',
      viewMap: 'Kartta',
      mapLoading: 'Ladataan karttaa…',
      mapLoadingPartial: 'Haetaan lisää sijainteja…',
      mapEmpty: 'Kartalle ei löytynyt sijainteja',
      mapEmptyHint:
        'Laitteet näytetään taloyhtiön tai asunnon osoitteen kohdalla. Osoitetta tai postinumeroaluetta ei löytynyt kartalta, joten tarkista laitteiden taloyhtiön tai asunnon osoite.',
      mapMarkerCount: '{{count}} sijaintia · {{assets}} laitetta',
      mapMissingCount:
        '{{count}} laitetta ei näy, koska niiden taloyhtiöllä tai asunnolla ei ole löydettävää osoitetta',
      downloadQr: 'Lataa QR',
      printQr: 'Tulosta QR',
      printQrSheet: 'Tulosta QR-arkki',
      qrSheetFileName: 'laitteet-qr',
      regenerateToken: 'Uusi QR-tunniste',
      regenerateTokenConfirm: 'Haluatko uusia laitteen "{{name}}" QR-tunnisteen? Vanha QR-koodi lakkaa toimimasta.',
      qrDownloaded: 'QR-koodi ladattu',
      qrDownloadFailed: 'QR-koodin lataus epäonnistui',
      qrPdfDownloaded: 'QR-tarrat ladattu',
      qrPdfFailed: 'QR-tarrojen lataus epäonnistui',
      attentionCount: 'Huomiota vaativat',
      attentionFilter: 'Näytä kaikki tai huomiota vaativat',
      noSchedule: 'Ei aikataulua',
      linkedNoSchedule: 'Huolto ilman päivää',
      columnNextDue: 'Seuraava huolto',
      nextDueFromPart: '{{date}} ({{part}})',
      linkedUpkeepsEmpty: 'Ei linkitettyjä huoltoja.',
      openInQrBank: 'Avaa Laitteissa',
      recordUpkeep: 'Kirjaa huolto',
      loginToManage: 'Kirjaudu hallintaan',
      bulkCreateUpkeep: 'Luo huolto valituille',
      bulkCreateUpkeepTitle: 'Luo huolto valituille laitteille',
      bulkCreateUpkeepCount: '{{count}} laitetta valittu',
      bulkCreateUpkeepSameCondo: 'Valitse vain saman taloyhtiön laitteita.',
      created: 'Laite luotu',
      saved: 'Laite tallennettu',
      createFailed: 'Laitteen luonti epäonnistui',
      saveFailed: 'Laitteen tallennus epäonnistui',
      tokenRegenerated: 'QR-tunniste uudistettu',
      tokenRegenerateFailed: 'QR-tunnisteen uudistus epäonnistui',
      notFound: 'Laitetta ei löytynyt',
      deleteTitle: 'Poista laite',
      deleteMessage: 'Poistetaanko laite {{name}}?',
      qrTitle: 'QR-koodi',
      publicPage: 'Julkinen sivu',
      publicNotFound: 'Laitetta ei löytynyt',
      relatedUpkeeps: 'Liittyvät huollot',
      upkeepHistoryTitle: 'Kunnossapitohistoria',
      upkeepHistoryEmpty: 'Ei vielä kunnossapitotapahtumia tälle laitteelle.',
      historyEventCount: '{{count}} tapahtumaa',
      createUpkeep: 'Luo huolto',
      nextDue: 'Seuraava',
      lastMaintenanceAt: 'Viimeinen huolto',
      lastInspectionAt: 'Viimeinen tarkastus',
      nextMaintenanceDue: 'Seuraava huolto',
      nextInspectionDue: 'Seuraava tarkastus',
      upkeepDates: 'Huollot ja tarkastukset',
      upkeepOk: 'OK',
      upkeepIssue: 'Huomio',
      categoryRequired: 'Kategoria on pakollinen',
      category: {
        heat: 'Lämpö',
        water: 'Vesi',
        air: 'Ilma',
        electrical: 'Sähkö',
        automation: 'Automaatio',
        building: 'Rakennus',
        fire: 'Palo',
      },
    },
    rentalBrokerage: {
      returnPartyDepositTitle: 'Palautetaanko vakuus?',
      returnPartyDepositConfirm: 'Vakuus merkitään palautetuksi. Jatketaanko?',
      title: 'Vuokraus',
      titleCombined: 'Vuokraus',
      tabListings: 'Ilmoitukset',
      tabApplicants: 'Hakijat',
      tabWatches: 'Jonotus',
      createWatch: 'Lisää jonoon',
      editWatch: 'Muokkaa jonotusta',
      searchWatches: 'Hae jonosta…',
      emptyWatches: 'Jonossa ei ole ketään',
      watchCity: 'Kaupunki',
      watchDistrict: 'Kaupunginosa',
      watchDistrictHint: 'Esim. Varissuo. Tyhjä tarkoittaa koko kaupunkia.',
      watchRooms: 'Huoneet',
      watchRoomsAny: 'Ei väliä',
      watchRoomsStudio: 'Yksiö',
      watchRoomsTwo: 'Kaksio',
      watchRoomsThreePlus: '3 huonetta tai enemmän',
      watchMaxRent: 'Enimmäisvuokra',
      watchMinSize: 'Pienin koko (m²)',
      watchMaxSize: 'Suurin koko (m²)',
      watchAvailableFrom: 'Asuntoa etsitään alkaen',
      watchAvailableFromHint: 'Ilmoitus lähtee heti, kun sopiva asunto julkaistaan.',
      watchNotes: 'Muistiinpanot',
      watchConsent: 'Asiakas suostuu sähköposti-ilmoituksiin',
      watchConsentRequired: 'Suostumus tarvitaan',
      watchCreated: 'Jonotus tallennettu',
      watchCreateFailed: 'Jonotuksen tallennus epäonnistui',
      watchUpdated: 'Jonotus päivitetty',
      watchUpdateFailed: 'Jonotuksen päivitys epäonnistui',
      watchBurstSkipped: 'Osumia on yli kahdeksan. Rajaa hakua, niin jo julkaistut asunnot voidaan ilmoittaa.',
      watchStatusActive: 'Aktiivinen',
      watchStatusClosed: 'Suljettu',
      watchStatusUnsubscribed: 'Peruttu',
      watchLocale: 'Kieli',
      watchLocaleFi: 'Suomi',
      watchLocaleEn: 'Englanti',
      watchLocaleSv: 'Ruotsi',
      watchDetailTitle: 'Jonotus',
      watchNotFound: 'Jonotusta ei löytynyt',
      watchDeleteTitle: 'Poista jonotus',
      watchDeleteConfirm: 'Haluatko varmasti poistaa tämän jonotuksen?',
      watchContact: 'Yhteystiedot',
      watchCriteria: 'Hakuehdot',
      watchSource: 'Lähde',
      watchSourceStaff: 'Henkilökunta',
      watchSourcePublic: 'Julkinen lomake',
      watchConsentAt: 'Suostumus',
      listingDistrict: 'Kaupunginosa',
      listingDistrictHint: 'Käytetään jonon osumissa, esim. Varissuo.',
      listingAssignedTo: 'Vastuuhenkilö',
      listingAssignedToPlaceholder: 'Valitse vastuuhenkilö',
      listingAssignedToHint: 'Saa sähköpostin uusista hakemuksista, näyttöilmoittautumisista ja yhteydenotoista.',
      tabStats: 'Tilastot',
      tabLeases: 'Vuokrasopimukset',
      tabInvoices: 'Laskut',
      tabFinalInspections: 'Lopputarkastukset',
      tabMoveInInspections: 'Muuttotarkastukset',
      searchFinalInspections: 'Hae lopputarkastuksia…',
      searchMoveInInspections: 'Hae muuttotarkastuksia…',
      finalInspectionCompletedAt: 'Valmistunut',
      columnTitle: 'Otsikko',
      columnStatus: 'Tila',
      columnAttention: 'Huomio',
      columnRent: 'Vuokra',
      columnAmount: 'Summa',
      columnDeposit: 'Vakuus',
      columnTenant: 'Vuokralainen',
      publicLink: 'Julkinen linkki',
      downloadQr: 'Lataa QR',
      qrDownloaded: 'QR-koodi ladattu',
      qrDownloadFailed: 'QR-koodin lataus epäonnistui',
      apartment: 'Asunto',
      listing: 'Ilmoitus',
      resident: 'Asukas',
      landlord: 'Vuokranantaja',
      createApartment: 'Luo asunto',
      template: 'Sopimuspohja',
      createListing: 'Luo ilmoitus',
      editListing: 'Muokkaa ilmoitusta',
      createApplicant: 'Lisää hakija',
      editApplicant: 'Muokkaa hakijaa',
      createLease: 'Luo vuokrasopimus',
      editLease: 'Muokkaa vuokrasopimusta',
      createInvoice: 'Luo lasku',
      editInvoice: 'Muokkaa laskua',
      invoiceDetailTitle: 'Lasku',
      invoiceNotFound: 'Laskua ei löytynyt',
      invoiceDeleteTitle: 'Poista lasku',
      invoiceDeleteConfirm: 'Haluatko varmasti poistaa tämän laskun?',
      listingDetailTitle: 'Ilmoitus',
      overview: 'Yleiskatsaus',
      statsDescription: 'Seuraa ilmoituksen avauksia, esittelyilmoittautumisia ja yhteydenottoja.',
      statsViews: 'Avaukset',
      statsSignups: 'Ilmoittautumiset',
      statsContacts: 'Yhteydenotot',
      statsPeriodHint: '{{from}} – {{to}}',
      statsPerDay: 'Päivittäinen kehitys',
      statsConversion: 'Konversio: ilmoittautumiset {{signupRate}}, yhteydenotot {{contactRate}} avauksista',
      statsEmpty: 'Ei vielä tilastodataa tältä jaksolta.',
      statsLoadFailed: 'Tilastojen lataus epäonnistui',
      listingNotFound: 'Ilmoitusta ei löytynyt',
      listingDeleteTitle: 'Poista ilmoitus',
      listingDeleteConfirm: 'Haluatko varmasti poistaa tämän ilmoituksen?',
      leaseDetailTitle: 'Vuokrasopimus',
      leaseNotFound: 'Vuokrasopimusta ei löytynyt',
      leaseDeleteTitle: 'Poista vuokrasopimus',
      leaseDeleteConfirm: 'Haluatko varmasti poistaa tämän vuokrasopimuksen?',
      agreementDetailTitle: 'Välityssopimus',
      agreementNotFound: 'Välityssopimusta ei löytynyt',
      agreementDeleteTitle: 'Poista välityssopimus',
      agreementDeleteConfirm: 'Haluatko varmasti poistaa tämän välityssopimuksen?',
      applicantDetailTitle: 'Hakija',
      applicantNotFound: 'Hakijaa ei löytynyt',
      applicantDeleteTitle: 'Poista hakija',
      applicantDeleteConfirm: 'Haluatko varmasti poistaa tämän hakijan?',
      lease: 'Vuokrasopimus',
      notes: 'Muistiinpanot',
      publish: 'Julkaise',
      brokerageAgreement: 'Välityssopimus',
      selectBrokerageAgreement: 'Valitse välityssopimus',
      pipelineTitle: 'Seuraavat askeleet',
      pipelineSignAgreement: 'Allekirjoita välityssopimus',
      pipelineCreateListing: 'Luo ilmoitus',
      pipelineAddViewingSlots: 'Lisää esittelyajat',
      pipelinePublishListing: 'Julkaise ilmoitus',
      pipelineTrackApplicants: 'Seuraa hakijoita',
      pipelineCreateLease: 'Luo vuokrasopimus',
      pipelineSignLease: 'Avaa allekirjoitus',
      pipelineSignaturesPending: 'Allekirjoitukset kesken ({{done}}/{{total}})',
      pipelineGenerateDepositInvoices: 'Luo vakuuslaskut',
      pipelineConfirmDeposit: 'Vahvista vakuus',
      pipelineTenantInvoices: 'Luo laskut vuokralaisille',
      feeRequiredBeforeInvoice: 'Lisää palkkiotyyppi ja summa muokkaamalla sopimusta',
      confirmDeposit: 'Vahvista vakuus',
      confirmDepositTitle: 'Vahvista vakuus',
      confirmDepositUnpaidConfirm:
        'Kaikkia vakuuslaskuja ei ole vielä merkitty maksetuksi ({{paid}}/{{total}} maksettu). Haluatko silti vahvistaa vakuuden?',
      confirmDepositUnpaidConfirmNoInvoices:
        'Vakuuslaskuja ei ole vielä merkitty maksetuksi. Haluatko silti vahvistaa vakuuden?',
      depositConfirmed: 'Vakuus vahvistettu',
      returnDeposit: 'Merkitse vakuus palautetuksi',
      returnDepositTitle: 'Merkitse vakuus palautetuksi',
      returnDepositConfirm: 'Haluatko merkitä vakuuden palautetuksi?',
      finalInspectionStateLabel: 'Lopputarkastus',
      finalInspectionStates: {
        not_inspected: 'Tarkastamatta',
        inspection_agreed: 'Tarkastus sovittu',
        at_viewing: 'Tarkastetaan näytön yhteydessä',
        inspected: 'Tarkastettu',
      },
      keysReturnStateLabel: 'Avaimet',
      keysReturnStates: {
        not_returned: 'Palauttamatta',
        returned: 'Palautettu',
      },
      markFinalInspected: 'Merkitse tarkastetuksi',
      markFinalInspectedTitle: 'Merkitse lopputarkastus tarkastetuksi',
      markFinalInspectedConfirm:
        'Tämä merkitsee sopimuksen tarkastetuksi, mutta ei luo lopputarkastusdokumenttia. Dokumentin voi luoda myöhemmin Lopputarkastus-välilehdeltä.',
      finalInspectionMarked: 'Lopputarkastus merkitty tarkastetuksi',
      finalInspectionMarkFailed: 'Lopputarkastuksen merkintä epäonnistui',
      finalInspectionMarkedWithoutDocument: 'Dokumenttia ei ole luotu. Tila on merkitty tarkastetuksi ilman lomaketta.',
      markKeysReturned: 'Merkitse palautetuksi',
      keysMarkedReturned: 'Avaimet merkitty palautetuiksi',
      keysMarkReturnedFailed: 'Avainten palautuksen merkintä epäonnistui',
      keysReturnStateManualHint: 'Käytä tätä vain, jos asunnolla ei ole avaimia järjestelmässä.',
      leaseCardKeys: 'Avaimet',
      apartmentKeys: 'Asunnon avaimet',
      apartmentKeysCount: '{{count}} avainta',
      noApartmentKeys: 'Asunnolla ei ole avaimia järjestelmässä',
      keysWithTenants: 'Asukkailla',
      keysHeldByTenants: '{{count}} avainta asukkailla',
      leaseCardContract: 'Sopimus',
      leaseCardRentAndDeposit: 'Vuokra ja vakuus',
      rentReview: {
        enabled: 'Vuosittainen vuokran tarkistus',
        enabledHelp:
          'Vuokranantaja saa muistutuksen tarkistuspäivänä ja voi jättää vuokran ennalleen tai lähettää asukkaalle korotusilmoituksen. Käytössä, kun vuokranantaja laskuttaa itse.',
        day: 'Päivä',
        month: 'Kuukausi',
        minimumPercent: 'Vähintään %',
        off: 'Ei käytössä',
        summary: '{{day}}.{{month}}. · vähintään {{percent}} %',
        history: 'Tarkistukset',
        status: {
          open: 'Avoin {{year}}',
          skipped: 'Ei korotettu {{year}}',
          notified: 'Korotusilmoitus {{year}}',
        },
        portalTitle: 'Vuokran tarkistus {{date}}',
        portalCurrent: 'Nykyinen vuokra {{rent}}',
        portalRule:
          'Sopimuksen mukaan vuokraa voidaan korottaa elinkustannusindeksin mukaan. Vuokra ei laske, eikä korotus ole pakollinen.',
        portalRuleWithMinimum:
          'Sopimuksen mukaan vuokraa voidaan korottaa elinkustannusindeksin mukaan, kuitenkin vähintään {{percent}} %. Vuokra ei laske, eikä korotus ole pakollinen.',
        notify: 'Korota ja ilmoita',
        skip: 'Älä korota tänä vuonna',
        skipTitle: 'Jätetäänkö korotus väliin?',
        skipMessage: 'Vuokra säilyy ennallaan. Asukkaalle ei lähde ilmoitusta.',
        notifyTitle: 'Ilmoitus vuokran korotuksesta',
        newRent: 'Uusi kuukausivuokra',
        message: 'Saate asukkaalle',
        lateWarning:
          'Ilmoitus lähtee myöhässä suhteessa yhteen täyteen kalenterikuukauteen. Sopimuksessa on silti sovittu tämä voimaantulopäivä.',
        skipSuccess: 'Vuokra jätettiin ennalleen',
        skipFailed: 'Tarkistuksen ohitus epäonnistui',
        notifySuccess: 'Korotusilmoitus lähetetty',
        notifyFailed: 'Korotusilmoituksen lähetys epäonnistui',
        notice: 'Vuokra nousee {{date}}: {{previous}} → {{next}}.',
      },
      leaseCardHandover: 'Päättyminen ja luovutus',
      handoverBlockerFinalInspection: 'lopputarkastusta ei ole merkitty tarkastetuksi',
      handoverBlockerKeys: 'avaimia ei ole merkitty palautetuiksi',
      returnDepositHandoverWarning:
        'Ennen vakuuden palautusta pitäisi olla tehty: {{blockers}}. Haluatko silti merkitä vakuuden palautetuksi?',
      returnDepositOverride: 'Merkitse silti palautetuksi',
      depositReturned: 'Vakuus merkitty palautetuksi',
      depositReturnFailed: 'Vakuuden palautuksen merkintä epäonnistui',
      partyDepositReturned: 'Osapuolen vakuus merkitty palautetuksi',
      partyDepositReturnFailed: 'Osapuolen vakuuden palautus epäonnistui',
      returnPartyDeposit: 'Palauta osapuolen vakuus',
      partyDepositStatus: 'Vakuus',
      partyInactive: 'lähtenyt',
      terminateParty: 'Irtisano osuus',
      terminatePartyTitle: 'Irtisano vuokralaisen osuus',
      terminatePartyHint:
        'Irtisanominen koskee vain tätä osapuolta, jos sopimuksella on muita aktiivisia vuokralaisia. Muutoin koko sopimus merkitään irtisanotuksi.',
      partyTerminated: 'Osuuden irtisanominen tallennettu',
      partyTerminateFailed: 'Osuuden irtisanominen epäonnistui',
      addPartyTitle: 'Lisää vuokralainen sopimukseen',
      addPartyHint:
        'Uusi osapuoli lisätään tasajaolla. Vuokranantaja ja uusi vuokralainen allekirjoittavat muutoksen Binkissä.',
      partyAdded: 'Vuokralainen lisätty',
      partyAddFailed: 'Vuokralaisen lisääminen epäonnistui',
      renewLease: 'Luo jatkosopimus',
      renewLeaseTitle: 'Luo jatkosopimus',
      renewLeaseConfirm:
        'Luodaan uusi luonnossopimus samoilla ehdoilla. Vanha sopimus säilyy päättyneenä. Voit valita uudet vuokralaiset myöhemmin.',
      leaseRenewed: 'Jatkosopimus luotu',
      leaseRenewFailed: 'Jatkosopimuksen luonti epäonnistui',
      binkAmendmentInProcess: 'Muutosallekirjoitus käynnissä',
      binkAmendmentHint: 'Uuden vuokralaisen Bink-allekirjoitus on kesken.',
      depositConfirmFailed: 'Vakuuden vahvistus epäonnistui',
      endAgreement: 'Päätä välityssopimus',
      endAgreementTitle: 'Päätä välityssopimus',
      endAgreementConfirm:
        'Haluatko varmasti päättää tämän välityssopimuksen? Sopimukseen liitetyt avoimet ilmoitukset arkistoidaan.',
      agreementEnded: 'Välityssopimus päätetty',
      agreementEndFailed: 'Välityssopimuksen päättäminen epäonnistui',
      endLease: 'Päätä vuokrasopimus',
      endLeaseTitle: 'Päätä vuokrasopimus',
      endLeaseConfirm: 'Haluatko varmasti päättää tämän vuokrasopimuksen?',
      leaseEnded: 'Vuokrasopimus päätetty',
      leaseEndFailed: 'Vuokrasopimuksen päättäminen epäonnistui',
      publicLinkActiveHint: 'Julkinen linkki toimii vain julkaistussa ilmoituksessa.',
      publicLinkInactiveHint:
        'Julkinen linkki ei ole käytössä tässä tilassa. Julkaise ilmoitus ottaaksesi linkin käyttöön.',
      emptyListings: 'Ei ilmoituksia.',
      emptyApplicants: 'Ei hakijoita.',
      emptyLeases: 'Ei sopimuksia.',
      emptyInvoices: 'Ei laskuja.',
      searchListings: 'Hae ilmoituksia...',
      searchApplicants: 'Hae hakijoita...',
      searchLeases: 'Hae vuokrasopimuksia...',
      searchInvoices: 'Hae laskuja...',
      searchAgreements: 'Hae välityssopimuksia...',
      searchTemplates: 'Hae sopimuspohjia...',
      publicNotFound: 'Ilmoitusta ei löytynyt',
      viewingSlots: 'Esittelyajat',
      upcomingViewings: 'Seuraavat esittelyt',
      noViewingSlots: 'Ei esittelyaikoja.',
      noViewingSlotsApplyHint: 'Ei tulevia esittelyjä — jätä hakemus.',
      slotRequired: 'Valitse esittelyaika',
      addViewingSlot: 'Lisää esittelyaika',
      editViewingSlot: 'Muokkaa esittelyaikaa',
      slotStartsAt: 'Alkaa',
      slotEndsAt: 'Päättyy',
      slotStartsAtRequired: 'Alkamisaika on pakollinen',
      slotEndsAtRequired: 'Päättymisaika on pakollinen',
      slotEndsAfterStarts: 'Päättymisaika on oltava alkamisajan jälkeen',
      slotStartInPast: 'Alkamisaika ei voi olla menneisyydessä',
      slotTooLong: 'Esittelyaika voi olla enintään 12 tuntia',
      slotOverlapWarning: 'Menee päällekkäin toisen esittelyajan kanssa: {{times}}. Voit silti tallentaa.',
      leaseOverlapWarning: 'Huoneistolla on jo sopimus samalle ajalle: {{leases}}. Voit silti tallentaa.',
      depositOverThreeMonthsWarning:
        'Vakuus ({{deposit}}) on yli 3 kuukauden vuokra ({{limit}}). Asuinhuoneiston vuokralaissa vakuus saa olla enintään 3 kk vuokra.',
      noDeposit: 'Ei vakuutta',
      pipelineAddPartiesFirst: 'Lisää sopimukselle vuokralainen ennen allekirjoitusta',
      amountTooLarge: 'Summa on liian suuri',
      invoiceAmountPositive: 'Summan on oltava suurempi kuin 0',
      invoiceDueBeforeIssue: 'Eräpäivä ei voi olla ennen laskun päivää',
      invoiceIbanInvalid: 'IBAN-tilinumero on virheellinen',
      invoiceBicInvalid: 'BIC-koodi on virheellinen',
      invoiceReferenceInvalid: 'Viitenumero on virheellinen (tarkiste ei täsmää)',
      invoiceDraftOnly: 'Lasku voidaan luoda vain luonnoksena. Lähetä tai merkitse maksetuksi laskun toiminnoista.',
      errSlotOverlap: 'Esittelyaika menee päällekkäin toisen esittelyajan kanssa',
      errLeaseOverlap: 'Huoneistolla on jo päällekkäinen vuokrasopimus samalle ajalle',
      errSignupDuplicate: 'Olet jo ilmoittautunut tähän esittelyyn',
      errLeaseDuplicateParty: 'Sama henkilö ei voi olla osapuolena useaan kertaan',
      notEnabledTitle: 'Vuokravälitys ei ole käytössä',
      notEnabledBody:
        'Vuokravälitys ei ole käytössä tälle yritykselle. Vaihda yritystä tai pyydä pääkäyttäjää ottamaan ominaisuus käyttöön.',
      notEnabledBack: 'Siirry työpöydälle',
      slotLocationNote: 'Sijaintihuomautus',
      slotCapacity: 'Osallistujamäärä (enintään)',
      slotCapacityHint: 'Jätä tyhjäksi, jos rajaa ei ole.',
      slotCapacityInvalid: 'Anna kokonaisluku väliltä 1–1000',
      slotSpotsLeft_one: '{{count}} paikka jäljellä',
      slotSpotsLeft_other: '{{count}} paikkaa jäljellä',
      slotFull: 'Täynnä',
      errSlotFull: 'Esittelyaika on täynnä. Valitse toinen aika.',
      errSlotCapacityBelowSignups: 'Osallistujamäärä ei voi olla pienempi kuin jo ilmoittautuneiden määrä',
      slotAssignedTo: 'Esittelyn hoitaja',
      slotAssignedToPlaceholder: 'Valitse hoitaja',
      slotSignups: 'Ilmoittautuneita',
      viewingSlotCreated: 'Esittelyaika lisätty',
      viewingSlotCreateFailed: 'Esittelyajan lisäys epäonnistui',
      viewingSlotUpdated: 'Esittelyaika päivitetty',
      viewingSlotUpdateFailed: 'Esittelyajan päivitys epäonnistui',
      descriptionPlaceholder: 'Ilmoituksen kuvaus. Voit käyttää muotoilua…',
      contentLanguage: 'Ilmoituksen kieli',
      contentLanguageHint: 'Vaihda kieltä ja täytä tekstit. Tyhjä käännös näyttää suomen kävijälle.',
      signupTitle: 'Ilmoittaudu esittelyyn',
      signup: 'Ilmoittaudu',
      signupDescription: 'Valitse esittelyaika ja jätä yhteystietosi.',
      applyTitle: 'Hae asuntoa',
      applyDescription: 'Täytä hakemuslomake. Kerro yhteystietosi ja taustatietosi asunnonhakua varten.',
      applySubmit: 'Lähetä hakemus',
      applySuccess: 'Hakemus lähetetty',
      applyFailed: 'Hakemuksen lähetys epäonnistui',
      applyThankYouTitle: 'Kiitos hakemuksestasi!',
      applyThankYouDescription: 'Olemme vastaanottaneet hakemuksesi. Otamme yhteyttä tarvittaessa.',
      applyAgain: 'Lähetä uusi hakemus',
      applyStepIndicator: 'Vaihe {{current}} / {{total}}',
      previewApplyDisabled: 'Hakemuslomake ei ole käytössä esikatselussa.',
      contactTitle: 'Ota yhteyttä',
      contactDescription: 'Lähetä viesti ilmoituksen tekijälle.',
      contactMessage: 'Viesti',
      contactMessagePlaceholder: 'Kerro lyhyesti, mistä haluat kysyä…',
      contactMessageRequired: 'Viesti on pakollinen',
      contactMessageTooLong: 'Viesti on liian pitkä (enintään 2000 merkkiä)',
      contactSubmit: 'Lähetä viesti',
      contactSuccess: 'Viesti lähetetty',
      contactFailed: 'Viestin lähetys epäonnistui',
      contactThankYouTitle: 'Kiitos viestistäsi!',
      contactThankYouDescription: 'Olemme välittäneet viestisi ilmoituksen tekijälle.',
      contactAgain: 'Lähetä uusi viesti',
      previewContactDisabled: 'Yhteydenotto ei ole käytössä esikatselussa.',
      created: 'Luotu',
      saved: 'Tallennettu',
      createFailed: 'Luonti epäonnistui',
      saveFailed: 'Tallennus epäonnistui',
      listingCreated: 'Ilmoitus luotu',
      listingCreateFailed: 'Ilmoituksen luonti epäonnistui',
      listingUpdated: 'Ilmoitus päivitetty',
      listingUpdateFailed: 'Ilmoituksen päivitys epäonnistui',
      listingPublished: 'Ilmoitus julkaistu',
      listingPublishFailed: 'Julkaisu epäonnistui',
      apartmentUnavailable: 'Asuntoa ei löydy',
      listingApartmentDeletedHint: 'Asunto on poistettu. Palauta se ennen kuin julkaiset ilmoituksen.',
      publishBlockedApartmentDeleted: 'Asunto on poistettu. Palauta se ennen julkaisua.',
      apartmentDeletedCannotUse: 'Poistettua asuntoa ei voi käyttää. Valitse toinen asunto tai palauta se.',
      preview: 'Esikatsele',
      previewBanner: 'Esikatselu — ilmoitusta ei ole vielä julkaistu',
      previewBannerPublished: 'Esikatselu — näin ilmoitus näkyy julkisella sivulla',
      previewSignupDisabled: 'Ilmoittautuminen ei ole käytössä esikatselussa.',
      files: 'Tiedostot',
      uploadFile: 'Lisää tiedosto',
      noFiles: 'Ei tiedostoja.',
      dragToReorderFiles: 'Raahaa vaihtaaksesi järjestystä',
      dragToReorderFilesHint: 'Raahaa tiedostoja vaihtaaksesi kuvien ja videoiden järjestystä ilmoituksella.',
      filesOrderSaved: 'Järjestys tallennettu',
      filesOrderSaveFailed: 'Järjestyksen tallennus epäonnistui',
      showOnListing: 'Näytä ilmoituksella',
      hideFromListing: 'Piilotettu ilmoitukselta',
      coverImage: 'Kansikuva',
      videoFile: 'Video',
      setAsCover: 'Aseta kansikuvaksi',
      fileUploaded: 'Tiedosto ladattu',
      fileUploadFailed: 'Tiedoston lataus epäonnistui',
      fileDownloadFailed: 'Tiedoston lataaminen epäonnistui',
      fileDeleteTitle: 'Poista tiedosto',
      fileDeleteConfirm: 'Haluatko varmasti poistaa tiedoston "{{name}}"?',
      attachFromDocumentBank: 'Liitä dokumenttipankista',
      attachFromDocumentBankTitle: 'Liitä tiedostoja dokumenttipankista',
      attachFromDocumentBankDescription:
        'Valitse asunnon tai kiinteistön tiedostoja liitettäväksi ilmoitukselle. Alkuperäiset jäävät dokumenttipankkiin.',
      attachFromDocumentBankConfirm: 'Liitä valitut',
      attachFromDocumentBankEmpty: 'Ei liitettäviä tiedostoja dokumenttipankissa.',
      attachFromDocumentBankSearch: 'Hae tiedostoja…',
      attachFromDocumentBankAlreadyAttached: 'Jo ilmoituksella',
      attachFromDocumentBankApartment: 'Asunto',
      attachFromDocumentBankCondominium: 'Kiinteistö',
      filesSavedToDocumentBankHint: 'Tiedostot tallennetaan asunnon dokumenttipankkiin kansioon {{folder}}.',
      fileDocumentBankArchiveFailed:
        'Tiedosto lisättiin ilmoitukselle, mutta tallennus dokumenttipankkiin epäonnistui.',
      attachFromDocumentBankFailed: 'Liittäminen dokumenttipankista epäonnistui',
      coverSet: 'Kansikuva asetettu',
      coverSetFailed: 'Kansikuvan asetus epäonnistui',
      publicDocuments: 'Liitteet',
      publicRepairHistory: 'Korjaushistoria',
      repairHistoryReport: 'Korjaushistoria ilmoituksella',
      repairHistoryReportNone: 'Ei näytetä',
      repairHistoryReportPlaceholder: 'Valitse korjausraportti',
      repairHistoryReportNeedApartment: 'Valitse ensin asunto',
      createRepairHistoryReport: 'Luo korjaushistoria',
      viewAllCompanyListings: 'Katso kaikki ilmoitukset',
      relatedListingsSection: 'Muut ilmoitukset',
      relatedListingsInCity: 'Muita ilmoituksia — {{city}}',
      relatedListingsNoSameCity:
        'Ei muita ilmoituksia samassa kaupungissa. Voit silti selata yrityksen kaikkia ilmoituksia.',
      companyListingsTitle: 'Vuokra-asunnot',
      companyListingsSubtitle: 'Julkaistut vuokrailmoitukset',
      companyListingsBrowseHint: 'Selaa avoimia vuokra-asuntoja. Suodata kaupungin, huoneluvun tai vuokran mukaan.',
      companyListingsCount: '{{count}} ilmoitusta',
      companyListingsFilteredCount: '{{count}} / {{total}} ilmoitusta',
      companyListingsEmpty: 'Ei julkaistuja ilmoituksia.',
      companyListingsEmptyFiltered: 'Ei ilmoituksia valituilla suodattimilla.',
      companyListingsNotFound: 'Yrityksen ilmoituksia ei löytynyt.',
      companyListingsFiltersTitle: 'Suodatus ja järjestys',
      companyListingsFiltersSubtitle: 'Valitse saatavilla olevista vaihtoehdoista',
      companyListingsFilterCity: 'Kaupunki',
      companyListingsFilterRooms: 'Huoneluku',
      companyListingsFilterAllCities: 'Kaikki kaupungit',
      companyListingsFilterAllRooms: 'Kaikki huoneluvut',
      companyListingsFilterMaxRent: 'Enimmäisvuokra',
      companyListingsFilterMaxRentPlaceholder: '€ / kk',
      companyListingsSort: 'Järjestys',
      companyListingsSortDefault: 'Oletus',
      companyListingsSortRentAsc: 'Vuokra: edullisin ensin',
      companyListingsSortRentDesc: 'Vuokra: kallein ensin',
      companyListingsSortSizeDesc: 'Pinta-ala: suurin ensin',
      companyListingsClearFilters: 'Tyhjennä suodattimet',
      backToCompanyListings: 'Takaisin ilmoituksiin',
      perMonth: 'kk',
      openFullscreen: 'Avaa koko näyttöön',
      imageLightbox: 'Kuvagalleria',
      imageCounter: '{{current}} / {{total}}',
      previousImage: 'Edellinen kuva',
      nextImage: 'Seuraava kuva',
      goToImage: 'Siirry kuvaan {{n}}',
      applicantCreated: 'Hakija lisätty',
      applicantCreateFailed: 'Hakijan lisäys epäonnistui',
      applicantUpdated: 'Hakija päivitetty',
      applicantUpdateFailed: 'Hakijan päivitys epäonnistui',
      leaseCreated: 'Sopimus luotu. Julkaistu ilmoitus merkitään varatuksi.',
      leaseCreateFailed: 'Sopimuksen luonti epäonnistui',
      leaseUpdated: 'Sopimus päivitetty',
      leaseUpdateFailed: 'Sopimuksen päivitys epäonnistui',
      invoiceCreated: 'Lasku luotu',
      invoiceCreateFailed: 'Laskun luonti epäonnistui',
      invoiceUpdated: 'Lasku päivitetty',
      invoiceUpdateFailed: 'Laskun päivitys epäonnistui',
      invoicePdfFailed: 'Laskun PDF:n lataus epäonnistui',
      invoicePdfFilename: 'lasku-{{id}}.pdf',
      agreementUpdated: 'Välityssopimus päivitetty',
      agreementUpdateFailed: 'Välityssopimuksen päivitys epäonnistui',
      signupSuccess: 'Ilmoittautuminen vastaanotettu',
      signupFailed: 'Ilmoittautuminen epäonnistui',
      signupThankYouTitle: 'Kiitos ilmoittautumisesta!',
      signupThankYouDescription: 'Olemme vastaanottaneet ilmoittautumisesi esittelyyn. Nähdään esittelyssä.',
      backToListing: 'Takaisin ilmoitukseen',
      viewingSignups: 'Ilmoittautuneet',
      noViewingSignups: 'Ei ilmoittautumisia.',
      addAsApplicant: 'Lisää hakijaksi',
      alreadyApplicant: 'Jo hakija',
      applicantFromViewingSignup: 'Lisätty esittelyilmoittautumisesta',
      applicantFromWatch: 'Lisätty jonosta',
      createResidentFromApplicant: 'Luo asukas',
      residentFromApplicant: 'Luotu / linkitetty hakijasta',
      tabBrokerageAgreements: 'Välityssopimukset',
      tabFinalInspection: 'Lopputarkastus',
      tabMoveInInspection: 'Muuttotarkastus',
      finalInspectionTemplates: {
        createTitle: 'Luo lopputarkastuspohja',
        editTitle: 'Muokkaa lopputarkastuspohjaa',
        createButton: 'Luo lopputarkastuspohja',
        searchPlaceholder: 'Hae lopputarkastuspohjia…',
        empty: 'Ei lopputarkastuspohjia.',
        deleteTitle: 'Poista lopputarkastuspohja',
        deleteConfirm: 'Poistetaanko lopputarkastuspohja “{{name}}”?',
        toastCreated: 'Lopputarkastuspohja luotu',
        toastUpdated: 'Lopputarkastuspohja päivitetty',
        toastDeleted: 'Lopputarkastuspohja poistettu',
        toastCreateFailed: 'Lopputarkastuspohjan luonti epäonnistui',
        toastUpdateFailed: 'Lopputarkastuspohjan päivitys epäonnistui',
        toastDeleteFailed: 'Lopputarkastuspohjan poisto epäonnistui',
      },
      finalCleaningTemplates: {
        createTitle: 'Luo loppusiivouspohja',
        editTitle: 'Muokkaa loppusiivouspohjaa',
        createButton: 'Luo loppusiivouspohja',
        searchPlaceholder: 'Hae loppusiivouspohjia…',
        empty: 'Ei loppusiivouspohjia.',
        toastCreated: 'Loppusiivouspohja luotu',
        toastUpdated: 'Loppusiivouspohja päivitetty',
        toastCreateFailed: 'Loppusiivouspohjan luonti epäonnistui',
        toastUpdateFailed: 'Loppusiivouspohjan päivitys epäonnistui',
      },
      moveInInspectionFormTemplates: {
        createTitle: 'Luo muuttotarkastuspohja',
        editTitle: 'Muokkaa muuttotarkastuspohjaa',
        createButton: 'Luo muuttotarkastuspohja',
        searchPlaceholder: 'Hae muuttotarkastuspohjia…',
        empty: 'Ei muuttotarkastuspohjia.',
        deleteTitle: 'Poista muuttotarkastuspohja',
        deleteConfirm: 'Poistetaanko muuttotarkastuspohja “{{name}}”?',
        toastCreated: 'Muuttotarkastuspohja luotu',
        toastUpdated: 'Muuttotarkastuspohja päivitetty',
        toastDeleted: 'Muuttotarkastuspohja poistettu',
        toastCreateFailed: 'Muuttotarkastuspohjan luonti epäonnistui',
        toastUpdateFailed: 'Muuttotarkastuspohjan päivitys epäonnistui',
        toastDeleteFailed: 'Muuttotarkastuspohjan poisto epäonnistui',
      },
      isDefault: 'Oletus',
      setAsDefault: 'Aseta oletuspohjaksi',
      defaultBadge: 'Oletus',
      finalCleaningTemplateLabel: 'Loppusiivouspohja',
      moveInInspectionTemplateLabel: 'Muuttotarkastuspohja',
      selectFinalCleaningTemplate: 'Valitse loppusiivouspohja',
      selectMoveInInspectionTemplate: 'Valitse muuttotarkastuspohja',
      portalFinalCleaningTitle: 'Loppusiivousohjeet',
      portalViewFinalCleaning: 'Näytä loppusiivousohje',
      portalMoveInInspectionTitle: 'Muuttotarkastus',
      portalMoveInInspectionComplete: 'Lähetä muuttotarkastus',
      portalMoveInInspectionSave: 'Tallenna luonnos',
      portalMoveInInspectionCompleted: 'Muuttotarkastus lähetetty',
      portalMoveInInspectionSaved: 'Muuttotarkastus tallennettu',
      moveInInspectionCreated: 'Muuttotarkastus luotu',
      moveInInspectionCreateFailed: 'Muuttotarkastuksen luonti epäonnistui',
      moveInInspectionUpdated: 'Muuttotarkastus päivitetty',
      moveInInspectionUpdateFailed: 'Muuttotarkastuksen päivitys epäonnistui',
      moveInInspectionCompleted: 'Muuttotarkastus valmis',
      moveInInspectionCompleteFailed: 'Muuttotarkastuksen valmistuminen epäonnistui',
      moveInInspectionCreate: 'Luo muuttotarkastus',
      moveInInspectionEmpty: 'Ei muuttotarkastuksia.',
      moveInInspectionDetailTitle: 'Muuttotarkastus',
      moveInInspectionNotFound: 'Muuttotarkastusta ei löytynyt',
      moveInInspectionDeleteTitle: 'Poista muuttotarkastus',
      moveInInspectionDeleteConfirm: 'Haluatko varmasti poistaa tämän muuttotarkastuksen?',
      moveInInspectionForm: 'Tarkastuslomake',
      moveInInspectionSelectTemplate: 'Valitse pohja',
      moveInInspectionSelectLease: 'Valitse vuokrasopimus',
      moveInInspectionNoEligibleLeases:
        'Ei sopivia vuokrasopimuksia. Muuttotarkastus voidaan luoda vain allekirjoitetuille, irtisanotuille tai päättyneille sopimuksille.',
      moveInInspectionFormSource: 'Lomake',
      moveInInspectionFormModeTemplate: 'Pohjasta',
      moveInInspectionFormModeCustom: 'Mukautettu',
      moveInInspectionComplete: 'Merkitse valmiiksi',
      moveInInspectionNotes: 'Muistiinpanot',
      inspectionPdfDownload: 'Lataa PDF',
      inspectionPdfDownloadBlank: 'Lataa tyhjä PDF',
      inspectionPdfDocumentTitle: 'Tarkastuslomake',
      inspectionPdfMetadata: 'Perustiedot',
      inspectionPdfForm: 'Lomake',
      inspectionPdfApartment: 'Asunto',
      inspectionPdfLease: 'Vuokrasopimus',
      inspectionPdfDate: 'Päivämäärä',
      inspectionPdfPerformedBy: 'Tekijä',
      inspectionPdfChecklist: 'Lomakevastaukset',
      inspectionPdfNoNotes: 'Ei muistiinpanoja',
      inspectionPdfSignature: 'Allekirjoitus',
      inspectionPdfRepairFindings: 'Korjaushavainnot',
      inspectionPdfExportFailed: 'PDF-lataus epäonnistui',
      moveInInspectionSignatureTooltip:
        'Allekirjoitus vahvistaa muuttotarkastuksen. Vaaditaan, kun lomake merkitään valmiiksi.',
      moveInInspectionSignatureRequired: 'Allekirjoitus vaaditaan valmistumiseen.',
      moveInInspectionSignatureEmpty: 'Ei allekirjoitusta',
      finalInspectionSignatureTooltip:
        'Allekirjoitus vahvistaa lopputarkastuksen. Vaaditaan, kun lomake merkitään valmiiksi.',
      finalInspectionSignatureRequired: 'Allekirjoitus vaaditaan valmistumiseen.',
      finalInspectionSignatureEmpty: 'Ei allekirjoitusta',
      moveInInspectionCompletedAt: 'Valmistunut',
      portalViewMoveInInspection: 'Näytä muuttotarkastus',
      portalFillMoveInInspection: 'Täytä muuttotarkastus',
      portalFinalInspectionTitle: 'Lopputarkastus',
      portalViewFinalInspection: 'Näytä lopputarkastus',
      finalInspectionCreate: 'Luo lopputarkastus',
      finalInspectionDetailTitle: 'Lopputarkastus',
      finalInspectionNotFound: 'Lopputarkastusta ei löytynyt',
      finalInspectionForm: 'Tarkastuslomake',
      finalInspectionDeleteTitle: 'Poista lopputarkastus',
      finalInspectionDeleteConfirm: 'Haluatko varmasti poistaa tämän lopputarkastuksen?',
      finalInspectionEmpty: 'Ei lopputarkastuksia.',
      finalInspectionEmptyMarkedWithoutDocument:
        'Sopimus on merkitty tarkastetuksi ilman dokumenttia. Voit silti luoda dokumentin jälkikäteen.',
      finalInspectionSelectLease: 'Valitse vuokrasopimus',
      finalInspectionNoEligibleLeases:
        'Ei sopivia vuokrasopimuksia. Lopputarkastus voidaan luoda vain sopimuksille, joiden tila on irtisanottu tai päättynyt.',
      finalInspectionSelectTemplate: 'Valitse pohja',
      finalInspectionFormSource: 'Lomake',
      finalInspectionFormModeTemplate: 'Pohjasta',
      finalInspectionFormModeCustom: 'Mukautettu',
      finalInspectionCreated: 'Lopputarkastus luotu',
      finalInspectionCreateFailed: 'Lopputarkastuksen luonti epäonnistui',
      finalInspectionUpdated: 'Lopputarkastus päivitetty',
      finalInspectionUpdateFailed: 'Lopputarkastuksen päivitys epäonnistui',
      finalInspectionCompleted: 'Lopputarkastus valmis',
      finalInspectionCompleteFailed: 'Lopputarkastuksen valmistuminen epäonnistui',
      finalInspectionComplete: 'Merkitse valmiiksi',
      finalInspectionStatus: {
        draft: 'Luonnos',
        completed: 'Valmis',
      },
      finalInspectionNotes: 'Muistiinpanot',
      finalInspectionPhotos: 'Kuvat',
      finalInspectionPhotosEmpty: 'Ei kuvia.',
      finalInspectionUploadPhoto: 'Lisää kuva',
      finalInspectionRepairItems: 'Korjattavat asiat',
      finalInspectionRepairItemsHint:
        'Kirjaa asiat, jotka pitää korjata ennen uutta vuokrausta, esimerkiksi keittiön kaapit tai maalattavat seinät.',
      finalInspectionRepairItemsEmpty: 'Ei korjattavia asioita.',
      finalInspectionAddRepairItem: 'Lisää korjattava asia',
      finalInspectionRepairItemTitle: 'Kohde',
      finalInspectionRepairItemNotes: 'Kuvaus',
      finalInspectionRepairItemTitlePlaceholder: 'Esim. keittiön kaapit',
      finalInspectionPhotoUploaded: 'Kuva lisätty',
      finalInspectionPhotoUploadFailed: 'Kuvan lisääminen epäonnistui',
      finalInspectionPhotoDeleted: 'Kuva poistettu',
      finalInspectionPhotoDeleteFailed: 'Kuvan poisto epäonnistui',
      finalInspectionRepairItemCreated: 'Korjattava asia lisätty',
      finalInspectionRepairItemCreateFailed: 'Korjattavan asian lisääminen epäonnistui',
      finalInspectionRepairItemUpdated: 'Korjattava asia päivitetty',
      finalInspectionRepairItemUpdateFailed: 'Korjattavan asian päivitys epäonnistui',
      finalInspectionRepairItemDeleted: 'Korjattava asia poistettu',
      finalInspectionRepairItemDeleteFailed: 'Korjattavan asian poisto epäonnistui',
      finalInspectionUnavailable: 'Lopputarkastuksen voi tehdä, kun sopimus on päättyvä tai päättynyt.',
      createTemplate: 'Luo sopimuspohja',
      editTemplate: 'Muokkaa sopimuspohjaa',
      createBrokerageAgreement: 'Luo välityssopimus',
      editBrokerageAgreement: 'Muokkaa välityssopimusta',
      feeType: 'Palkkiotyyppi',
      feeTypes: {
        monthly: 'Kuukausittain',
        one_time: 'Kertasumma',
      },
      feeAmountMonthly: 'Summa (€ / kk)',
      feeAmountOneTime: 'Kertasumma (€)',
      feeAmountMonthlyDisplay: '{{amount}} / kk',
      feeAmountRequired: 'Palkkion summa on pakollinen',
      columnFee: 'Palkkion määrä',
      generateInvoicesForLandlords: 'Luo laskut vuokranantajille',
      agreementContent: 'Sopimuksen sisältö',
      templateType: 'Pohjan tyyppi',
      templateTypeLease: 'Vuokrasopimus',
      templateTypeBrokerage: 'Välityssopimus',
      rentSplitMode: 'Vuokran jako',
      rentSplitEqual: 'Tasajako',
      rentSplitCustom: 'Mukautettu jako',
      sharePercent: 'Osuus (%)',
      generateInvoicesForPeriod: 'Luo laskut kuluvalle kuukaudelle',
      generateDepositInvoices: 'Luo vakuuslaskut',
      invoicesGenerated: 'Laskut luotu',
      invoicesGenerateFailed: 'Laskujen luonti epäonnistui',
      depositInvoicesGenerated: 'Vakuuslaskut luotu',
      depositInvoicesGenerateFailed: 'Vakuuslaskujen luonti epäonnistui',
      depositInvoicesAlreadyExist: 'Vakuuslaskut on jo luotu tälle sopimukselle',
      printLease: 'Tulosta sopimus',
      tenantBillingModeLeaseHint:
        'Oletus tulee vuokranantajalta. Jos vuokranantaja laskuttaa itse, Xkey ei luo vuokralaislaskuja.',
      tenantBillingSelfBanner: 'Vuokranantaja hoitaa laskut itse',
      tenantBillingSelfOverview: 'Xkey ei luo vuokra- eikä vakuuslaskuja tälle sopimukselle.',
      sendBrokerageFee: 'Lähetä välityspalkkio',
      createBrokerageFeeInvoice: 'Luo välityspalkkiolasku',
      brokerageFeeInvoice: 'Välityspalkkiolasku',
      brokerageFeeInvoiceAlreadyExists: 'Välityspalkkiolasku on jo luotu tälle asunnolle',
      brokerageFeeSent: 'Välityspalkkio lähetetty',
      brokerageFeeSendFailed: 'Välityspalkkion lähetys epäonnistui',
      brokerageFeeDraftHint: 'Palkkiolasku on luotu mutta sitä ei ole vielä lähetetty.',
      leaseBrokerageFeeHint:
        'Tälle sopimukselle ei ole välityssopimusta, joten anna palkkion summa. Lasku luodaan luonnoksena; lähetä se laskuriviltä tai laskun sivulta.',
      brokerageFeeAmount: 'Välityspalkkio',
      pipelineBrokerageFee: 'Lähetä välityspalkkio',
      signedPdfHint:
        'Tämä on sopimuksen sisältö luettavassa muodossa. Lataa allekirjoitettu PDF, jos tarvitset virallisen, sähköisesti allekirjoitetun asiakirjan.',
      signedPdfUnavailable: 'Allekirjoitetun sopimuksen lataus ei onnistunut',
      viewLeaseContract: 'Näytä sopimus',
      printAgreement: 'Tulosta sopimus',
      printBrokerageDocumentTitle: 'Välityssopimus',
      printSignature: 'Allekirjoitus',
      printReference: 'Sopimus nro {{id}}',
      portalLeaseDraftHint: 'Välittäjä valmistelee sopimusta. Saat ilmoituksen, kun se on allekirjoitettavissa.',
      portalLeaseAwaitingOthers: 'Odottaa toisen osapuolen allekirjoitusta.',
      portalLeaseDepositPayHint: 'Maksettavat laskut (esim. vakuus) löytyvät alla olevasta Laskut-osiosta.',
      sendForBinkSigning: 'Lähetä allekirjoitettavaksi (Bink)',
      binkSentForSigning: 'Allekirjoituspyyntö lähetetty Binkin kautta',
      binkSendFailed: 'Allekirjoituspyynnön lähetys Binkiin epäonnistui',
      cancelBinkSigning: 'Peruuta allekirjoituspyyntö',
      keepBinkSigningRequest: 'Pidä pyyntö',
      cancelBinkSigningTitle: 'Peruuta allekirjoituspyyntö?',
      cancelBinkSigningConfirm:
        'Allekirjoituslinkit lakkaavat toimimasta. Bink ei lähetä peruutusviestiä, joten alkuperäiset sähköpostit jäävät. Kerro osapuolille itse. Sopimus palaa luonnokseksi, ja voit muokata ja lähettää sen uudelleen.',
      cancelBinkSigningSuccess: 'Allekirjoituspyyntö peruttu. Sopimus on taas luonnos.',
      cancelBinkSigningFailed: 'Allekirjoituspyynnön peruminen epäonnistui',
      cancelBinkSigningFailedNotSent: 'Allekirjoituspyyntöä ei ole vielä lähetetty',
      cancelBinkSigningFailedAlreadySigned: 'Sopimus on jo allekirjoitettu, eikä pyyntöä voi perua',
      cancelBinkSigningFailedSealing: 'Sopimusta sinetöidään. Odota hetki. Perumista ei voi tehdä kesken sinetöinnin.',
      binkPendingSealHint:
        'Allekirjoitettu sopimus on sinetöinnissä. Peruuttaminen ei ole mahdollista tässä vaiheessa.',
      signingMethod: 'Allekirjoitustapa',
      signingMethodOption: {
        email: 'Heikko (sähköposti)',
        strong: 'Vahva',
      },
      signingMethodHint: {
        email: 'Allekirjoitus vahvistetaan sähköpostilinkillä (Bink).',
        strong: 'Allekirjoitus vahvistetaan vahvalla tunnistautumisella (Bink).',
      },
      binkSigningHint: 'Allekirjoituslinkki on lähetetty osapuolille sähköpostitse (Bink).',
      binkSigningHintByMethod: {
        email: 'Allekirjoituslinkki on lähetetty osapuolille sähköpostitse (Bink).',
        strong: 'Vahva allekirjoituspyyntö on lähetetty osapuolille Binkin kautta.',
      },
      binkSignedHint: 'Sopimus on allekirjoitettu Binkissä.',
      binkSignedElectronicallyByMethod: {
        email: 'Allekirjoitettu sähköisesti Binkissä (sähköposti)',
        strong: 'Allekirjoitettu sähköisesti Binkissä (vahva allekirjoitus)',
      },
      downloadSignedPdf: 'Lataa allekirjoitettu PDF',
      binkSigningStatus: 'Bink-tila',
      binkStatus: {
        inProcess: 'Allekirjoitettavana',
        pendingSeal: 'Sinetöidään',
        signed: 'Allekirjoitettu',
      },
      referenceNumber: 'Viitenumero',
      referenceNumberPlaceholder: 'Jätä tyhjäksi, niin generoidaan lähetyksessä',
      invoiceIban: 'Tilinumero (IBAN)',
      invoiceBic: 'BIC',
      invoicePayeeKind: 'Laskun saaja',
      invoicePayeeKindCompany: 'Välitysliike',
      invoicePayeeKindLandlord: 'Vuokranantaja',
      invoicePayeeKindHint: 'Vuokranantaja-valinnalla tilisiirron saaja ja tilinumero valitaan laskua luotaessa.',
      invoicePayeeLandlord: 'Saaja (vuokranantaja)',
      invoicePayeeLandlordRequired: 'Valitse vuokranantaja, jolle maksu ohjataan',
      invoicePayeeName: 'Saaja',
      invoicePayeeMissingLandlordIban: 'Vuokranantajalla ei ole tilinumeroa',
      invoicePayeeMissingCompanyIban: 'Välitysliikkeellä ei ole tilinumeroa. Täytä IBAN ja BIC yrityksen asetuksissa.',
      generateInvoicesPayeeLandlordHint: 'Valitse vuokranantaja, jonka nimi ja tilinumero tulevat tilisiirtoon.',
      generateInvoicesPayeeCompanyHint: 'Maksu ohjataan välitysliikkeen tilille.',
      dueDate: 'Eräpäivä',
      issuedAt: 'Laadittu',
      portalInvoicePayHint:
        'Maksa lasku eräpäivään mennessä käyttäen viitenumeroa. Maksu kirjataan kun välittäjä vahvistaa sen.',
      sendInvoice: 'Lähetä lasku',
      invoiceSent: 'Lasku lähetetty',
      invoiceSendFailed: 'Laskun lähetys epäonnistui',
      markInvoicePaid: 'Merkitse maksetuksi',
      invoiceMarkedPaid: 'Lasku merkitty maksetuksi',
      invoiceMarkPaidFailed: 'Laskun merkitseminen maksetuksi epäonnistui',
      markInvoiceUnpaid: 'Merkitse maksamattomaksi',
      invoiceMarkedUnpaid: 'Lasku merkitty maksamattomaksi',
      invoiceMarkUnpaidFailed: 'Laskun merkitseminen maksamattomaksi epäonnistui',
      startRentalBrokerage: 'Aloita vuokraus',
      emptyTemplates: 'Ei sopimuspohjia.',
      emptyBrokerageAgreements: 'Ei välityssopimuksia.',
      templateBody: 'Pohjan sisältö',
      columnNameAddress: 'Nimi ja osoite',
      columnTarget: 'Kohde',
      parties: 'Osapuolet',
      addParty: 'Lisää osapuoli',
      fillEmptyPartyFirst: 'Valitse tai luo asukas tyhjälle riville ensin',
      noMorePartyResidents: 'Kaikki henkilöt on jo lisätty osapuoliksi',
      sharesSum: 'Osuuksien summa: {{sum}} %',
      sharesSumInvalid: 'Osuuksien summan tulee olla 100 % (nyt {{sum}} %)',
      signatures: 'Allekirjoitukset',
      unsigned: 'Ei allekirjoitettu',
      signedStatus: 'Allekirjoitettu',
      signedAtLabel: 'Allekirjoitettu {{date}}',
      printDocumentTitle: 'Vuokrasopimus',
      titleRequired: 'Otsikko on pakollinen',
      listingRequired: 'Ilmoitus on pakollinen',
      bodyRequired: 'Sisältö on pakollinen',
      termsRequired: 'Ehdot ovat pakolliset',
      amountRequired: 'Summa on pakollinen',
      descriptionRequired: 'Kuvaus on pakollinen',
      landlordRequired: 'Vuokranantaja on pakollinen',
      residentRequired: 'Vuokralainen on pakollinen',
      targetKind: {
        tenant: 'Vuokralainen',
        landlord: 'Vuokranantaja',
        listing: 'Ilmoitus',
        apartment: 'Asunto',
      },
      invoiceType: 'Laskutyyppi',
      invoiceTypeOption: {
        deposit: 'Vuokravakuus',
        brokerage_fee: 'Välityspalkkio',
        rent: 'Vuokra',
        other: 'Muu',
      },
      listingStatus: {
        draft: 'Luonnos',
        published: 'Julkaistu',
        reserved: 'Varattu',
        leased: 'Vuokrattu',
        archived: 'Arkistoitu',
      },
      listingStatusUnknown: 'Ei tilaa',
      interestStatus: {
        interested: 'Kiinnostunut',
        applied: 'Hakenut',
        pending_review: 'Vuokranantajalla',
        confirmed: 'Vahvistettu',
        withdrawn: 'Peruttu',
        rejected: 'Hylätty',
      },
      leaseStatus: {
        draft: 'Luonnos',
        pending_signature: 'Odottaa allekirjoitusta',
        signed: 'Allekirjoitettu',
        terminating: 'Irtisanottu',
        ended: 'Päättynyt',
      },
      depositStatus: {
        pending: 'Odottaa maksua',
        paid: 'Maksettu',
        confirmed: 'Vahvistettu',
        returned: 'Palautettu',
      },
      invoiceStatus: {
        draft: 'Luonnos',
        sent: 'Lähetetty',
        paid: 'Maksettu',
        overdue: 'Erääntynyt',
      },
      agreementStatus: {
        draft: 'Luonnos',
        pending_signature: 'Odottaa allekirjoitusta',
        active: 'Aktiivinen',
        ended: 'Päättynyt',
      },
      agreementListStatus: {
        draft: 'Luonnos',
        pending_signature: 'Odottaa allekirjoitusta',
        active: 'Aktiivinen',
        ended: 'Päättynyt',
      },
      waterFeeAdvancePerPerson: 'Vesimaksu (€/kk/hlö)',
      contentSource: 'Sisällön lähde',
      contentSourceOption: {
        default: 'Oletus',
        template: 'Pohja',
        custom: 'Mukautettu',
      },
      defaultContentHint:
        'Oletuspohja sisältää tietokenttiä, jotka täyttyvät sopimuksen tiedoista esikatselussa, tulosteessa ja allekirjoitettaessa.',
      startsOn: 'Alkamispäivä',
      endsOn: 'Päättymispäivä',
      endsOnHint: 'Jätä tyhjäksi toistaiseksi voimassa olevalle sopimukselle.',
      leaseTermOpen: 'Toistaiseksi',
      depositAmount: 'Vakuussumma',
      rentDueDay: 'Vuokran eräpäivä (pv)',
      createResident: 'Luo asukas',
      partyApplicantNeedsResident: 'Hakija: {{name}} — valitse tai luo asukas',
      createLandlord: 'Luo vuokranantaja',
      apartmentMissingLandlord:
        'Valitulla tilalla ei ole vuokranantajaa. Liitä tai luo vuokranantaja, jotta sopimus voidaan allekirjoittaa.',
      leaseMissingLandlord: 'Valitse vuokranantaja tälle sopimukselle.',
      shareWithLandlord: 'Lähetä vuokranantajalle',
      landlordAccepted: 'Vuokranantaja hyväksynyt',
      attentionCreateLease: 'Aloita sopimus',
      confirmedApplicant: 'Vahvistettu hakija',
      confirmedApplicants: 'Vahvistetut hakijat',
      shareWithLandlordSuccess: 'Hakijat lähetetty vuokranantajalle',
      shareWithLandlordFailed: 'Hakijoiden lähetys epäonnistui',
      shareWithLandlordSelectHint: 'Valitse lähetettävät hakijat',
      shareWithLandlordNeedAppliedHint:
        'Vain tilaan Hakenut merkittyjä hakijoita voi lähettää. Esittelyyn ilmoittautuneet (Kiinnostunut) eivät kelpaa.',
      shareWithLandlordPublishFirst: 'Julkaise ilmoitus ensin',
      waitingLandlordDecision: 'Odottaa vuokranantajan päätöstä',
      markApprovedWithoutPortal: 'Merkitse hyväksytyksi ilman portaalia',
      markApprovedWithoutPortalTitle: 'Merkitse vuokranantajan hyväksymäksi?',
      markApprovedWithoutPortalConfirm:
        'Hakija merkitään vahvistetuksi ilman portaalilähetystä (esim. puhelinhyväksyntä). Muut avoimet hakijat samalle ilmoitukselle hylätään.',
      createLeaseNeedConfirmedHint:
        'Vuokrasopimuksen voi luoda vasta kun hakija on vahvistettu (vuokranantaja hyväksynyt portaalissa tai ilman portaalia).',
      applicantsStatusFlowHint:
        'Esittelyilmoittautuminen luo hakijan tilaan Kiinnostunut. Hakemus nostaa tilan Hakenut — vasta sitten voit lähettää vuokranantajalle.',
      acceptProposalConfirmTitle: 'Hyväksy hakemus?',
      acceptProposalConfirmMessage:
        'Muut avoimet hakemukset samalle ilmoitukselle merkitään hylätyiksi. Tätä toimintoa ei voi perua, jos vuokrasopimus on jo luotu.',
      acceptJointProposalConfirmMessage:
        'Koko yhteishakemus hyväksytään. Muut avoimet hakemukset samalle ilmoitukselle merkitään hylätyiksi.',
      pipelineAmbiguousApplicantsHint:
        'Useita hakijaryhmiä odottaa. Valitse oikeat hakijat Hakijat-välilehdeltä ennen sopimuksen luontia.',
      publishBlockedApartmentDeletedLink: 'Avaa asunto',
      feeRequiredBeforeInvoiceLink: 'Muokkaa sopimusta',
      invoicePayeeMissingCompanyIbanLink: 'Avaa yrityksen laskutustiedot',
      apartmentRentalTab: 'Vuokraus',
      apartmentRentalOverviewHint: 'Ilmoitukset, sopimukset ja välityssopimus tälle asunnolle.',
      apartmentRentalNoActivity: 'Ei vuokrauskohteita tälle asunnolle.',
      apartmentRentalOpenInModule: 'Avaa Vuokraus-moduulissa',
      apartmentRentalListings: 'Ilmoitukset',
      apartmentRentalLeases: 'Vuokrasopimukset',
      apartmentRentalAgreement: 'Välityssopimus',
      listingDraftPublishRequired: 'Julkaise ilmoitus ensin',
      listingDraftPublishRequiredHint: 'Tilastot tulevat näkyviin, kun ilmoitus on julkaistu.',
      oikotie: {
        tab: 'Oikotie',
        title: 'Oikotie-julkaisu',
        description: 'Julkaise vuokra-asunto Oikotiehen ja seuraa käyntejä sekä yhteydenottoja.',
        notConfigured: 'Oikotie-yhteyttä ei ole konfiguroitu',
        notConfiguredHint: 'Lisää API-avain ja yritystunnus yrityksen tiedoissa.',
        openCompanySettings: 'Avaa yrityksen tiedot',
        status: 'Tila',
        statusNotPublished: 'Ei julkaistu',
        statusActive: 'Aktiivinen',
        statusDisabled: 'Poistettu Oikotiesta',
        statusError: 'Virhe',
        lastSynced: 'Viimeksi synkronoitu',
        lastError: 'Viimeisin virhe',
        openOnOikotie: 'Avaa Oikotiessa',
        publish: 'Julkaise Oikotiehen',
        sync: 'Päivitä Oikotiessa',
        unpublish: 'Poista Oikotiesta',
        publishSuccess: 'Ilmoitus julkaistu Oikotiehen',
        syncSuccess: 'Ilmoitus päivitetty Oikotiessa',
        unpublishSuccess: 'Ilmoitus poistettu Oikotiesta',
        publishFailed: 'Julkaisu Oikotiehen epäonnistui',
        syncFailed: 'Päivitys Oikotiessa epäonnistui',
        unpublishFailed: 'Poisto Oikotiesta epäonnistui',
        settings: 'Oikotie-asetukset',
        objectType: 'Talotyyppi',
        energyClass: 'Energialuokka',
        rentTerm: 'Vuokrasuhde',
        rentTermOpen: 'Toistaiseksi voimassa',
        rentTermFixed: 'Määräaikainen',
        saveSettings: 'Tallenna asetukset',
        settingsSaved: 'Oikotie-asetukset tallennettu',
        settingsSaveFailed: 'Asetusten tallennus epäonnistui',
        checklist: 'Tarkistuslista ennen julkaisua',
        checklistOk: 'Valmis',
        checklistMissing: 'Puuttuu',
        stats: 'Oikotie-tilastot',
        statsDescription: 'Käynnit, yhteydenotot, suosikit, hakuvahdit ja soitot Oikotiessa.',
        statsEmpty: 'Ei tilastoja valitulta jaksolta.',
        visits: 'Käynnit',
        contacts: 'Yhteydenotot',
        favourites: 'Suosikit',
        guardHits: 'Hakuvahdit',
        calls: 'Soitot',
        objectTypes: {
          KT: 'Kerrostalo',
          RT: 'Rivitalo',
          PT: 'Paritalo',
          ET: 'Omakotitalo',
          OT: 'Omakotitalo',
          PUUT: 'Puutalo',
        },
      },
      applicantProposals: 'Hakijaehdotukset',
      acceptProposal: 'Hyväksy',
      rejectProposal: 'Hylkää',
      revokeProposalAcceptance: 'Peruuta hyväksyntä',
      proposalAcceptedBrokerHint: 'Välittäjä luo vuokrasopimuksen hyväksytyn hakijan perusteella.',
      proposalSharedAt: 'Lähetetty',
      showProposalDetails: 'Näytä lisätiedot',
      hideProposalDetails: 'Piilota lisätiedot',
      proposalStatus: {
        shared: 'Odottaa',
        accepted: 'Hyväksytty',
        rejected: 'Hylätty',
      },
      wizardStepContact: 'Yhteystiedot',
      wizardStepProfile: 'Hakijan tiedot',
      wizardStepApplication: 'Hakemus',
      wizardStepParties: 'Kohde ja osapuolet',
      wizardStepTerms: 'Ehdot',
      wizardStepContent: 'Sisältö',
      wizardStepListingProperty: 'Kohde',
      wizardStepListingText: 'Ilmoitustekstit',
      applicantProfile: 'Hakijan tiedot',
      birthYear: 'Syntymävuosi',
      currentCity: 'Nykyinen paikkakunta',
      currentHousingType: 'Nykyinen asumismuoto',
      studyPlaceAndProgram: 'Opiskelupaikka ja -linja',
      studiesRemaining: 'Opintoja jäljellä',
      isStudying: 'Olen opiskelija',
      hasPaymentDefaults: 'Maksuhäiriömerkintöjä',
      hasPets: 'Lemmikkejä',
      petsNote: 'Lemmikkien kuvaus',
      canPayDepositMonths: 'Voin maksaa vakuutta (kk)',
      depositMonthsValue: '{{count}} kk',
      depositPaymentForm: 'Vakuusmuoto',
      depositPaymentFormOptions: {
        self: 'Maksan itse',
        insurance: 'Vakuutus',
        guarantor: 'Takaaja',
        other: 'Muu',
      },
      applicationReason: 'Asunnonhaun syy',
      intendedStayDuration: 'Aiottu asumisaika',
      leaseCanStartOn: 'Vuokrasopimus voi alkaa',
      appliesWithOthers: 'Haen yhteissopimuksella toisen kanssa',
      jointApplicantsHint:
        'Ilmoita henkilöiden nimet ja sähköpostit, joiden kanssa haette yhdessä. Jokaisen on täytettävä oma hakemuksensa.',
      jointApplicantN: 'Yhteishakija {{n}}',
      addJointApplicant: 'Lisää yhteishakija',
      removeJointApplicant: 'Poista yhteishakija',
      jointApplicantsRequired: 'Lisää vähintään yksi yhteishakija',
      jointApplicantSelfEmail: 'Yhteishakijan sähköposti ei voi olla sama kuin omasi',
      jointApplicantDuplicateEmail: 'Sama sähköposti on jo lisätty',
      jointApplicationBadge: 'Yhteishakemus ({{count}})',
      jointApplicationShort: 'Yhteishakemus',
      jointApplicantsDeclared: 'Ilmoitetut yhteishakijat',
      relatedApplicants: 'Linkitetyt hakemukset',
      jointApplicantPending: 'Odottaa hakemusta',
      acceptJointApplication: 'Hyväksy yhteishakemus',
      rejectJointApplication: 'Hylkää yhteishakemus',
      jointApplicationMembers: 'Yhteishakijat',
      terminateLease: 'Irtisano sopimus',
      terminateMyShare: 'Irtisano oma osuutesi',
      terminateLeaseConfirm: 'Lähetä irtisanomisilmoitus',
      terminateLeaseHint:
        'Irtisanominen koskee koko vuokrasopimusta. Sopimus merkitään irtisanotuksi valittuna päättymispäivänä.',
      terminateLeaseLandlordHint:
        'Irtisanominen koskee koko vuokrasopimusta. Vuokranantajan irtisanomisaika on vähintään kolme kuukautta.',
      terminateMyShareHint:
        'Irtisanot vain oman osuutesi. Muut osapuolet jäävät sopimukselle, ja vuokraosuudet päivittyvät päättymispäivän jälkeen.',
      noticeEndsOn: 'Päättymispäivä',
      noticePeriodMinTenantHint:
        'Vuokralaisen irtisanomisaika on vähintään yksi kuukausi (AHVL). Aikaisin päättymispäivä on irtisanomiskuukautta seuraavan kuukauden viimeinen päivä.',
      noticePeriodMinLandlordHint:
        'Vuokranantajan irtisanomisaika on vähintään kolme kuukautta (AHVL). Aikaisin päättymispäivä on irtisanomiskuukaudesta kolmen kuukauden päässä olevan kuukauden viimeinen päivä.',
      noticePeriodTooShortTenant: 'Valitse päivä, joka on vähintään kuukauden irtisanomisajan päässä',
      noticePeriodTooShortLandlord: 'Valitse päivä, joka on vähintään kolmen kuukauden irtisanomisajan päässä',
      staffNoticePeriodWarning:
        'Huom: AHVL:n mukaan vuokralaisen irtisanomisaika on yleensä 1 kk ja vuokranantajan 3 kk (yli vuoden sopimuksissa 6 kk). Henkilökunta voi merkitä myös lyhyemmän ajan.',
      terminateLeaseSuccess: 'Irtisanomisilmoitus tallennettu',
      terminateLeaseFailed: 'Irtisanomisilmoituksen tallennus epäonnistui',
      noticeMessage: 'Viesti',
      noticeDepositReturnIban: 'Tilinumero (IBAN)',
      noticeDepositReturnAmount: 'Palautettava vakuussumma',
      noticeDepositReturnHint:
        'Anna tilinumero ja vakuussumma, jonka vuokranantaja palauttaa tilillesi irtisanomisen jälkeen.',
      leavingPartyPending: '{{name}} irtisanonut osuutensa',
      leavingPartyInactive: '{{name}} (lähtenyt)',
      partyNoticeEndsOn: 'Oman osuuden päättymispäivä',
      partyNoticePending: 'Osuus irtisanottu',
      startLookingForTenant: 'Aloita uuden vuokralaisen etsintä',
      relistingRequestedHint: 'Luonnosilmoitus on luotu välittäjälle. Saat päivityksiä prosessin edetessä.',
      relistingRequestedSuccess: 'Luonnos luotu välittäjälle',
      relistingRequestedFailed: 'Uuden vuokralaisen etsinnän aloitus epäonnistui',
    },
    residentPortal: {
      leasesTitle: 'Vuokrasopimukset',
      noLeases: 'Ei vuokrasopimuksia.',
      invoicesTitle: 'Laskut',
      noInvoices: 'Ei laskuja.',
      emailTitle: 'Kirjaudu asukasportaaliin',
      emailSubtitle: 'Syötä sähköpostiosoitteesi. Saat sähköpostiisi kertakirjautumislinkin.',
      emailLabel: 'Sähköposti',
      emailPlaceholder: 'nimi@example.com',
      emailRequired: 'Sähköposti on pakollinen',
      emailInvalid: 'Virheellinen sähköpostiosoite',
      continue: 'Jatka',
      submitting: 'Lähetetään...',
      checkEmailTitle: 'Tarkista sähköpostisi',
      checkEmailDescription:
        'Jos sähköpostiosoitteesi on rekisteröity, saat kirjautumislinkin. Linkki on voimassa 15 minuuttia.',
      useDifferentEmail: 'Käytä eri sähköpostia',
      verifyingTitle: 'Kirjaudutaan...',
      verifyingDescription: 'Vahvistetaan kirjautumislinkki...',
      verifyErrorTitle: 'Kirjautuminen epäonnistui',
      verifyErrorDescription: 'Linkki on vanhentunut tai sitä on jo käytetty.',
      requestNewLink: 'Pyydä uusi linkki',
      title: 'Asukasportaali',
      portalTitle: 'Asukasportaali',
      sessionExpired: 'Istunto on vanhentunut. Kirjaudu uudelleen.',
      loadFailedTitle: 'Portaalia ei voitu ladata',
      loadFailedDescription: 'Tarkista yhteys ja yritä uudelleen.',
      retryLoad: 'Yritä uudelleen',
      serviceRequests: 'Palvelupyynnöt',
      noServiceRequests: 'Ei palvelupyyntöjä.',
      requestForAddress: 'Palvelupyyntö osoitteeseen',
      apartment: 'Asunto',
      selectApartment: 'Valitse asunto...',
      noMessages: 'Ei vielä viestejä.',
      messageError: 'Viestin lähetys epäonnistui.',
      address: 'Osoite',
      createError: 'Palvelupyynnön luominen epäonnistui.',
      keysSectionTitle: 'Avaimet',
      noKeys: 'Sinulla ei ole yhtään avainta.',
      filesSectionTitle: 'Asunnon ja taloyhtiön tiedostot',
      noFiles: 'Ei näytettäviä tiedostoja.',
      measurementsSectionTitle: 'Mittaukset',
      noMeasurements: 'Ei mittauksia vielä.',
      upkeepsSectionTitle: 'Kunnossapito',
      noUpkeeps: 'Ei kunnossapitoa tälle asunnolle.',
    },
    landlordPortal: {
      emailTitle: 'Kirjaudu vuokranantajaportaaliin',
      emailSubtitle: 'Syötä sähköpostiosoitteesi. Saat sähköpostiisi kertakirjautumislinkin.',
      checkEmailTitle: 'Tarkista sähköpostisi',
      checkEmailDescription:
        'Jos sähköpostiosoitteesi on rekisteröity vuokranantajana, saat kirjautumislinkin. Linkki on voimassa 15 minuuttia.',
      useDifferentEmail: 'Käytä eri sähköpostia',
      verifyingTitle: 'Kirjaudutaan...',
      verifyingDescription: 'Vahvistetaan kirjautumislinkki...',
      verifyErrorTitle: 'Kirjautuminen epäonnistui',
      verifyErrorDescription: 'Linkki on vanhentunut tai sitä on jo käytetty.',
      sessionExpired: 'Istunto on vanhentunut. Kirjaudu uudelleen.',
      loadFailedTitle: 'Portaalia ei voitu ladata',
      loadFailedDescription: 'Tarkista yhteys ja yritä uudelleen.',
      retryLoad: 'Yritä uudelleen',
      requestNewLink: 'Pyydä uusi linkki',
      notLandlordTitle: 'Sinulla ei ole vuokranantajan oikeuksia',
      notLandlord:
        'Olet kirjautunut vuokranantajaportaaliin, mutta käyttäjälläsi ei ole vuokranantajan kohteita tässä palvelussa. Jos olet asukas, avaa asukasportaali. Jos uskot tämän olevan virhe, pyydä uusi linkki.',
      openResidentPortal: 'Avaa asukasportaali',
      portalTitle: 'Vuokranantajan portaali',
      title: 'Vuokranantajan portaali',
      residents: 'Asukkaat',
      residentsComingSoon: 'Asukastietojen tarkempi näkymä tulee pian.',
      leasesTitle: 'Vuokrasopimukset',
      noLeases: 'Ei vuokrasopimuksia tälle asunnolle.',
      invoicesTitle: 'Laskut',
      noInvoices: 'Ei laskuja tälle asunnolle.',
      keys: 'Avaimet',
      files: 'Tiedostot',
      noFiles: 'Ei näytettäviä tiedostoja.',
      upkeepsSectionTitle: 'Kunnossapito',
      noUpkeeps: 'Ei kunnossapitoa tälle asunnolle.',
      measurements: 'Mittaukset',
      noMeasurements: 'Ei mittauksia vielä.',
      keyEmailHeader: 'Sähköposti',
      keyPhoneHeader: 'Puhelin',
      keyStampHeader: 'Leima',
      keyHolderHeader: 'Kenelle annettu',
      keyTypeHeader: 'Tyyppi',
      keyDueDateHeader: 'Eräpäivä',
      keyHistoryDate: 'Päivämäärä',
      keyHistoryEvent: 'Tapahtuma',
      keyHistoryHolder: 'Kenelle',
      inspectionHistoryDate: 'Päivämäärä',
      inspectionHistoryResult: 'Tulos',
      inspectionHistoryObservation: 'Huomiot',
      inspectionHistorySuccessful: 'Hyväksytty',
      inspectionHistoryFailed: 'Hylätty',
      allApartmentsOption: 'Kaikki asunnot',
      pendingApplicantsElsewhere: 'Muilla asunnoilla on hakijoita odottamassa tarkistusta',
      goToApartment: 'Siirry asuntoon',
      pendingApplicantsCount: '{{count}} odottaa',
      noKeysForApartment: 'Tälle asunnolle ei ole vielä avaimia.',
      addKey: 'Lisää avain',
      cannotDeleteKeyGiven: 'Lainassa olevaa avainta ei voi poistaa.',
      upkeepDateShort: 'Pvm',
      inspectionNotesShort: 'Huom.',
    },
    portalTabs: {
      overview: 'Yhteenveto',
      maintenance: 'Ylläpito',
      brokerage: 'Vuokraus',
      keys: 'Avaimet',
      files: 'Tiedostot',
      properties: 'Kohteet',
      chat: 'Viestit',
      selectApartment: 'Valitse asunto nähdäksesi tiedot.',
      emptyOverview: 'Ei yhteenvetotietoja tälle asunnolle.',
      emptyKeys: 'Ei avaimia tälle asunnolle.',
      emptyFiles: 'Ei tiedostoja tälle asunnolle.',
      emptyMaintenance: 'Ei ylläpitotietoja.',
    },
    portal: {
      superIntendentLabel: 'Hallinnoija',
      signedInAs: 'Kirjautuneena',
    },
    tenantChat: {
      messagesTitle: 'Viestit',
      selectPartner: 'Valitse keskustelukumppani',
      searchPartners: 'Hae keskustelua tai henkilöä',
      backToConversations: 'Keskustelut',
      unreadConversations: '{{count}} lukematonta keskustelua',
      partnerHasConversation: 'Keskustelu aloitettu',
      newMessages: 'Uudet viestit',
      partnerSectionWithMessages: 'Viestit',
      partnerSectionOther: 'Muut',
      title: 'Asuntokeskustelu vuokralaisen kanssa',
      tenantLabel: 'Vuokralainen',
      landlordLabel: 'Vuokranantaja',
      staffLabel: 'Käyttäjä',
      noRecipientForChat: 'Ei löytynyt ketään, jolle lähettää viestejä',
      noMessages: 'Ei vielä viestejä.',
      error: 'Viestin lähetys epäonnistui. Yritä uudelleen.',
      startConversationError: 'Keskustelun aloitus epäonnistui. Yritä uudelleen.',
    },
    serviceRequestMessages: {
      messagePlaceholder: 'Kirjoita viestisi tähän...',
      send: 'Lähetä',
      visibleToRequester: 'Näkyy pyytäjälle',
      you: 'Sinä',
      internalOnly: 'Vain sisäinen',
      noMessages: 'Ei vielä viestejä.',
      addAttachment: 'Lisää liite',
      removeAttachment: 'Poista liite',
      tooManyAttachments: 'Viestiin voi liittää enintään {{count}} tiedostoa.',
      attachmentInvalid: 'Tiedostotyyppi tai koko ei ole sallittu.',
      attachmentHint: 'Voit liittää enintään {{count}} tiedostoa, enintään {{mb}} Mt / tiedosto.',
      delete: 'Poista',
      deleteTitle: 'Poista viesti',
      deleteConfirm: 'Haluatko poistaa tämän viestin? Viesti ja sen liitteet poistetaan pysyvästi kaikilta.',
      deleteFailed: 'Viestin poistaminen epäonnistui.',
    },
    tooltips: {
      tags: {
        entityPicker:
          'Hae tagin nimellä, valitse listasta tai luo uusi tagi. Tagit ovat yrityskohtaisia ja sama nimi päivittyy kaikkialla.',
        archived: 'Arkistoidut tagit eivät näy valitsimessa, mutta säilyvät jo liitettyinä.',
      },
      keys: {
        periodType:
          'Toistaiseksi voimassa oleva avain ei vaadi palautuspäivämäärää. Määräaikainen avain on palautettava valittuna päivänä.',
        canBeReGiven: 'Sallii avaimen haltijan luovuttaa avaimen edelleen toiselle henkilölle ilman erillistä lupaa.',
        mandate: 'Lataa valtuutusasiakirja, jos avain luovutetaan jollekulle muulle kuin avaimenhaltijalle.',
        signature: 'Allekirjoitus vaaditaan avaimen luovutuksen todentamiseen ja vastuun vahvistamiseen.',
        handoverInstructions:
          'Näytetään avainten luovutuksen ja palautuksen yhteydessä. Voit määrittää ohjeet yritys-, laskutus-, taloyhtiö- ja asuntotasolla; alempi taso ylikirjoittaa ylemmän.',
        stamp:
          'Avaimeen painettu fyysinen leima tai koodi. Käytetään yksittäisten avainten tunnistamiseen ja seurantaan.',
        amount:
          'Luo useita avaimia kerralla samoilla ominaisuuksilla. Jokainen avain luodaan omana erillisenä kohteenaan.',
      },
      roles: {
        globalRole:
          'Globaalit roolit ovat kaikkien yritysten käytössä. Yrityskohtaiset roolit ovat vain yhden yrityksen käytössä.',
        permissionCount:
          'Näyttää kuinka monta käyttöoikeutta tähän rooliin on liitetty. Käyttöoikeudet määrittävät, mitä toimintoja roolin omaavat käyttäjät voivat suorittaa.',
        roleSelection: 'Rooli määrittää, mitä toimintoja ja ominaisuuksia käyttäjä voi käyttää järjestelmässä.',
      },
      permissions: {
        name: 'Käyttöoikeudet noudattavat nimeämiskäytäntöä: Toiminto_Kohde (esim. Create_Key, Edit_Apartment).',
      },
      import: {
        delimiter:
          'Erotin on merkki, joka erottaa arvot CSV-tiedostossa. Yleisimmät erottimet ovat pilkku (,) ja puolipiste (;).',
      },
      wizard: {
        lockType: 'Lukkotyyppi määrittää taloyhtiössä käytettävän lukitusjärjestelmän (esim. Abloy, Assa).',
        keyTypes:
          'Yleiset avaimet avaavat yleensä useita lukituksia taloyhtiössä. Asuntokohtaiset avaimet avaavat vain yhden asunnon.',
        superintendent: 'Hallinnoija on asukas, joka vastaa taloyhtiön päivittäisestä hallinnosta ja ylläpidosta.',
      },
      contractor: {
        accessType:
          'Käyttöoikeuden tyyppi määrittää, mihin urakoitsijalla on pääsy: koko taloyhtiöön, tiettyyn asuntoon tai yksittäiseen avaimeen.',
      },
      company: {
        keyAgreement:
          'Avaimien luovutuksen yhteydessä käyttäjille näytettävä sopimusteksti. Käytetään yrityksen käytäntöjen ja vastuiden kertomiseen.',
        contact: 'Näytetään asukas- ja vuokranantajaportaaleissa palvelupyyntöjen yhteydessä aukioloaikojen vieressä.',
      },
      condominium: {
        businessId:
          'Suomalainen Y-tunnus muodossa 1234567-8. Valinnainen, mutta suositeltava virallisille taloyhtiöille.',
        identifier: 'Valitsemasi tunnus. Auttaa hakemisessa ja tunnistamisessa.',
        defaultServiceRequestTeam:
          'Uudet palvelupyynnöt osoitetaan tälle tiimille, jos käyttäjä ei valitse käsittelijää tai tiimiä. Asunnolta luotaessa käytetään taloyhtiön asetusta.',
        defaultUpkeepTeam:
          'Uudet kunnossapidot osoitetaan tälle tiimille, jos käyttäjä ei valitse vastuuhenkilöä tai tiimiä. Asunnolta luotaessa käytetään taloyhtiön asetusta. Jos tiimiä ei ole, voidaan käyttää hallinnoijaa.',
      },
      keyTypes: {
        generalKey:
          'Yleiset avaimet voivat yleensä avata useita lukkoja taloyhtiössä. Poista valinta asuntokohtaisille avaimille, jotka avaavat vain yhden asunnon.',
        warnDuplicates:
          'Ota käyttöön näyttääksesi varoituksia luotaessa avaimia, joilla on sama leima. Hyödyllinen ainutlaatuisten fyysisten avainten seurannassa.',
      },
      apartments: {
        multiple:
          'Luo useita asuntoja peräkkäisillä numeroilla (esim. A1, A2, A3). Kaikki asunnot käyttävät samaa perusosoitetta.',
        identifier: 'Valinnainen tilatunnus. Auttaa hakemisessa ja tunnistamisessa.',
      },
      settings: {
        showMyProperties: 'Näytä taloyhtiöt, joissa olet hallinnoijana tai joihin sinulla on erityisoikeus.',
        showMyKeys: 'Näytä hallussasi olevat avaimet hallintapaneelissa.',
        showBorrowedKeys: 'Näytä kaikki lainassa olevat avaimet.',
        showLateKeys: 'Korosta avaimet, jotka ovat myöhässä palautuksesta.',
        showMissingKeys: 'Korosta avaimet, jotka on merkitty kadonneiksi tai puuttuviksi.',
        showUpkeeps: 'Näytä työpöydällä tulevat ja myöhässä olevat kunnossapidot.',
        showServiceRequests: 'Näytä työpöydällä palvelupyynnöt.',
        showEvents: 'Näytä työpöydällä viimeisimmät tapahtumat (asukkaiden, asuntojen ja taloyhtiöiden muutokset).',
        showFavorites: 'Näytä työpöydällä suosikkisi (taloyhtiöt, asunnot, asukkaat ja avaimet).',
        showBulkDelete:
          'Mahdollistaa usean kohteen valinnan ja massapoiston taulukoissa (asunnot, asukkaat, taloyhtiöt, avaimet).',
        showReadyToTransferKeys:
          'Näytä työpöydällä luovutusvalmiit avaimet (omat yksityiset korit ja yrityksen korit).',
        showCalendar: 'Näytä työpöydällä kalenteri (tarkastukset ja avaimien eräpäivät).',
        showTodoList: 'Näytä työpöydällä henkilökohtainen tehtävälista.',
        showKeyHistoryTasks: 'Näytä työpöydällä luovutustehtävien lista.',
        showRentalLeaseOverview:
          'Näytä työpöydällä vuokrasopimusten tilannekatsaus (tilat, vakuudet ja erääntyneet laskut).',
        showBrokerageAgreements:
          'Näytä työpöydällä välityssopimusten tilannekatsaus (luonnokset, allekirjoitus, aktiiviset ja palkkio lähettämättä).',
      },
    },
    keyHistoryTasks: {
      tabTitle: 'Tehtävät',
      title: 'Luovutustehtävät',
      searchPlaceholder: 'Hae luovutustehtäviä...',
      onlyMine: 'Vain omat',
      showDone: 'Näytä tehdyt',
      task: 'Tehtävä',
      createdAt: 'Luotu',
      event: 'Tapahtuma',
      openEvent: 'Avaa tapahtuma',
      markDone: 'Merkitse tehdyksi',
      markedDone: 'Merkitty tehdyksi',
      reopen: 'Avaa uudelleen',
      empty: 'Ei avoimia luovutustehtäviä.',
      addPlaceholder: 'Kirjoita tehtävä ja paina +',
      sameBatchTitle: 'Merkitäänkö sama tehtävä muillekin avaimille?',
      sameBatchMessage:
        'Samassa luovutuksessa tai palautuksessa on vielä {{count}} avointa tehtävää nimellä "{{title}}". Haluatko merkitä nekin valmiiksi?',
      sameBatchOnlyThis: 'Vain tämä avain',
      sameBatchAll: 'Merkitse kaikki',
      sameBatchCheckFailed: 'Saman erän tehtäviä ei voitu tarkistaa.',
      markDoneFailed: 'Tehtävän merkitseminen epäonnistui.',
    },
    keyHistoryBillableWorks: {
      title: 'Laskutettava lisätyö',
      description: 'Lisää tähän tapahtumaan laskutettavat lisätyöt. Rivit näkyvät laskutuksen esikatselussa.',
      nameLabel: 'Nimi',
      namePlaceholder: 'Esim. Selvitystyö',
      unitPriceLabel: 'Hinta (€)',
      addAction: 'Lisää lisätyö',
      empty: 'Ei laskutettavia lisätöitä.',
      createdAt: 'Lisätty',
      deleteTitle: 'Poistetaanko lisätyö?',
      deleteMessage: 'Lisätyö "{{name}}" poistetaan.',
      createSuccess: 'Lisätyö lisätty.',
      createFailed: 'Lisätyön lisääminen epäonnistui.',
      deleteSuccess: 'Lisätyö poistettu.',
      deleteFailed: 'Lisätyön poistaminen epäonnistui.',
      validation: {
        name: 'Anna lisätyölle nimi.',
        unitPrice: 'Anna kelvollinen hinta (vähintään 0).',
      },
    },
    contractPlaceholders: {
      insert: 'Lisää tietokenttä',
      search: 'Hae kenttiä...',
      noResults: 'Ei tuloksia',
      modeEdit: 'Muokkaa',
      modePreview: 'Esikatselu',
      liveUntilSignHint:
        'Tietokentät täyttyvät automaattisesti esikatselussa ja tulosteessa. Allekirjoitettaessa arvot lukitaan.',
      liveUntilHandoverHint:
        'Tietokentät täyttyvät avaimen luovutuksessa. Yrityksen omat kentät näkyvät esikatselussa heti.',
      groups: {
        company: 'Yritys',
        landlord: 'Vuokranantaja',
        tenant: 'Vuokralainen',
        apartment: 'Asunto',
        rent: 'Vuokra',
        brokerage: 'Välitys',
        key: 'Avain',
        recipient: 'Vastaanottaja',
        handover: 'Luovutus',
      },
      keys: {
        companyName: 'Yrityksen nimi',
        companyEmail: 'Yrityksen sähköposti',
        companyPhone: 'Yrityksen puhelin',
        landlordName: 'Vuokranantajan nimi',
        landlordAddress: 'Vuokranantajan osoite',
        landlordLeaseContact: 'Vuokrasopimusyhteystieto',
        landlordBillingContact: 'Laskutusyhteystieto',
        landlordBlock: 'Vuokranantaja (lohko)',
        tenantName: 'Vuokralaisen nimi',
        tenantPersonalId: 'Vuokralaisen henkilötunnus',
        tenantEmail: 'Vuokralaisen sähköposti',
        tenantPhone: 'Vuokralaisen puhelin',
        tenantsBlock: 'Vuokralaiset (lohko)',
        apartmentAddress: 'Asunnon osoite',
        apartmentRoomComposition: 'Huonejako',
        apartmentSizeM2: 'Pinta-ala',
        rentAmount: 'Vuokra',
        rentWaterFeeAdvance: 'Vesimaksu / hlö',
        rentWaterFeeLine: 'Vesimaksu (rivi)',
        rentTotalWithWater: 'Vuokra + vesi yht.',
        rentDueDay: 'Eräpäivä',
        rentStartsOn: 'Alkamispäivä',
        rentEndsOn: 'Päättymispäivä',
        rentTerm: 'Vuokra-aika',
        rentDeposit: 'Vakuus',
        rentOccupantCount: 'Henkilömäärä',
        leasePlaceAndDate: 'Paikka ja päiväys',
        brokerageTitle: 'Sopimuksen otsikko',
        brokerageFeeType: 'Palkkiotyyppi',
        brokerageFeeAmount: 'Palkkion määrä',
        keyIdentifier: 'Avaimen tunniste',
        keyDescription: 'Avaimen kuvaus',
        recipientName: 'Vastaanottajan nimi',
        recipientEmail: 'Vastaanottajan sähköposti',
        recipientPhone: 'Vastaanottajan puhelin',
        handoverDate: 'Luovutuspäivä',
      },
    },
  },
};
